/* eslint-disable max-len */
export default {
  embark: 'Embark',
  'csmWidget.header1.p1': 'Top schools',
  'csmWidget.header1.p2': 'for every',
  'csmWidget.header1.p3': 'dream career',
  'csmWidget.header1.p4': ' - search now!',
  'csmWidget.text': 'Find schools and careers today!',
  'careerSearchbar.placeholder': 'Search for careers...',
  'searchbar.nothingHere': 'Hmm... no matches found. Try another career?',
  embarkStudentCorp: 'Embark Student Corp.',
  'home.footerCopyrightSymbol': '©',
  'home.footerAllRightsReserved': 'All rights reserved.',
  'home.footerTrademarkText': 'Embark is a trademark of Embark Student Corp.',
  'outage.title': 'We will be back online soon.',
  'outage.message':
    'Our site is currently down for maintenance. Exciting upgrades are coming!',
  register: 'Register',
  continue: 'Continue',
  next: 'Next',
  send: 'Send',
  retry: 'Retry',
  done: 'Done',
  cancel: 'Cancel',
  copy: 'Copy',
  copied: 'Copied!',
  update: 'Update',
  skip: 'Skip',
  and: 'and',
  note: 'Note:',
  his: 'his',
  her: 'her',
  their: 'their',
  on: 'on',
  is: 'is',
  disagree: 'Disagree',
  decline: 'Decline',
  name: 'Name',
  change: 'Change',
  remove: 'Remove',
  noKeep: 'No, keep',
  yesRemove: 'Yes, remove',
  share: 'Share',
  close: 'Close',
  confirmRemove: 'Are you sure you want to remove?',
  'giftDetails.title': 'Gift amount',
  'giftDetails.banner.title': 'How much do you want to gift?',
  'giftDetails.banner.description':
    'Choose the amount you’d like to send. You can gift as little as $25, and up to a maximum of $2,500.',
  'giftDetails.amount.input.label': 'How much would you like to gift?',
  'giftDetails.amount.input.textFieldLabel': 'Custom amount',
  'giftDetails.message.input.label': 'Add a message (optional)',
  'giftDetails.message.input.placeholder':
    'A little something for you. Wishing you success and joy ahead!',
  'giftDetails.about.label': 'Send a gift note',
  'giftDetails.about.description':
    'Let them know you’re thinking about them with a customized message.',
  'giftDetails.options.custom': 'Custom',
  'giftDetails.error.amountEmpty': 'Please select an option to continue.',
  'giftDetails.error.amountUnderMin': 'Enter a minimum of $25.',
  'giftDetails.error.amountOverMax': 'Enter a maximum of $2,500.',
  'giftDetails.error.exceededMaximumCharacter':
    'Gift note must be 1000 characters or less.',
  'giftDetails.error.allFieldsRequired':
    'Please complete all details to continue',
  'giftCompliance.title': 'We need a few details',
  'giftCompliance.banner.title': 'What’s your relationship?',
  'giftCompliance.banner.description':
    'We ask for this information to ensure that we are in compliance with government guidelines for Registered Education Savings Plans (RESPs).',
  'giftCompliance.relationship.heading':
    'What’s your relationship to the child?',
  'giftCompliance.relationship.dropdown.label': 'Relationship',
  'giftCompliance.relationship.dropdown.grandparent': 'Grandparent',
  'giftCompliance.relationship.dropdown.aunt': 'Aunt',
  'giftCompliance.relationship.dropdown.uncle': 'Uncle',
  'giftCompliance.relationship.dropdown.sibling': 'Sibling',
  'giftCompliance.relationship.dropdown.parent': 'Parent',
  'giftCompliance.relationship.dropdown.notRelated': 'Not related',
  'giftCompliance.relationship.dropdown.other': 'Other',
  'giftCompliance.error.noRelationship': 'Please select the relationship',
  'giftOccasion.title': 'Select an occasion',
  'giftOccasion.header': 'Is it a special event?',
  'giftOccasion.header.imgAlt': 'Party Popper',
  'giftOccasion.body':
    "Gifts add to the excitement of any occasion! Choose an event you're celebrating.",
  'giftOccasion.listHeader': 'Gifting occasions',
  'giftOccasion.lunarNewYear.label': 'Lunar New Year',
  'giftOccasion.congratulations.label': 'Congratulations',
  'giftOccasion.birthday.label': 'Birthday',
  'giftOccasion.gift.label': 'Embark gift',
  'giftOccasion.lunarNewYear.imgAlt': 'Red envelope',
  'giftOccasion.congratulations.imgAlt': 'Trophy',
  'giftOccasion.birthday.imgAlt': 'Birthday cake',
  'giftOccasion.gift.imgAlt': 'Gift box',
  'giftOccasion.brithdaygGiftCard.label': 'Happy Birthday',
  'giftOccasion.congratsGiftCard.label': 'Congratulations',
  'giftOccasion.lunarNewYearGiftCard.label': 'Lunar New Year',
  'giftOccasion.brithdaygGiftCard.imgAlt': 'Gift card with birthday cake',
  'giftOccasion.congratsGiftCard.imgAlt': 'Gift card with trophy',
  'giftOccasion.lunarNewYearGiftCard.imgAlt': 'Gift card with red envelope',
  'giftError.title.expired': 'Something’s not right',
  'giftError.description.expired':
    'It appears that the gifting link has expired. Please ask the subscriber to create a new link.',
  facebook: 'Facebook',
  x: 'X',
  whatsApp: 'WhatsApp',
  reddit: 'Reddit',
  linkedIn: 'LinkedIn',
  'img.alt.annulus': 'A ring shape cut in half',
  'img.alt.schoolPin': 'Icon of a graduation cap',
  'img.alt.clippedSquarePattern': 'Small square',
  'img.alt.smallCirclePattern': 'Small circle',
  'img.alt.largeCirclePattern': 'Large circle',
  'img.alt.halfCirclePattern': 'Half circle',
  'img.alt.extraLargeCirclePattern': 'Extra large circle',
  'img.alt.diamondPattern': 'Diamond',
  'img.alt.noSearchOptionsIllustration':
    'Illustration of an antenna receiving no signal',
  'img.alt.professionsSearchIllustration':
    'Illustration of a blue person browsing the internet',
  'img.alt.professionsSearchRocketTelescope':
    'Illustration of a blue person looking through telescope wearing a jetpack',
  'img.alt.emailIcon': 'Email',
  'img.alt.searchIcon': 'Search',
  'img.alt.closeIcon': 'Close',
  'img.alt.arrowBackIcon': 'Back arrow',
  'img.alt.programScholarIcon':
    'Icon of magnifying glass searching through paper',
  'img.alt.sinDrivingLicense': 'SIN Driving License',
  'img.alt.successIcon': 'Success Icon',
  'img.alt.apolloIcon': 'Company icon of Apollo',
  'img.alt.youthfullyIcon': 'Company icon of Youthfully',
  'img.alt.willfulIcon': 'Company icon of Willful',
  'img.alt.borrowellIcon': 'Company icon of Borrowell',
  'img.alt.neoFinancialIcon': 'Company icon of NeoFinancial',
  'img.alt.policyMeIcon': 'Company icon of PolicyMe',
  'img.alt.facebookIcon': 'Company icon of Facebook',
  'img.alt.xIcon': 'Company icon of X',
  'img.alt.whatsAppIcon': 'Company icon of WhatsApp',
  'img.alt.redditIcon': 'Company icon of Reddit',
  'img.alt.linkedInIcon': 'Company icon of LinkedIn',
  'img.alt.specialization': 'Notify',
  'img.alt.btnPlusIcon': 'Plus Icon',
  'img.alt.btnTransferIcon': 'Transfer Icon',
  'img.alt.trendingUpIcon': 'Trending icon',
  'img.alt.iq.yellowArrow': 'yellow arrow with no tail',
  'img.alt.iq.thumbsUp': 'Thumbs up',
  'img.alt.iq.thumbsDown': 'Thumbs Down',
  'img.alt.giftLinkError': 'Link error',
  'img.alt.giftCircle': 'Small present box',
  'img.alt.shieldIcon': 'Shield',
  'img.alt.embarkGift': 'Embark Gifting',
  'gifting.about.headerOne': 'You’ve been invited to gift to',
  'gifting.about.headerTwo': 'RESP',
  'gifting.about.bodyOne': 'Your gift to',
  'gifting.about.bodyTwo':
    'RESP will play a crucial role in shaping their future. It will support their educational aspirations, empowering them to achieve their dreams.',
  'gifting.about.button': 'Gift now',
  'gifting.list.header': 'About Embark Gifting',
  'gifting.list.one.header': 'Embark Gifting is safe and secure',
  'gifting.list.one.body':
    'You can securely and conveniently gift using Credit Cards, Apple Pay and Google Pay. Everything is encrypted and safe.',
  'gifting.list.one.bodyTwo':
    'At this time, we can only accept Canadian payments.',
  'gifting.list.two.header': 'Embark RESP gifts keep on giving',
  'gifting.list.two.body':
    'You can give a gift of up to $2,500, which may qualify for an additional 20% in government grants. Your gift is greatly appreciated; however, please note that it is not a donation and does not qualify for tax receipts.',
  'gifting.list.three.header': 'Your relationship',
  'gifting.list.three.body':
    'We need to ask you some questions about your relationship with the gift recipient to comply with government regulations.',
  'gifting.about.terms.body':
    'By sending a gift to an Embark child, you are consenting to the',
  'gifting.about.terms.link': 'Terms and conditions.',
  'gifting.about.terms.alt': 'redirect icon',
  'gifting.review.header': 'Let’s quickly review',
  'gifting.review.name': 'Embark gift recipient:',
  'gifting.review.amount': 'Embark RESP gift total:',
  'gifting.review.processingFee': 'Processing fee:',
  'gifting.review.total': 'Total amount:',
  'gifting.review.message': 'Gift message:',
  'gifting.review.button': 'Pay and send gift',
  'gifting.review.dialog.header': 'Processing fee',
  'gifting.review.dialog.body':
    'The bank that issues the payment card charges a fee to cover the service of handling the transaction. We do our best to keep them as low as possible.',
  'footer.embark': 'Embark.',
  'footer.rightsReserved': 'All rights reserved.',
  'footer.trademarkLine2': 'Embark is a trademark of Embark Student Corp.',
  'networkError.title': "Something's not right. Please try again later.",
  'gifting.success.header': 'Your Embark RESP gift has been sent!',
  'gifting.success.header.lunarNewYear.one': 'Your Embark RESP ',
  'gifting.success.header.lunarNewYear.two': 'lucky red envelope ',
  'gifting.success.header.lunarNewYear.three': 'has been sent!',
  'gifting.success.body':
    'You will receive a receipt in your inbox, and we will notify the Embark customer that your gift is on the way!',
  'gifting.success.button': 'Done',
  'home.footerCopyrightText': 'Embark Student Corp.',
  'home.signIn': 'Sign in',
  'home.signIn.embark': 'Sign in to Embark',
  'home.signUp.note': "Don't have an account? ",
  'home.signUp': 'Sign Up',
  'home.embarkSignin.title': 'What would you like to do today?',
  'home.embarkSignin.title1': 'Sign in to ',
  'home.embarkSignin.title2': ' Embark ',
  'home.embarkSignin.title3': ' Student Plans',
  'home.embarkSignin.label':
    "Access your dashboard, manage contributions or withdraw for your child's education.",
  'home.embarkSignin.note1': 'Embark RESP plans opened in ',
  'home.embarkSignin.note2': 'March 2023 or later.',
  'home.flexFirstSignin.title1': 'Sign in to plans',
  'home.flexFirstSignin.title2': 'formerly managed by',
  'home.flexFirstSignin.title3': 'Knowledge First Financial',
  'home.flexFirstSignin.note1': 'RESP plans that were opened between ',
  'home.flexFirstSignin.note2': '1995 and February 2023.',
  'home.about': 'About',
  'home.privacy': 'Privacy',
  'home.terms': 'Terms',
  'textfield.inputError': 'Input Error.',
  'textfield.passwordVisibility': 'Password Visibility',
  'textfield.showPassword': 'Show Password',
  'textfield.hidePassword': 'Hide Password',
  'textfield.clearInput': 'Clear text',
  'textfield.cancelInput': 'Cancel',
  allRequiredErrorMessage: 'Please enter all details to continue.',
  login: 'Login',
  'login.title':
    'Sign in with your Knowledge First Financial login to get started',
  'login.sessionTimedOut': 'Session timed out',
  'login.resetPassword': 'Reset password',
  'login.invalidAzureUrlParams':
    'A problem occured while verifying your Microsoft account',
  signUp: 'Sign up',
  getStarted: 'Ready to start',
  projectedSavings: 'Projected savings',
  estimateGrowth: 'Estimate growth',
  educationAverageCost: 'Average cost of education',
  'educationAverageCost.description':
    "This value is based on data published by the Employment and Social Development Canada's (ESDC) Canadian Post-Secondary Institution Collection (PIC) database. This information, including tuition fees, is updated by ESDC every year and is subject to change.",
  projectedRateReturn: 'Projected rate of return',
  'onboarding.genderInfo':
    "Please ensure that the gender selected matches the beneficiary's SIN information.",
  'onboarding.title': 'RESP ACCOUNT OPENING',
  'onboardingGateway.headline': 'Before you get started',
  'onboardingGateway.description':
    'Here are some important requirements to get started:',
  'onboardingGateway.requirementsTitle1':
    'Please ensure you have one of the following valid IDs ready:',
  'onboardingGateway.requirementsTitle2': 'You need to be:',
  'onboardingGateway.requirementItem1': 'Driver’s license',
  'onboardingGateway.requirementItem2': 'Passport',
  'onboardingGateway.requirementItem3': 'Permanent resident card',
  'onboardingGateway.requirementItem4': 'A parent or grandparent',
  'onboardingGateway.requirementItem5': '18 years or older',
  'onboardingGateway.checkboxLabel': 'I confirm I have the required SINs',
  'onboardingGateway.estimatedTime': 'Estimated time: 10-15 minutes',
  'onboardingGateway.moreInfo': 'Need more information?',
  'onboardingGateway.withOurTeam': 'with out team.',
  'onboardingGateway.dialogContent':
    'You are joining an Embark Student Plan as a co-subscriber.',
  'onboardingStart.headline': 'Welcome to Embark!',
  'onboardingStart.welcomeText':
    "We're excited you're here and are ready to help you take the first steps towards saving for your child's education!",
  'onboardingStart.requirementsHeader1': 'Information to keep handy',
  'onboardingStart.requirementsHeader2':
    'Quick overview of important information and requirements.',
  'onboardingStart.description':
    "Here's what you'll need to apply. We'll match you with the right plan for your child's future with this information.",
  'onboardingStart.requirement1': 'You need to be:',
  'onboardingStart.requirement2': "You'll need the following:",
  'onboardingStart.requirement3':
    'Device camera access and a valid government issued ID, for real-time identity verification',
  'onboardingStart.requirementItem1': 'A parent or grandparent',
  'onboardingStart.requirementItem2': '18 years or older',
  'onboardingStart.requirementItem3': 'A Canadian resident​',
  'onboardingStart.requirementItem4': 'Social insurance number (SIN)',
  'onboardingStart.requirementItem5':
    'for you and your child, as per CRA requirements',
  'onboardingStart.requirementItem6':
    'Personal information for you and your child',
  'onboardingStart.requirementItem7':
    'If applicable, co-subscriber’s email and legal name',
  'onboardingStart.estimatedTime': 'Estimated time 10-15 minutes.',
  'onboardingStart.startNow': 'Open RESP',
  'onboardingStart.hasSIN': "I confirm I have my SIN and my child's SIN",
  subscriberProfileSetup: "Subscriber's profile setup",
  'onboardingBeneficiaries.headline':
    'How many children are you adding to your Embark plan?',
  'onboardingBeneficiaries.label': "Beneficiary's profile setup",
  'onboardingBeneficiaries.description':
    "You will be able to add additional beneficiaries later, as long as they're all siblings.",
  'onboardingBeneficiaries.dropdownLabel': 'Number of children',
  'onboardingBeneficiaries.dropdownError':
    'Please select the number of children.',
  'onboardingBeneficiarySIN.label': "Child's profile",
  'onboardingBeneficiarySIN.headlinePart1':
    "As required by the Employment and Social Development Canada (ESDC), what's ",
  'onboardingBeneficiarySIN.headlinePart2': '  Social Insurance Number?',
  'onboardingBeneficiarySIN.descriptionPart1': "We're collecting",
  'onboardingBeneficiarySIN.descriptionPart2':
    'SIN to apply for all applicable government grants, on your behalf.',
  'onboardingBeneficiarySIN.info':
    'We collect this information following CRA guidelines. All your data is secure and encrypted.​',
  'onboardingBeneficiarySIN.infoGuide1':
    "Don't have a social insurance number?",
  'onboardingBeneficiarySIN.infoGuide2': "Here's how to get one",
  'onboardingBeneficiarySIN.infoGuideLink':
    'https://www.canada.ca/en/employment-social-development/services/sin/apply.html',
  'onboardingBeneficiarySIN.grantsHeadline':
    'You may be eligible for government grants!',
  'onboardingBeneficiarySIN.grantsDescription':
    'Based on your submitted information, you may qualify for the following federal and provincial government grants.',
  'onboardingBeneficiarySIN.grantsListTitle':
    "Sit back and relax. We'll apply for these grants on your behalf.",
  'onboardingBeneficiarySIN.grantNoteDescription':
    'Each child is eligible for applicable government grants. Government grants can change without notice.',
  'onboardingBeneficiarySIN.descriptionCESG': 'Up to $500 per year per child',
  'onboardingBeneficiarySIN.descriptionACESG': 'Up to $100 per year per child ',
  'onboardingBeneficiarySIN.descriptionCLB':
    'Up to $2000 per lifetime per child',
  'onboardingBeneficiarySIN.descriptionBCTESG':
    'A one-time payment of $1200 per child',
  'onboardingBeneficiarySIN.SINRequiredError':
    "Please enter your child's social insurance number.",
  'onboardingPersonalInfo.headline': 'Tell us about yourself',
  'onboardingPersonalInfo.governmentName':
    'The name on your government-issued ID.',
  'onboardingSIN.alt': 'Notification Icon',
  'onboardingSIN.headline':
    'For tax and grant purposes, we need your SIN to be included in the RESP plan.',
  'onboardingSIN.description':
    'Your SIN is required to register the plan with the CRA for tax purposes and for your child to receive government grants.',
  'onboardingSIN.note':
    'Canadian regulators require us to collect this information as part of our Know-Your-Client (KYC) obligations. Your data is safe and never leaves Embark.',
  'onboardingSIN.noteHeader': "Don't have a social insurance number?",
  'onboardingSIN.link':
    'https://www.canada.ca/en/employment-social-development/services/sin/apply.html',
  'onboardingSIN.howToGetOne': "Here's how to get one",
  'onboardingChildsDetails.headline': 'Who are you saving for?',
  'onboardingChildsDetails.headlineFirst': 'Your first child',
  'onboardingChildsDetails.headlineSecond': 'Your second child',
  'onboardingChildsDetails.headlineThird': 'Your third child',
  'onboardingChildsDetails.headlineFourth': 'Your fourth child',
  'onboardingChildsDetails.relationshipHeadline': "What's your relationship?",
  'onboardingChildRelationship.isCustodialParent':
    'Does the child live with you?',
  'onboardingChildRelationship.custodialParentTrue':
    'Yes, I am the primary caregiver',
  'onboardingChildRelationship.custodialParentFalse':
    'No, I am not the primary caregiver',
  'onboardingChildsDetails.label': "Child's profile",
  'onboardingChildsDetails.nameHelper':
    'The name on their birth certificate or social insurance number.',
  'onboardingChildsDetails.addressHelperText':
    "Address for the beneficiary (if not the same as subscriber's).",
  'onboardingChildsDetails.addressError':
    "Please enter a valid address for the beneficiary (if not the same as subscriber's).",
  'onboardingMaritalStatus.label': 'Marital Status',
  'onboardingMaritalStatus.headline': 'What’s your marital status?',
  'onboardingReviewRESPSection.headline': 'Who’s opening this RESP?',
  'onboardingReviewSINSection.SIN': "What's your social insurance number?",
  'onboardingReviewEmploymentStatus.headline': 'What’s your employment status?',
  'onboardingReviewRelationshipSection.title': 'Relationship',
  'onboardingReviewRelationshipSection.relationship1':
    "What's your relationship to ",
  'onboardingReviewRelationshipSection.relationship2': '?',
  'onboardingReviewRelationshipSection.iconAlt': 'Relationship',
  'maritalStatus.single': 'Single',
  'maritalStatus.married': 'Married',
  'maritalStatus.divorced': 'Divorced',
  'maritalStatus.widowed': 'Widowed',
  'maritalStatus.separated': 'Separated',
  'maritalStatus.domestic': 'Domestic / Common law',
  'onboardingEmploymentStatus.label': 'Employment status',
  'onboardingEmploymentStatus.headline': 'Tell us what you do',
  'onboardingEmploymentStatus.header': "What's your current employment status?",
  'employmentStatus.self-employed': 'Self-employed',
  'employmentStatus.employed': 'Employed (Full-time or part-time)',
  'employmentStatus.unemployed': 'Unemployed',
  'employmentStatus.retired': 'Retired or pensioner',
  'employmentStatus.student': 'Student',
  'onboardingEmploymentStatus.jobTitleLabel': "What's your job title?",
  'onboardingInvestingExperience.label': 'Investing experience',
  'onboardingInvestingExperience.headline':
    'How much experience do you have investing in stocks, bonds, and mutual funds?',
  'investingExperience.lowOption': 'Less than 1 year of investment experience',
  'investingExperience.mediumOption':
    'Between 2 to 5 years of investment experience',
  'investingExperience.highOption':
    'More than 5 years of investment experience',
  'onboardingRiskTolerance.label': 'Risk tolerance',
  'onboardingRiskTolerance.headline': 'How would you rate your risk tolerance?',
  'onboardingRiskTolerance.header': 'Wondering what this is?',
  'onboardingRiskTolerance.description':
    'Risk tolerance is your willingness to take investment decisions by evaluating risk of loss against the prospect of returns received. The higher the risk, the greater the probability of long-term returns.',
  'riskTolerance.lowOption': 'Low',
  'riskTolerance.lowMediumOption': 'Low-Medium',
  'riskTolerance.mediumOption': 'Medium',
  'riskTolerance.mediumHighOption': 'Medium-High',
  'riskTolerance.highOption': 'High',
  'riskTolerance.lowDescription': ' (Want to completely avoid losses)',
  'riskTolerance.lowMediumDescription':
    ' (Comfortable accepting a low to medium level of volatility to seek some degree of growth or income from my investments)',
  'riskTolerance.mediumDescription':
    ' (Willing to accept a moderate level of volatility to ensure I balance my losses with returns)',
  'riskTolerance.mediumHighDescription':
    ' (Comfortable with short and medium term fluctuations in exchange for long-term investment growth)',
  'riskTolerance.highDescription':
    ' (Willing to risk the probability of a loss to maximize my returns)',
  'riskCapacity.lowOption': 'Low',
  'riskCapacity.lowMediumOption': 'Low-Medium',
  'riskCapacity.mediumOption': 'Medium',
  'riskCapacity.mediumHighOption': 'Medium-High',
  'riskCapacity.highOption': 'High',
  'riskCapacity.lowDescription':
    ' (Capable of withstanding a low level of volatility within my investments and seeking lower returns for the greater safety of my capital)',
  'riskCapacity.lowMediumDescription':
    ' (Capable of accepting a low to medium level of volatility within my investments and seeking lower returns over a longer period)',
  'riskCapacity.mediumDescription':
    ' (Capable of accepting a moderate level of volatility within my investments and seeking a moderate level of growth over a longer period)',
  'riskCapacity.mediumHighDescription':
    ' (Capable of accepting a medium to high level of volatility within my investments and seeking a higher level of growth over a longer period)',
  'riskCapacity.highDescription':
    ' (Capable of accepting a high degree of volatility and significant short-term fluctuations in portfolio value in exchange for potentially higher long-term returns)',
  'onboardingRiskCapacity.label': 'Risk capacity',
  'onboardingRiskCapacity.headline': "What's your risk capacity?",
  'onboardingRiskCapacity.header': 'Wondering what this is?',
  'onboardingRiskCapacity.description':
    'Risk capacity is your financial capability to take risks, based on factors like your financial situation, income, age and the time you have to achieve your savings goals.\n   The higher the risk, the greater the probability of long-term returns.',
  'onboardingHouseholdNetWorth.label1': 'Total assets',
  'onboardingHouseholdNetWorth.label2': 'Total liabilities',
  'onboardingHouseholdNetWorth.headline1':
    'What are your estimated total assets and liabilities?',
  'onboardingHouseholdNetWorth.header1':
    'What are your estimated total assets?',
  'onboardingHouseholdNetWorth.description1':
    'The total value of the securities and funds in your accounts (chequing, savings, retirement, trading) and your real estate.',
  'onboardingAnnualIncome.error': 'Please enter your gross income.',
  'onboardingHouseholdNetWorth.error1': 'Please enter your total assets.',
  'onboardingHouseholdNetWorth.header2':
    'What are your estimated total liabilities?',
  'onboardingHouseholdNetWorth.description2':
    'The total debts you have, including personal loans, credit cards, student loans, unpaid taxes, and mortgages.',
  'onboardingHouseholdNetWorth.error2': 'Please enter your total liabilities.',
  'onboardingHouseholdNetWorth.tooltip1': 'Lorem ipsum dolor sit amet',
  'onboardingHouseholdNetWorth.headline2':
    'How much of the above net worth can be converted into cash? ',
  'onboardingHouseholdNetWorth.tooltip2': 'Lorem ipsum dolor sit amet',
  'onboardingAnnualIncome.label': 'Annual income',
  'onboardingAnnualIncome.headline': 'What’s your estimated gross income?',
  'onboardingAnnualIncome.tooltip': 'Lorem ipsum dolor sit amet',
  'onboardingAnnualIncome.description':
    'Your gross (pre-tax) income. For example, your annual salary.',
  'login.footNote': 'Don’t have a Knowledge First Financial digital account? ',
  'login.createAnAccount': 'Create an account.',
  confirmEmail: 'Confirm email',
  emailsDoNotMatch: 'Please ensure both email addresses are the same.',
  pleaseEnterEmail: 'Please enter an email address.',
  invalidEmail: 'Invalid email address.',
  invalidEmail1: 'Please enter a valid email.',
  invalidEmailLength: 'Please enter 40 characters or less.',
  pleaseEnterPassword: 'Please enter a password.',
  passwordStrengthError:
    'Password must be between 8 to 24 characters long containing at least two numeric characters.',
  emailAddress: 'Email address',
  password: 'Password',
  address: 'Address',
  age: 'Age',
  ageRequiredError: 'Please enter an age.',
  enterTheAddress: 'Enter the address',
  legalName: 'Legal name',
  legalFirstName: 'Legal first name',
  legalMiddleName: 'Legal middle name',
  'legalMiddleName.placeholder': 'Optional',
  firstName: 'First name',
  middleName: 'Middle name',
  firstNameRequiredError: 'The name on your government-issued ID.',
  invalidFirstName: 'Invalid first name.',
  invalidName: 'Invalid name.',
  invalidMiddleName: 'Invalid middle name.',
  legalLastName: 'Legal last name',
  lastName: 'Last name',
  lastNameRequiredError: 'The name on your government-issued ID.',
  invalidLastName: 'Invalid last name.',
  invalidNameLength: 'Please enter 20 characters or less.',
  invalidMiddleNameLength: 'Please enter 15 characters or less.',
  jobTitle: 'Job title',
  jobTitleError: 'Please enter your job title.',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  notProvided: 'Not provided',
  phone: 'Phone',
  phoneNumberRequiredError: 'Please enter your mobile number.',
  phoneNumberFormatError: 'Please enter a valid mobile number.',
  SINRequiredError: 'Please enter a social insurance number.',
  SINOwnerRequiredError: 'Please enter your social insurance number.',
  SINFormatError: 'Please enter a valid SIN.',
  SINDuplicatedError:
    "Please enter your child's social insurance number. This SIN is already on file.",
  SIN: 'Social insurance number',
  'education.partTimeOption': 'Part-time',
  'education.fullTimeOption': 'Full-time',
  phoneCall: 'Phone call',
  'onboardingPersonalInfo.MobileNumberHeader': 'Mobile number',
  mobileNumber: 'Mobile number',
  'mobileNumber.message':
    'For security purposes, we’ll use this number to verify your identity during sign-in.',
  phoneNumber: 'Phone number',
  dateOfBirth: 'Date of birth',
  'dateOfBirth.dayLabel': 'Day',
  'dateOfBirth.monthLabel': 'Month',
  'dateOfBirth.yearLabel': 'Year',
  'dateOfBirth.dayError': 'Enter a day.',
  'dateOfBirth.monthError': 'Enter a month.',
  'dateOfBirth.yearError': 'Enter a year.',
  'dateOfBirth.enteredBirthdatePrimary': 'Your birthday is: ',
  'dateOfBirth.enteredBirthdateBene': 'Their birthday is: ',
  dateOfBirthRequiredError: 'Please enter your date of birth.',
  dateOfBeneBirthRequiredError: 'Please enter their date of birth.',
  dateFormatError: 'Invalid date.',
  invalidBirthDateError: 'Please enter a valid birth date.',
  ageUnderError: 'To open an RESP, subscribers must be 18 years or older.',
  invalidDate: 'Please enter a valid date of birth.',
  beneficiaryAgeError:
    'To open an RESP for a beneficiary, they must be under the age of 21.',
  birthYearFormatError: 'Enter a year.',
  additionalInformation: 'Additional Information',
  okay: 'Okay',
  ok: 'Ok',
  confirm: 'Confirm',
  confirmPassword: 'Confirm password',
  confirmPasswordMismatchError: 'Passwords do not match.',
  'signUp.title': 'Create a digital account',
  'signUp.description':
    'We’ll need some information to look up your existing account with Knowledge First Financial.',
  'signUp.footnote1':
    'Already have a Knowledge First Financial digital account? ',
  'signUp.footnoteAction': 'Sign in',
  'signUp.footnote2': ' here.',
  'unsavedChangesConfirmationDialog.title': 'Are you sure you want to leave?',
  'unsavedChangesConfirmationDialog.description':
    'You will lose any unsaved changes.',
  'unsavedChangesConfirmationDialog.confirmLabel': 'No, stay',
  'unsavedChangesConfirmationDialog.cancelLabel': 'Yes, leave',
  'leavingConfirmationDialog.title': 'Leaving so soon?',
  'leavingConfirmationDialog.description':
    'If you leave now your information will be lost.',
  'leavingConfirmationDialog.oneTimeContribution':
    'You will lose all progress with your one-time contribution.',
  alberta: 'Alberta',
  britishColumbia: 'British Columbia',
  manitoba: 'Manitoba',
  novaScotia: 'Nova Scotia',
  newBrunswick: 'New Brunswick',
  newfoundlandAndLabrador: 'Newfoundland and Labrador',
  ontario: 'Ontario',
  princeEdwardIsland: 'Prince Edward Island',
  quebec: 'Quebec',
  saskatchewan: 'Saskatchewan',
  northwestTerritories: 'Northwest Territories',
  yukon: 'Yukon',
  nunavut: 'Nunavut',
  grossIncomeRequiredError: 'Please enter your gross annual income.',
  step: 'Step',
  of: 'of',
  start: 'Start',
  back: 'Back',
  low: 'Low',
  lowMedium: 'Low-medium',
  medium: 'Medium',
  mediumHigh: 'Medium-high',
  high: 'High',
  lessThan: 'Less than',
  greaterThan: 'Greater than',
  liquidAssets: 'Liquid assets',
  liquidAssetsError: 'Please enter the liquid asset amount.',
  annualIncome: 'Annual income',
  annualIncomeError: 'Please enter the annual income.',
  'personalInfo.numberOfDependents':
    'How many people do you financially support',
  dependentsRequiredError: 'Please select the number of dependents.',
  streetNumberRequiredError: 'Please enter the street number.',
  streetNameRequiredError: 'Please enter the street name.',
  cityRequiredError: 'Please enter the city.',
  provinceRequiredError: 'Please select the province.',
  provinceNotAllowed:
    'Sorry, this plan is currently not available to the residents of Quebec',
  hopeToPartner: 'We hope to partner with you in the future.',
  postalCodeRequiredError: 'Please enter the postal code.',
  postalCodeFormatError: 'Invalid postal code.',
  postalCodeCorrespondError: 'Postal code does not correspond to province.',
  optional: 'Optional',
  streetNumberLabel: 'Street number',
  unitNumberLabel: 'Unit/suite',
  streetNameLabel: 'Street name',
  cityLabel: 'City',
  provinceLabel: 'Province',
  postalCodeLabel: 'Postal code',
  schoolPostalCodeLabel: 'School postal code',
  schoolName: 'School name',
  no: 'No',
  yes: 'Yes',
  'home.logoLinkUnAuthenticatedAlt': 'Home',
  'home.logoLinkAuthenticatedAlt': 'Dashboard',
  'reset.title': 'Password Reset',
  'forgot.description':
    'Enter your email, and we’ll send you instructions on how to reset your password.',
  'forgot.forgotEmail': 'Forgot email?',
  'forgot.sendMeInstructions': 'Send me instructions',
  'forgot.backToSignIn': 'Back to sign-in',
  'reset.description':
    'Passwords must be between 8 and 24 characters long and contain at least two numeric characters.',
  'reset.changeMyPassword': 'Change my password',
  'reset.PleaseEnterMatchingPasswords': 'Please enter matching passwords',
  profile: 'Profile',
  manageAccount: 'Manage account',
  signOut: 'Sign out',
  'dropdown.selectionError': 'Dropdown selection error',
  'select.placeholder': 'Select',
  'select.buttonAriaLabel': 'Open menu',
  'inputStepper.decrementButtonAriaLabel': 'Decrease',
  'inputStepper.incrementButtonAriaLabel': 'Increase',
  addressOptions1: 'Search or ',
  addressOptions2: 'enter address',
  termsOfUse: 'Terms of Use',
  digitalTermsAndConditions: 'Digital Terms & Conditions',
  'digitalTermsAndConditions.link': `${__STUDENT_SERVICES_URL__}/documents/Digital_Terms_and_Conditions_en.pdf`,
  privacyNotice: 'Privacy Notice',
  privacyPolicy: 'Privacy Policy',
  'privacyPolicy.link': `${__STUDENT_SERVICES_URL__}/documents/Embark_Privacy_Policy_en.pdf`,
  'bookAppointmentReason.thirdParty': 'Third party contributor on the plan.',
  'bookAppointmentReason.notPCG':
    'Subscriber is not the primary caregiver or custodial parent.',
  'bookAppointmentReason.notParent':
    'Subscriber is not a parent, grandparent or sibling.',
  'bookAppointmentReason.timeHorizon': 'Response to Time Horizon = No',
  'bookAppointmentReason.investmentObjective':
    'Response to Investment Objective = No',
  'bookAppointmentReason.riskProfile': "Subscriber's Risk Score = Low",
  'bookAppointmentReason.duplicateSubscriber':
    'Subscriber already has a digital account and tried to create a different account.',
  'bookAppointmentReason.noRESP':
    'Subscriber did not complete onboarding after creating digital account. Onboarding must be completed via the assisted flow.',
  'bookAppointmentReason.nonPSEWithdrawal':
    'Customer is requesting non-PSE withdrawal.',
  'bookAppointmentReason.cannotBeCoSub':
    'Customer does not meet the requirements to be a co-subscriber.',
  'bookAppointmentReason.quebecResident': 'Customer is a Québec resident.',
  'bookAppointmentReason.idvAttempts':
    'Customer reached the maximum ID verification attempts.',
  'bookAppointmentReason.passwordReset':
    'Customer needs help resetting their password.',
  'bookAppointmentReason.duplicateAccounts':
    'Multiple duplicate person records found.',
  'bookAppointmentReason.duplicateAccount':
    'Duplicate person record found with an existing digital account.',
  'bookAppointmentReason.duplicateRESP':
    'Duplicate person record found with an existing RESP.',
  reason: 'Reason',
  'selection.requiredError': 'Please select an option.',
  'selection.requiredToContinueError': 'Please select an option to continue.',
  'services.infoMessage':
    'Due to covid precautions, appointments are only available by phone call.',
  information: 'Information',
  'feedbackDialogForm.title': 'Quick check-in',
  'feedbackDialogForm.description': 'How likely are you to recommend Embark?',
  'feedbackDialogForm.textFieldLabel': 'Additional feedback',
  'feedbackDialogSuccess.title': 'Thank you!',
  'feedbackDialogSuccess.description':
    'By making your voice heard, you help us improve Embark.',
  date: 'Date',
  futureDate: 'Future date',
  futureDateError: 'Please choose a future date.',
  now: 'Now',
  service: 'Service',
  meetingMethod: 'Meeting method',
  language: 'Language',
  timeZone: 'Time zone',
  dateAndTime: 'Date and time',
  morning: 'Morning',
  afternoon: 'Afternoon',
  reschedule: 'Reschedule',
  at: 'at',
  'navigation.homeLinkLabel': 'Home',
  'navigation.contributeLinkLabel': 'Contribute',
  'navigation.programMatcherLabel': 'Career & School Matcher',
  'navigation.withdrawalLinkLabel': 'Withdraw',
  'navigation.transactionsLinkLabel': 'Transactions',
  'navigation.messagesLinkLabel': 'Message centre',
  'navigation.inviteLinkLabel': 'Invite',
  'navigation.bankInfoLinkLabel': 'Banking information',
  'navigation.documentsLinkLabel': 'Documents',
  'navigation.onboardingLabel': 'Onboarding',
  'navigation.dashboardLabel': 'Home',
  'navigation.openPlanLabel': 'Open a plan',
  'navigation.rescheduleContributionLabel': 'Reschedule a contribution',
  'navigation.cancelContributionLabel': 'Cancel a contribution',
  'navigation.accountLabel': 'Account',
  'navigation.helpCentreLabel': 'Help Centre',
  'navigation.referLabel': 'Refer a friend',
  'navigation.signInLabel': 'Sign in',
  'navigation.signOutLabel': 'Sign out',
  'navigation.profileManagementLabel': 'Profile management',
  'navigation.menu': 'Menu',
  'navigation.shareFeedback': 'Share feedback',
  'navigation.educationServices': 'Education services',
  'navigation.costOfSchool': 'Cost of School',
  'navigation.scholarships': 'Scholarships',
  'navigation.referAFriend': 'Refer a friend',
  'navigation.resps': 'RESP',
  'navigation.openAccount': 'Open an account',
  'navigation.contact': 'Contact',
  'navigation.contactPhoneLabel': '1-800-363-7377',
  'navigation.contactEmailLabel': 'contact@embark.ca',
  'navigation.gift': 'Embark Gifting',
  'sendAGift.dialog.title': 'Create gift link',
  'sendAGift.dialog.header':
    'Open an RESP account to begin creating a gift link.',
  'sendAGift.dialog.body':
    'Once you open an account, you can create your own unique gift link for each child in your RESP.',
  'sendAGift.dialog.openButton': 'Open an RESP',
  'sendAGift.dialog.closeButton': 'Close',
  'makeContribution.contributionDetails': 'Contribution details',
  'contributionCalendarIcon.alt': 'Contribution Calendar',
  'matchesLoading.text': 'Finding matches...',
  'alertDialog.confirmTitle': 'Are you sure you want to leave?',
  'alertDialog.confirmMessage': 'You will lose any unsaved changes.',
  'alertDialog.confirmMessageForOnboarding':
    'Your application will not be submitted.',
  'alertDialog.confirmBtnLabel': 'Yes, leave',
  'alertDialog.cancelBtnLabel': 'No, stay',
  'noBankAccount.alert': 'Please add a bank account.',
  frequency: 'Frequency',
  oneTime: 'One-time',
  once: 'Once',
  monthly: 'Monthly',
  biweekly: 'Bi-weekly',
  weekly: 'Weekly',
  yearly: 'Yearly',
  recurring: 'recurring',
  fromThisAccount: 'From this account',
  intoThisAccount: 'Into this account',
  addBankAccount: 'Add bank account',
  starting: 'Starting',
  from: 'From',
  into: 'Into',
  to: 'To',
  account: 'Account',
  withdraw: 'Withdraw',
  transferDate: 'Transfer date',
  confirmation: 'Confirmation',
  confirmationNumber: 'Confirmation number',
  cancellation: 'Cancellation',
  startDate: 'Start date',
  nextDate: 'Upcoming contribution',
  finishDate: 'Finish date',
  endDate: 'End date',
  agreeAndContinue: 'Agree & Continue',
  agreeAndSubmit: 'Agree & Submit',
  monthlyContribution: 'Monthly Contribution',
  'verifyContribution.infoIcon': 'Info Icon',
  'networkError.description':
    'Our system is down, please come back another day.',
  locationError: "Something's not right. Please try again later.",
  'addBankAccountDialog.termsTextPreLink':
    'By choosing to continue, you agree to the',
  'addBankAccountDialog.termsTextLink': 'Terms %26 Conditions',
  'addBankAccountDialog.termsTextPostLink':
    'and authorize the communication of any required financial information with Embark Student Corp.',
  'contribute.title': 'Make a contribution',
  'contribute.clickHere': 'Click here',
  amount: 'Amount',
  amountError: 'Please enter the amount.',
  maxDigitError: 'Please enter 11 digits or less.',
  maxDigitError40: 'Please enter 40 digits or less.',
  'missingBankAccount.noBankHeader': "You don't have any bank accounts set up.",
  'missingBankAccount.noBankDescription':
    "You'll need to add a bank account to contribute funds easily.",
  'missingBankAccount.AddABankAccount': 'Add a bank account',
  'missingBankAccount.noBankAccount': 'No bank account',
  success: 'Success',
  error: 'Error',
  submit: 'Submit',
  edit: 'Edit',
  apply: 'Apply',
  save: 'Save',
  saved: 'Saved',
  customize: 'Customize',
  reset: 'Reset',
  contribute: 'Contribute',
  'choosePlan.label': 'Plan details',
  'choosePlan.headline': 'Select a plan',
  'choosePlan.plans': 'Which plan would you like to contribute to?',
  'choosePlan.planError': 'Please select one plan.',
  'dashboard.interceptDialog.headline': 'RESP ACCOUNT OPENING',
  'dashboard.interceptDialog.title': 'Finish your Embark Plan application',
  'dashboard.interceptDialog.subtitle':
    'Your account is almost ready! Just a few quick questions left.',
  'dashboard.interceptDialog.stage.personal': 'Personal information',
  'dashboard.interceptDialog.stage.idv': 'Identity verification',
  'dashboard.interceptDialog.stage.profile': 'Investment profile',
  'dashboard.interceptDialog.stage.sin': 'SIN information',
  'dashboard.currentPlan': 'Current plans',
  'dashboard.planTransferAlert':
    'We are currently processing your plan transfer following your recent update to your investment risk profile. This procedure may require 45-60 business days days to be fully completed. Your previous plan will be removed from your dashboard once the transfer is finished.',
  'dashboard.newRESP': 'Open a new RESP',
  'dashboard.addBene': 'Save for another child',
  'dashboard.externalTransfer': 'Transfer an RESP',
  'dashboard.financialPlanner': 'Financial Planner',
  'dashboard.addChild': 'Add a child profile',
  'dashboard.addPlanCardTitle': 'Add',
  'dashboard.addPlanCardBody':
    'Embark Student Family Plan or an Embark Student Individual Plan',
  'dashboard.childProfile': 'Child profiles',
  'dashboard.applicationStatusCard.pending.title':
    'Your RESP application is pending',
  'dashboard.applicationStatusCard.pending.description':
    'Resume your application.',
  'dashboard.applicationStatusCard.underReview.title':
    'Your application is pending',
  'dashboard.applicationStatusCard.underReview.description':
    "This may take a few business days. You will receive an email once it's approved.",
  'dashboard.applicationStatusCardCosub.underReview.description':
    'Your joint account application is pending',
  'dashboard.yearsOld': 'yo',
  'dashboard.aspiredToBe': 'Aspired to be',
  'dashboard.noCareer': 'No Career',
  'dashboard.accountSummaryCard.title': 'Embark Student Family Plan',
  'dashboard.accountSummaryCard.newPlanLabel': 'New plan',
  'dashboard.accountSummaryCard.oldPlanLabel': 'This plan will be deactivated.',
  'dashboard.accountSummaryCard.buttonText': 'See details',
  'dashboard.accountSummaryCard.totalSavings': 'Total savings',
  'dashboard.remindCoSubDialog.title':
    'Invite your joint account holder to activate their digital account',
  'dashboard.remindCoSubDialog.whyThisMatters': 'Why this matters:',
  'dashboard.remindCoSubDialog.whyThisMattersBody':
    "For your joint account holder to get full access to Embark, they need to sign up. We'll send them an email to guide them on how to register with us.",
  'dashboard.remindCoSubDialog.whyThisMattersNote1': 'Note: ',
  'dashboard.remindCoSubDialog.whyThisMattersNote2':
    'The joint account holder must be a spouse, or common-law partner.',
  'dashboard.remindCoSubDialog.whatYouNeedToDo': 'What you need to do:',
  'dashboard.remindCoSubDialog.whatYouNeedToDoStep1':
    'Enter their email to send a reminder.',
  'dashboard.remindCoSubDialog.whatYouNeedToDoStep2':
    'They will receive an email with instructions to finish setting up their account.',
  sendReminder: 'Send reminder',
  maybeLater: 'Maybe later',
  'dashboard.addPlan': 'Add a new plan',
  'dashboard.featureCards.title': 'Explore services',
  'dashboard.featureCard.title.costOfSchool': 'Cost of School',
  'dashboard.featureCard.title.scholarship': 'Scholarships',
  'dashboard.featureCard.title.resp': 'RESPs',
  'dashboard.featureCard.title.schoolMatcher': 'Career & School Matcher',
  'dashboard.featureCard.title.gift': 'Embark Gifting',
  'dashboard.featureCard.content.costOfSchool':
    'Calculate and track projected school expenses and savings.',
  'dashboard.featureCard.content.scholarship':
    "Find scholarships that fit your child's aspirations.",
  'dashboard.featureCard.content.resp': 'Find the right plan for your child.',
  'dashboard.featureCard.content.schoolMatcher':
    'Explore career paths that match your child’s skills, interests and values.',
  'dashboard.featureCard.content.gift':
    'Family and friends can now gift money into your child’s RESP.',
  'dashboard.featureCard.button.gift': 'Create gift link',
  'featureCard.newTag': 'New!',
  'dashboard.articleCards.title': 'Picked for you',
  'dashboard.articleCard.title.withdraw': 'Withdrawing From Your RESP',
  'dashboard.articleCard.title.career':
    'How to help your child choose a career?',
  'dashboard.articleCard.title.grants':
    'Maximize your savings with government grants',
  'dashboard.articleCard.content.withdraw':
    'Understand the steps to withdraw funds from your RESP, empowering your financial decision-making.',
  'dashboard.articleCard.content.career':
    "Get valuable insights and strategies as a parent to guide your child's career path for a successful future.",
  'dashboard.articleCard.content.grants':
    'Explore government grants that match your RESP contributions, boosting your future savings.',
  'dashboard.articleCard.imgAlt.withdraw':
    'A person wearing glass standing with arms crossed smiling',
  'dashboard.articleCard.imgAlt.career':
    'A person looking upward with a concerned expression',
  'dashboard.articleCard.imgAlt.grants': 'A teenage girl with a hopeful smile',
  'dashboard.exclusiveOfferCards.title': 'Exclusive offers for you',
  'dashboard.exclusiveOfferCards.title.apollo': 'Apollo',
  'dashboard.exclusiveOfferCards.description.apollo':
    'Exclusive offer for tenant insurance.',
  'dashboard.exclusiveOfferCards.title.youthfully': 'Youthfully',
  'dashboard.exclusiveOfferCards.description.youthfully':
    'Receive 10% off student 1:1 coaching.',
  'dashboard.exclusiveOfferCards.title.willful': 'Willful',
  'dashboard.exclusiveOfferCards.description.willful':
    'Get 20% off your legal will.',
  'dashboard.exclusiveOfferCards.title.borrowell': 'Borrowell',
  'dashboard.exclusiveOfferCards.description.borrowell':
    'Free credit score + more offers.',
  'dashboard.exclusiveOfferCards.title.neoFinancial': 'Neo Financial',
  'dashboard.exclusiveOfferCards.description.neoFinancial':
    'Receive $25 on a Neo approved credit card.',
  'dashboard.exclusiveOfferCards.title.policyMe': 'PolicyMe',
  'dashboard.exclusiveOfferCards.description.policyMe':
    'Get your first two months of life or critical illness insurance free.',
  'dashboard.exclusiveOfferCards.title.shiftCollab': 'Shift Collab',
  'dashboard.exclusiveOfferCards.description.shiftCollab':
    "Therapy so good, you'll actually want to talk. Receive $100 off your first session.",
  'dashboard.exclusiveOfferDialog.cta': 'Continue',
  'dashboard.exclusiveOfferDialog.referralDisclosure1':
    'By clicking on this offer, you agree to the ',
  'dashboard.exclusiveOfferDialog.referralDisclosure2':
    'Referral Disclosure Agreement.',
  'dashboard.exclusiveOfferDialog.apollo.referralDisclosure':
    '/documents/Apollo_Referral_Disclosure_en.pdf',
  'dashboard.exclusiveOfferDialog.apollo.url':
    'https://info.apollocover.com/embark',
  'dashboard.exclusiveOfferDialog.apollo.bodyBoldOne':
    'Get your exclusive offer for tenant insurance in 5 minutes.',
  'dashboard.exclusiveOfferDialog.apollo.bodyOne':
    "Tenant insurance ⎯ also known as renters insurance, condo tenant insurance, or content insurance ⎯ is essential for anyone who rents their living space. Tenant insurance covers your personal property, liability, and additional living expenses if you're forced to temporarily relocate due to a covered event.",
  'dashboard.exclusiveOfferDialog.apollo.bodyTwo':
    'Guaranteed acceptance by property managers and landlords across Canada',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointOne.headline':
    'Comprehensive and Affordable',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointOne.description':
    'We provide the best value for your money, with more standard coverages built into one low price. Pay less for more coverage.',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointTwo.headline':
    'Online Portal, Easy to Use',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointTwo.description':
    'Our platform is designed to be the fastest and simplest way to buy insurance. Purchase and bind in less than a minute and we’ll send your documents right to your inbox.',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointThree.headline':
    '5-Star Customer Rating ',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointThree.description':
    'Customer service is our priority. We earn our clients’ trust by providing the best products backed by world class service and support.',
  'dashboard.exclusiveOfferDialog.youthfully.referralDisclosure':
    '/documents/Youthfully_Referral_Disclosure_en.pdf',
  'dashboard.exclusiveOfferDialog.youthfully.url':
    'https://www.youthfully.com/embark?via=embark',
  'dashboard.exclusiveOfferDialog.youthfully.bodyBoldOne':
    'Receive 10% off Youthfully services',
  'dashboard.exclusiveOfferDialog.youthfully.bodyOne':
    "Youthfully is Canada's go-to destination for 1:1 student coaching, offering refreshingly personalized support by a top-rated, expert coach to assist with:",
  'dashboard.exclusiveOfferDialog.youthfully.bodyTwo.one': '',
  'dashboard.exclusiveOfferDialog.youthfully.bodyTwo.maclean': 'Maclean’s',
  'dashboard.exclusiveOfferDialog.youthfully.bodyTwo.two':
    ' calls Youthfully the “best application help money can buy,” and the Globe and Mail recognizes the program for “its emphasis on teaching soft skills.”',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointOne.description':
    'University admissions essays and interviews',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointTwo.description':
    'Job search and interview preparation',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointThree.description':
    'Clarifying future education and career paths',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointFour.description':
    'Improving foundational academic and learning skills',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointFive.description':
    'Securing scholarships and awards',
  'dashboard.exclusiveOfferDialog.willful.referralDisclosure':
    '/documents/Willful_Referral_Disclosure_en.pdf',
  'dashboard.exclusiveOfferDialog.willful.url': 'https://try.willful.co/embark',
  'dashboard.exclusiveOfferDialog.willful.bodyBoldOne':
    'Get 20% off any Willful plan.',
  'dashboard.exclusiveOfferDialog.willful.bodyOne':
    'Trusted by over 150,000 Canadians, Willful is Canada’s leading online estate planning platform. Created with lawyers in each province, Willful’s user-friendly experience helps you create a legal will and power of attorney documents from the comfort of home.',
  'dashboard.exclusiveOfferDialog.borrowell.referralDisclosure':
    '/documents/Borrowell_Referral_Disclosure_en.pdf',
  'dashboard.exclusiveOfferDialog.borrowell.url':
    'https://borrowell.com/partner/embark/rent-advantage?utm_source=embark&utm_medium=referral&utm_campaign=fcs&utm_content=platform',
  'dashboard.exclusiveOfferDialog.borrowell.bodyBoldOne': 'Rent Advantage',
  'dashboard.exclusiveOfferDialog.borrowell.bodyOne':
    'Report your rent and build your credit history with Borrowell’s Rent Advantage program.',
  'dashboard.exclusiveOfferDialog.borrowell.bodyTwo':
    'Additionally, join over 3 million Canadians and get the tools you need to help understand, manage, and master your credit.',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointOne.description':
    'Build credit so you can access more credit products at better rates.',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointTwo.description':
    "Take on no additional debt. Use rent that you're already paying monthly.",
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointThree.description':
    'Easy setup. No credit checks. No hidden fees. Cancel anytime.',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointFour.headline':
    'Free Credit Score',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointFour.description':
    'Your credit score can have a big impact on your financial future. Sign up for Borrowell to get your credit score and credit report for free!',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointFive.headline':
    'Credit Builder',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointFive.description':
    'Canadians who are aiming to build their credit history to access more credit products like loans, credit cards and mortgages, and at lower interest rates.  Build your credit with Borrowell and achieve your financial goals. No hard credit check when you apply.',
  'dashboard.exclusiveOfferDialog.shiftCollab.referralDisclosure':
    '/documents/Referral_Disclosure_Shift_Collab.pdf',
  'dashboard.exclusiveOfferDialog.shiftCollab.url':
    'https://go.shiftcollab.com/Embark',
  'dashboard.exclusiveOfferDialog.shiftCollab.bodyTitle':
    'Receive $100 off your first therapy session.',
  'dashboard.exclusiveOfferDialog.shiftCollab.bodyOne':
    'Therapy so good, you’ll actually want to talk. Shift Collab helps Canadians build the lives they want—one session at a time. ',
  'dashboard.exclusiveOfferDialog.shiftCollab.bulletPointOne.description':
    'No waitlists',
  'dashboard.exclusiveOfferDialog.shiftCollab.bulletPointTwo.description':
    'Clinician-owned',
  'dashboard.exclusiveOfferDialog.shiftCollab.bulletPointThree.description':
    'Quality virtual mental health therapy',
  'dashboard.exclusiveOfferDialog.shiftCollab.bulletPointFour.description':
    'Covered under most benefits plans',
  'dashboard.exclusiveOfferDialog.shiftCollab.bulletPointFive.description':
    'Open 7 days a week',
  'dashboard.exclusiveOfferDialog.shiftCollab.bodyTwo':
    'At Shift Collab, we have a large and diverse team of 125 therapists. We thoughtfully match each patient with the best therapist to support their needs—with a fit guarantee. ',
  'dashboard.exclusiveOfferDialog.shiftCollab.bodyThree':
    'Whether you’re seeking therapy for yourself, your teen, family therapy, or couples counselling, our expert therapists are here to support you through every chapter of life. Embrace this opportunity to invest in your mental health.',
  'dashboard.exclusiveOfferDialog.neoFinancial.referralDisclosure':
    '/documents/Neofinancial_Referral_Disclosure_en.pdf',
  'dashboard.exclusiveOfferDialog.neoFinancial.url':
    'https://myneo.financial/gh271',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyBoldOne':
    'Receive $25 Exclusive to Embark customers',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyOne':
    'Sign up for a Neo Credit Card and complete one transaction and you will receive $25.',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyTwo':
    'Voted as Canada’s best cash back credit card',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyThree.one':
    'Additionally, Embark customers can take advantage of NeoFinancial’s accounts and tools, including: ',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyThree.two':
    'Neo High Interest Savings account ',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyThree.three': 'and ',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyThree.four':
    'Neo Money account.',
  'dashboard.exclusiveOfferDialog.neoFinancial.bulletPointOne.description':
    'Sign up in 3 minutes and use your virtual card instantly',
  'dashboard.exclusiveOfferDialog.neoFinancial.bulletPointTwo.description':
    'Stay on top of your finances with real-time spend insights.',
  'dashboard.exclusiveOfferDialog.neoFinancial.bulletPointThree.description':
    'Freeze and unfreeze your card anytime from the Neo app',
  'dashboard.exclusiveOfferDialog.policyMe.referralDisclosure':
    '/documents/PolicyMe_Referral_Disclosure.pdf',
  'dashboard.exclusiveOfferDialog.policyMe.url':
    'https://policyme.pxf.io/c/5711270/2138593/15713',
  'dashboard.exclusiveOfferDialog.policyMe.bodyBoldOne':
    'Get your first two months of life or critical illness insurance free.',
  'dashboard.exclusiveOfferDialog.policyMe.bodyOne':
    "Exploring life insurance is key to securing your family's financial future. It provides crucial support by covering debts and maintaining living standards if something happens to you. This type of insurance is especially important for families with dependents, ensuring they’re financially protected.",
  'dashboard.exclusiveOfferDialog.policyMe.bodyTwo':
    'With PolicyMe, parents can trust they’re in good hands with advisors here to help them through the process, by phone or email.',
  'dashboard.exclusiveOfferDialog.policyMe.bodyBoldTwo':
    'Additional PolicyMe Perks',
  'dashboard.exclusiveOfferDialog.policyMe.bulletPointOne.description':
    'Get your online quote in 30 seconds',
  'dashboard.exclusiveOfferDialog.policyMe.bulletPointTwo.description':
    'Apply for insurance online in less than 20 minutes',
  'dashboard.exclusiveOfferDialog.policyMe.bulletPointThree.description':
    'Couples get 10% off in the first year when they apply together',
  'dashboard.exclusiveOfferDialog.policyMe.bulletPointFour.description':
    'Get $10,000 in free Child Coverage with your life insurance policy',
  'dashboard.cosubReminder.title': ' needs to complete registration',
  'childSavingsCalculator.header1': "Ready to see what's possible?",
  'childSavingsCalculator.header2': 'Embark student plan',
  'childSavingsCalculator.subheader':
    'Calculate how much you can save with your Embark Student Plan.',
  'childSavingsCalculator.childAgeSlider.label': "Child's Age",
  'childSavingsCalculator.childAgeSlider.inputLabel': 'Age',
  'childSavingsCalculator.graph.infoHeader': 'Projected savings by ',
  'childSavingsCalculator.graph.infoIconAlt':
    'Information Icon - Click to open dialog.',
  'childSavingsCalculator.graph.dialog.title': 'Projected savings',
  'childSavingsCalculator.graph.dialog.description1':
    'This projection is based on assumptions and is for illustrative purposes only. This is the total projected value of your RESP at the time your child is expected to start their post-secondary education.',
  'childSavingsCalculator.graph.dialog.description2':
    'The projected savings are calculated using a rate of return of 4%',
  'childSavingsCalculator.graph.dialog.description3':
    'The projected value includes contributions and government grants you are expected to accumulate, and the earnings on those contributions and grants. The total market value of your plan may fluctuate daily based on the value of the plan’s investments. Investment returns and the actual future value of your RESP cannot be predicted or guaranteed.',
  'childSavingsCalculator.graph.buttonLabel': 'Start saving',
  'childSavingsCalculator.provinceDropdown.helperText':
    'Government grants may vary based on your residence.',
  'childSavingsCalculator.contributionSlider.label': 'Monthly contribution',
  'childSavingsCalculator.graph.contributions': 'Contributions',
  'childSavingsCalculator.graph.grants': 'Grants',
  'childSavingsCalculator.graph.income': 'Income',
  'childSavingsCalculator.graph.subheading.including': ' including ',
  'childSavingsCalculator.graph.subheading.inGrants': ' in grants',
  'childSavingsCalculatorV2.subtitle': "Let's get saving",
  'childSavingsCalculatorV2.headline': 'Estimate your savings',
  'contributionDetails.label': 'Contribute',
  'contributionDetails.headline': 'Ready to save?',
  'contributionDetails.cardHeadline1': 'Get up to',
  'contributionDetails.cardHeadline2': '$500.00',
  'contributionDetails.cardHeadline3': 'in free government grants',
  'contributionDetails.cardContent':
    'The government matches 20% on your first $2,500 contributed annually. You could earn up to a maximum of $500 in grants, per beneficiary per year, with a lifetime maximum of $7,200.',
  'contributionDetails.amount': 'How much?',
  'contributionDetails.chooseAPlan':
    'From which account would you like to make your contribution?',
  'contributionDetails.frequency': 'How often?',
  'contributionDetails.amountLabel':
    'A minimum contribution of $5.00 is required.',
  'contributionDetails.startDate': 'From which date?',
  'contributionDetails.bankAccount': 'From which account?',
  'contributionDetails.frequencyError':
    'Select the frequency of the contribution.',
  'contributionDetails.beneficiariesAmountError':
    'Please enter an amount for at least one of your beneficiaries.',
  'contributionDetails.noAmountError': 'Please enter a contribution amount.',
  'contributionDetails.minAmountError':
    'A minimum contribution of $5.00 is required.',
  'contributionDetails.maxAmountError':
    'Please enter an amount less than or equal to $50,000.00.',
  'contributionDetails.bankAccountError':
    'Select an account for the contribution.',
  'contributionDetails.startDateError': 'Please set a start date.',
  'contributionDetails.planError': 'Select an RESP recipient.',
  'contributionDetails.fieldsEmptyError':
    'Please enter all details to continue.',
  'verifyContribution.label': 'Verify',
  'verifyContribution.headline': "Let's quickly review",
  'verifyContribution.total': 'Total',
  'verifyContribution.to': 'To',
  'verifyContribution.noteHighlight':
    'All transactions take place on a business day. Any contributions made on holidays and weekends will be processed on the next business day.',
  'verifyContribution.submitBtn': 'Confirm Contribution',
  'contributionSuccess.alt': 'Contribution Success',
  'contributionSuccess.headline': 'Contribution scheduled!',
  'contributionSuccess.headlineOneTime': 'Contribution completed!',
  'contributionSuccess.description1': 'Your',
  'contributionSuccess.description2': 'contribution of',
  'contributionSuccess.description3': 'has been successfully scheduled.',
  'contributionSuccess.description3OneTime': 'has been successfully completed.',
  cancelDescription: 'Change of plans?',
  cancelNextDayOrderDescription: 'Want to cancel this contribution?',
  cancelContribution: 'Cancel contribution.',
  'flinksConsent.title': 'Consent required',
  'flinksConsent.subTitle': 'We need permission to connect with your:',
  'flinksConsent.description1': 'Account transaction history',
  'flinksConsent.description2': 'Account number and balance',
  'flinksConsent.description3a': 'Personal information',
  'flinksConsent.description3b': '(name, email, address, and phone number)',
  'upcomingContributionsList.title': 'Upcoming contributions',
  parent: 'Parent',
  grandparent: 'Grandparent',
  auntUncle: 'Aunt or uncle',
  notRelated: 'Not related',
  publicPrimaryCaregiver: 'Public primary caregiver',
  spouse: 'Spouse or common-law partner',
  child: 'Child',
  stepchild: 'Step-child',
  grandchild: 'Grandchild',
  sibling: 'Sibling',
  other: 'Other',
  coSubscriber: 'Co-subscriber',
  'promoInput.label': 'Enter your advisor or promo code',
  'promoInput.button': 'Apply now',
  'promoInput.success': 'Your promo code has been successfully applied!',
  'promoInput.codeError': 'Please enter a valid code.',
  'onboardingRelationship.headline':
    "Before we begin, what's your relationship to",
  'onboardingRelationship.isCustodialParent': 'Are you the custodial parent?',
  'onboardingDependents.fiveOrMore': '5 or more',
  'onboardingDependents.dropdownLabel': 'Number of dependents',
  'onboardingDependents.description':
    'A dependent can be a child, a relative, or any other individual you financially support.',
  'onboardingDependents.label': 'Dependents',
  'onboardingDependents.headline':
    'How many people do you financially support?',
  'onboardingDependents.dropdownDescription':
    'Please select the number of dependents.',
  'onboardingNonEducationExpenses.label': 'Non-education expenses',
  'onboardingNonEducationExpenses.headline':
    'Do you anticipate a need to withdraw funds from this plan for non-education expenses?',
  'onboardingNonEducationExpenses.note':
    'Knowledge First Financial offers education savings plans designed for long-term savings to put towards the cost of post-secondary education.\n  The Relationship Disclosure Information booklet describes the risks to be considered when making early RESP withdrawals.',
  'onboardingCoApplicant.label': 'Co-applicant',
  'onboardingCoApplicant.title1': "Let's set up your Embark student plan",
  'onboardingCoApplicant.header': "Who's opening this RESP?",
  'onboardingCoApplicant.me': 'Individual - Me',
  'onboardingCoApplicant.joint':
    'Joint - My spouse or common-law partner, and I, as co-subscribers',
  'onboardingCoApplicant.meAndThirdParty':
    'I am opening the account but someone, other than my co-subscriber and I, will be contributing to the RESP',
  'onboardingCoApplicant.coSubscriberHeader': 'Invite a co-subscriber',
  'onboardingCoApplicant.coSubscriber1':
    "We'll invite your co-subscriber by emailing them a secure link, after you submit your RESP application.",
  'onboardingCoApplicant.coSubscriberMessage':
    'For your co-subscriber to successfully pass ID verification, please ensure their full name matches the name on their government-issued id.',
  'onboardingCoApplicant.coSubscriber2': 'This invite expires in 48 hours.',
  'cannotContinue.header': "Sorry, you can't continue digitally",
  'cannotContinue.description1':
    'We need additional information and verification for a third-party contributor.',
  'cannotContinue.description2':
    'Don’t worry, our agents will assist you with your RESP needs. Please call us at 1-800-363-7377 or chat with us online to continue.',
  'cannotContinue.additionalInfoDescription1':
    'We need additional information and verification.',
  'cannotContinue.additionalInfoDescription2':
    'Please call us at 1-800-363-7377 or chat with us online to continue.',
  'cannotContinue.descriptionNoResp':
    'Your RESP application is incomplete. Please call us at 1-800-363-7377 or chat with us online to continue.',
  'cannotContinue.descriptionPreviousResponse':
    "Sorry, based on your previous response, you can't continue digitally",
  'cannotContinue.descriptionRiskProfile':
    "Sorry, based on your risk profile, you can't continue digitally",
  'onboardingGrants.label': 'Government grants',
  'onboardingGrants.headline': "We'll apply for these grants on your behalf",
  'onboardingGrants.weCanApplyFor':
    "We can apply for the following federal and provincial government grants, and we will do all the leg work. So, you can rest easy knowing you're not missing out.",
  'onboardingGrants.grantsListTitle': 'Eligible grants based on your province',
  'onboardingGrants.CESG': 'Canadian Education Savings Grant (CESG)',
  'onboardingGrants.CESG.link':
    'https://www.canada.ca/en/services/benefits/education/education-savings/savings-grant.html',
  'onboardingGrants.ACESG': 'Additional Canada Education Savings Grant (ACESG)',
  'onboardingGrants.ACESG.link':
    'https://www.canada.ca/en/services/benefits/education/education-savings/savings-grant/amount.html',
  'onboardingGrants.CLB': 'Canada Learning Bond (CLB)',
  'onboardingGrants.CLB.link':
    'https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/registered-education-savings-plans-resps/canada-education-savings-programs-cesp/canada-learning-bond.html',
  'onboardingGrants.BCTESG':
    'British Columbia Training and Education Savings Grant (BCTESG)',
  'onboardingGrants.BCTESG.link':
    'https://www2.gov.bc.ca/gov/content/education-training/k-12/support/scholarships/bc-training-and-education-savings-grant',
  'onboardingGrants.QESI': 'Quebec Education Savings Incentive (QESI)',
  'onboardingGrants.QESI.link':
    'https://www.revenuquebec.ca/en/citizens/tax-credits/quebec-education-savings-incentive/',
  'onboardingGrants.descriptionCESG1': 'Each year, the federal government',
  'onboardingGrants.descriptionCESG2':
    'matches 10% of your contributions, up to $2,500',
  'onboardingGrants.descriptionCESG3':
    "and will deposit the money directly into the child's RESP account.",
  'onboardingGrants.descriptionACESG1':
    'A child is eligible for the additional amount of CESG if the adjusted family income level is $93,208 or less,',
  'onboardingGrants.descriptionACESG2':
    'an additional 10% to 20% on the first $500 they contribute in a year.',
  'onboardingGrants.descriptionBCTESG':
    "The BCTESG requires no matching or additional contributions—the B.C. government will contribute\n  $1,200 to eligible children so parents and families who can't afford to put aside savings at this time can still start an RESP.",
  'onboardingGrants.noteDescription':
    'Grants are subject to change without notice.',
  'onboardingBeneficiarySIN.descriptionQESI': 'Up to $250 per year per child',
  'onboardingGrants.grantAmount1':
    'A $2500/year contribution for approximately 15 years =',
  'onboardingGrants.grantAmount2': '$500 x 14.4 years =',
  'onboardingGrants.governmentGrants': 'in government grants',
  'onboardingRiskProfile.alt': 'Risk Profile',
  'onboardingRiskProfile.descriptionHeader':
    'Based on your preferences, your overall risk profile is ',
  'onboardingRiskProfile.reviewTitle': 'Overall risk profile',
  'onboardingRiskProfile.notAvailable': 'Not Available',
  'onboardingRiskProfile.accountSettings':
    'You can update your profile anytime by visiting your account settings.',
  'onboardingRiskProfile.ProfileCalculationError':
    'Something went wrong while calculating risk tolerance.',
  'educationSavings.title': 'Select a plan to view your dashboard',
  'schoolType.universityOption': 'University',
  'schoolType.collegeOption': 'College',
  'schoolType.tradeOption': 'Trade school',
  'schoolType.apprenticeOption': 'Apprenticeship',
  'programType.universityOption': 'University',
  'programType.collegeOption': 'Community College',
  'programType.tradeOption': 'Private trade, vocational or career college',
  'programType.otherOption': 'Other',
  'plan.title': 'Student Individual plan',
  'plan.accountDescription': 'Family plan',
  'plan.type.individual': 'Individual plan',
  'plan.type.family': 'Family plan',
  'plan.type.unknown': 'Plan Account',
  'plan.error.notFound': 'Plan account not found.',
  'accountSummary.message':
    'Set your education target, schedule contributions and maximize your grants.',
  'accountSummary.groupIcon': 'Group Icon',
  resp: 'RESP',
  hi: 'Hi',
  welcomeBack: 'Welcome back, ',
  'profileImage.ariaLabel': 'Upload a photo',
  'imageDrop.title': 'Set a profile picture',
  'imageDrop.dragAndDrop': 'Drag and drop or ',
  'imageDrop.browse': 'Browse',
  'imageDrop.avatarFormat': 'JPEG, PNG or GIF format',
  'imageDrop.avatarSize1': 'Max file size: ',
  'imageDrop.avatarSize2': '2.5MB',
  'imageDrop.dropImage': 'drop image head icon',
  'imageDrop.dropAreaIcon': 'drop area icon',
  'imagePreview.zoomOutPreview': 'Zoom Out Preview',
  'imagePreview.zoomInPreview': 'Zoom In Preview',
  'imagePreview.headline': 'Preview',
  'imagePreview.dragToReposition': 'Drag to reposition',
  'imagePreview.rotate': 'Rotate',
  'imagePreview.description':
    'I agree to upload my child’s image based on the following',
  'imagePreview.termsAndConditions': ' Terms and Conditions.',
  'imagePreview.termsAndConditions.link': `${__STUDENT_SERVICES_URL__}/documents/Upload_Student_Picture_Disclaimer-EN.pdf`,
  'imageUploading.text': 'Uploading...',
  accountBeneProfile: 'My future scholar',
  'studentCard.empty.description':
    'Select a profile picture that reflects their unique personality, and set an education goal that aligns with their dreams.',
  'imageError.fileTooLarge': 'Please upload a valid file size.',
  'imageError.invalidFileType': 'Please upload a valid file type.',
  'imageError.otherImageError': 'Something’s not right. Please try again.',
  'imageChangeConfirm.edit': 'Edit profile picture',
  'imageChangeConfirm.confirmDescription1': '',
  'imageChangeConfirm.confirmDescription2': ' profile picture will be deleted.',
  'imageChangeConfirm.successUpdate': 'Profile picture updated',
  'imageChangeConfirm.successDeleteDescription': 'Photo removed successfully.',
  'imageChangeConfirm.deletingLoading': 'Deleting',
  'refer.piggy.alt': 'Refer Piggy',
  'refer.error.alt': 'Refer Error',
  'refer.error': "Something's not right. Please try again.",
  'refer.title': 'Refer a friend',
  'refer.retry': 'Retry',
  'refer.future': 'Refer more, earn more!',
  'refer.content':
    "Help your friends plan their child's education. Invite them to Embark and you could both earn",
  'refer.terms': '*Terms & Conditions',
  'refer.apply': 'apply.',
  'refer.copyLink': 'Copy link',
  'refer.steps.title': '3 simple steps',
  'refer.step1':
    'Invite your friends to join Embark. Copy your unique referral link or code from above and send it to them.',
  'refer.step2':
    'Have your friends use your unique link or code when opening an Embark RESP.',
  'refer.step3':
    'We credit $100.00 each to the RESP accounts of you and your friends.',
  'refer.termsLink': `${__STUDENT_SERVICES_URL__}/documents/Refer_a_friend_Terms_en.pdf`,
  'accountSummary.grantsCard.description1': "You've received ",
  'accountSummary.grantsCard.description3': ' in government grants!',
  'accountSummary.grantsCard.description4': 'Since ',
  'accountSummary.grantsCard.alt': 'grants',
  'accountSummary.referCard.alt': 'piggy',
  'accountSummary.referCard.referTitle': 'Refer a friend and earn ',
  'accountSummary.referCard.referAmount': '$100.00',
  'accountSummary.referCard.referMessage1':
    'Share this unique code with friends and family: ',
  'accountSummary.referCard.referMessage2':
    '. Or, copy and share the link below.',
  'accountSummary.referCard.referButton': 'Learn more',
  'accountSummary.programMatcherCard.headline.text1': 'Find ',
  'accountSummary.programMatcherCard.headline.text2': 'the best program',
  'accountSummary.programMatcherCard.headline.text3':
    " for your child's career",
  'accountSummary.totalSavings': 'Total savings',
  'accountSummary.savings': 'savings',
  'accountSummary.net': 'Net',
  'accountSummary.earnings': 'Earnings',
  'accountSummary.grants': 'Grants',
  'accountSummary.savingsGrowth': 'Savings growth',
  'accountSummary.recentTransactions': 'Recent transactions',
  'accountSummary.viewHistory': 'View Account History',
  'accountSummary.embarkGlidePath.alt': 'Glide Path',
  'accountSummary.embarkGlidePath.Image':
    'Embark glide path investment advantage image',
  'accountSummary.embarkGlidePath.header':
    "What's the Embark glide path investment advantage?",
  'accountSummary.embarkGlidePath.description.paraOne':
    'Your RESP includes contributions you make over the years, grants from the government and earnings you gain through compound growth on investment of your contributions and grants.',
  'accountSummary.embarkGlidePath.description.paraTwo':
    "Under the glide path approach, the investment mix changes with your child's age. When your child is younger, the emphasis is on growth through equity investing.\n  As your child moves closer to their post-secondary education, we invest more conservatively, with an emphasis on fixed-income securities to preserve your savings.",
  'accountHistory.title': 'Account history',
  'accountHistoryList.datePickerLabel': 'Activity for',
  'accountHistoryList.accountTransactionsListLabel': 'Account transactions',
  'accountHistoryList.loadMoreButtonLabel': 'View more',
  'accountHistoryList.scrollToTopButtonLabel': 'Back to top',
  'accountHistoryList.dateRangeOptions.last-6-months': 'Last 6 months',
  'accountHistoryList.dateRangeOptions.ytd': 'Year to date',
  'accountHistoryList.noTransactions.last-6-months':
    'There are no transactions for the last 6 months',
  'accountHistoryList.noTransactions.ytd':
    'There are no transactions for the year to date',
  'accountHistoryList.noTransactions.part1': 'There are no transactions for',
  'accountPlanActivity.title': 'Plan activity',
  'accountPlanActivity.recentLabel': 'Recent',
  'accountPlanActivity.viewLink': 'View all',
  'programMatcherNotice.headline':
    ' might be attending university next September!',
  'programMatcherNotice.text':
    'Explore the best schools and programs to support their dream career.',
  'accountBeneficiaryProfile.headline': 'My future scholar',
  'accountBeneficiaryProfile.totalCostHeadline': 'Total cost',
  'accountBeneficiaryProfile.totalCostText': 'Projected for',
  'educationGoal.title': 'Education cost',
  'educationGoal.schoolType': 'School type',
  'educationGoal.yearsOfTuition': 'Years of tuition',
  'educationGoal.schoolLocation': 'School location',
  'educationGoal.schoolLocationError': 'Please enter a school location.',
  'educationGoal.tuitionFees': 'Tuition fees',
  'educationGoal.residenceAndMeals': 'Residence and meals',
  'educationGoal.residenceAndMealsDescription':
    'Housing, rentals, utilities, internet, food',
  'educationGoal.booksAndSupplies': 'Books and supplies',
  'educationGoal.booksAndSuppliesDescription':
    'Books, laptop, tools, art supplies, software',
  'educationGoal.personalExpenses': 'Personal expenses',
  'educationGoal.personalExpensesDescription':
    'Entertainment, cellphone, clothing',
  'educationGoal.liveAwayOption': 'Live away',
  'educationGoal.liveHomeOption': 'Live at home',
  'educationGoal.alertText1': 'Important',
  'educationGoal.alertText2':
    "The projected costs have been adjusted for inflation and are intended for illustrative purposes only. Based on 'Statistics Canada' data.",
  'educationGoalSetup.description1': "Let's set an education goal for",
  'educationGoalSetup.description2': 'and estimate the cost of school in',
  'educationGoalCustomize.headline': 'Customize what’s included',
  'educationGoalCustomize.optionsTitle': 'Other costs to consider',
  'educationGoalChart.description1': 'These costs are projected for',
  'educationGoalChart.description2': 'when',
  'educationGoalChart.description3': 'is likely to go to school',
  'educationGoalChart.year': 'year',
  'educationGoalChart.years': 'years',
  'educationGoalChart.universityInnerLabel': 'of University',
  'educationGoalChart.collegeInnerLabel': 'of College',
  'noPlanActivity.description':
    'No plan activity yet. Your contributions, withdrawals and grants will appear here.',
  'noTransactionsMessage.heading':
    'There are currently no existing transactions for this plan',
  'noTransactionsMessage.descriptionPart1':
    'If you have past transactions and believe you have received this message in error, please',
  'noTransactionsMessage.descriptionLinkLabel': 'contact us',
  'noTransactionsMessage.descriptionPart2': 'directly for support.',
  'bankAccountSelect.legend': 'Choose an account',
  'onboardingReview.promoTitle': 'Have a promo code?',
  'onboardingReview.label': 'Application review',
  'onboardingReview.headline': "Let's do a quick review of your application",
  'onboardingReview.SINPartOne': 'What’s',
  'onboardingReview.SINPartTwo': '’s social insurance number?',
  'onboardingReview.cancelBtn': 'Cancel',
  'onboardingReviewRESPSection.title': 'Embark Student Plan',
  'onboardingReviewRESPSection.iconAlt': 'Parent',
  'onboardingReviewSubscriberSection.title': 'Profile',
  'onboardingReviewSubscriberSection.iconAlt': 'Licence',
  'onboardingReviewAccountDetailsSection.title': 'Investment profile',
  'onboardingReviewAccountDetailsSection.iconAlt': 'Document',
  'onboardingReviewBeneficiarySection.title': "Child's profile",
  'onboardingReviewBeneficiarySection.question':
    'How many children are you adding to your new Embark RESP?',
  'onboardingReviewBeneficiarySection.relationshipLabel': 'Relationship',
  'onboardingReviewBeneficiarySection.primaryCaregiverLabel':
    'Are you the primary caregiver?',
  'onboardingReviewBeneficiarySINSection.title': 'Social insurance number',
  'onboardingTandC.description':
    'Please review these terms and conditions. A copy of all agreements will be available for your reference under account settings.',
  'onboardingTandC.submitLabel': 'Submit application',
  'onboardingSuccess.heading': "You're all set!",
  'onboardingSuccess.message1':
    "Let's explore your dashboard, set education goals, and get saving for ",
  'onboardingSuccess.message2': ' education.',
  'onboardingSuccess.contribute': 'Contribute',
  'onboardingSuccess.dashboard': 'Dashboard',
  beneficiary: 'beneficiary',
  'tandC.dialogTitle': 'Are you sure you want to leave?',
  'tandC.dialogContent': 'Your application will not be submitted.',
  'tandC.continueBtnLabel': 'Yes, leave',
  'tandC.cancelBtnLabel': 'No, stay',
  email: 'Email',
  'remindCoSubDialog.email': 'Email',
  'manageAccount.personalInformation': 'Personal information',
  'manageAccount.noLinkedBankAccounts':
    "You don't have any linked bank accounts",
  'manageAccount.linkedBankAccountsError':
    'Something’s not right. Please try again later.',
  'manageAccount.noLinkedBankAccountsImg': 'No bank accounts',
  'manageAccount.linkedBankAccountsErrorImg': 'Bank accounts error',
  'manageAccount.title': 'Account',
  'manageAccount.accountCircle.alt': 'Account Circle Icon',
  'manageAccount.profile': 'Profile',
  'manageAccount.profile.comment': 'Review and update personal information',
  'manageAccount.creditCard.alt': 'Credit Card Icon',
  'manageAccount.linkedBankAccounts': 'Linked bank accounts',
  'manageAccount.linkedBankAccounts.comment': 'View and manage bank accounts',
  'manageAccount.document.alt': 'Documents Icon',
  'manageAccount.addPerson.alt': 'Add Person Icon',
  'manageAccount.Documents': 'Documents',
  'manageAccount.Documents.comment': 'Access statements and tax slips',
  'manageAccount.co-sub': 'Add a joint-account holder',
  'manageAccount.co-sub.alt': 'Add a joint-account holder Icon',
  'manageAccount.co-sub.comment': 'Invite a co-subscriber to your plan',
  'manageAccount.bene': 'Save for another child',
  'manageAccount.bene.alt': 'Save for another child Icon',
  'manageAccount.bene.comment': 'Add a new beneficiary to an RESP',
  'manageAccount.addPlanMembers': 'Add plan members',
  'manageAccount.addAPlan': 'Open a new RESP',
  'manageAccount.addAPlanComment': 'Open a new RESP',
  'manageAccount.addAPlan.alt': 'Open a new RESP',
  'manageAccount.addPlanMembersComment': 'Add a child or co-subscriber',
  'addPlanMembers.label': 'Add plan members',
  'addPlanMembers.memberType.headline':
    'Who would you like to add to your plan?',
  'addPlanMembers.addChildIndividualPlanError':
    'There can only be one child under an Individual plan. To add a child, select a Family plan or book an appointment to open a new plan.',
  'addPlanMembers.cosub.label': 'Add a co-subscriber',
  'addPlanMembers.cosub.headline': 'Send an invite',
  'addPlanMembers.cosub.description1':
    'Invite a spouse or common-law partner to contribute to',
  'addPlanMembers.cosub.description2': 'education.',
  'addPlanMembers.cosub.description3':
    "We'll invite them by emailing a secure link.",
  'addPlanMembers.cosub.description4': 'This invite',
  'addPlanMembers.cosub.description5': 'expires in 48 hours.',
  'addPlanMembers.child.label': 'ADD A BENEFICIARY',
  'addPlanMembers.childReview.headline':
    'Let’s do a quick review of your child’s information',
  'addPlanMembers.childSuccess.headline': 'added to your plan',
  'coApplicant.coSubscriberEmail': "Co-subscriber's email",
  'coApplicant.coSubscriberFirstName': "Co-subscriber's legal first name",
  'coApplicant.coSubscriberLastName': "Co-subscriber's legal last name",
  'coApplicant.coSubLegalFirstName': 'Legal first name',
  'coApplicant.coSubLegalLastName': 'Legal last name',
  'coApplicant.coSubscriberNameInfo': 'The name on their government-issued ID.',
  'coApplicant.coSubscriberFirstNameError': 'Please enter their first name.',
  'coApplicant.coSubscriberLastNameError': 'Please enter their last name.',
  'coApplicant.existingCoSubError':
    'A co-subscriber is already on file. You can add only one co-subscriber to your plan.',
  'coApplicantDialog.title': "You're inviting",
  'coApplicantDialog.description':
    'will be invited to contribute to your Embark student plan.',
  'language.en-US': 'English',
  'language.fr-CA': 'Français',
  'language.en': 'English',
  'language.fr': 'French',
  'language.cn': 'Cantonese',
  'addressFields.title': 'Residential address',
  'withdrawal.title': 'MAKE A WITHDRAWAL',
  'withdrawal.selectBankAccountLegend': 'Into which account?',
  'withdrawal.amountQuestion': 'How much would you like to withdraw?',
  'withdrawal.amountPopupHeader': "Don't worry, your money's safe.",
  'withdrawal.amountPopupDescription':
    'will have access to the rest of the amount after completing 13 weeks of school.\n  As per CRA guidelines, in the first 13 weeks of school, withdrawal of grants and earnings is limited to $5,000 for full-time and $2,500 for the part-time program.',
  'withdrawal.netContributionsAmountPart1': 'available for ',
  'withdrawal.netContributionsAmountPart2': 'withdrawal',
  'withdrawal.noRespAccountFound': "Couldn't find the RESP account.",
  'withdrawal.maxNetAmountErrorPart1':
    'You can only withdraw your net contributions.',
  'withdrawal.maxNetAmountErrorPart2':
    'For withdrawal of income and grants, please submit an EAP request.',
  'withdrawal.confirmationDialogTitle': 'Are you sure you want to go ahead?',
  'withdrawal.confirmationDialogDescriptionPart1': 'might lose',
  'withdrawal.confirmationDialogDescriptionPart2': 'in government grants',
  'withdrawal.confirmationDialogContinue': 'Yes, Continue',
  'withdrawal.beneficiarySelectionQuestion': 'Who will be attending school?',
  'withdrawal.beneficiarySelectionDropdownLabel': 'Student',
  'withdrawalEntry.title': "It's time for school!",
  'withdrawalEntry.body':
    'Congratulations on your child’s post-secondary enrolment. Let’s withdraw your savings for tuition, boarding, books, supplies, transportation, and other essentials.',
  'withdrawalEntry.footerText':
    'Withdrawing for non-educational or personal expenses? ',
  'withdrawalEntry.appointment': 'Book an appointment',
  'withdrawalType.label': 'Withdrawal type',
  'withdrawalType.headline': "Are you withdrawing for your child's education?",
  'withdrawalType.pseAlertMessage':
    'Verification of enrolment (VoE) is required to make this withdrawal.',
  'withdrawalType.nonpseAlertMessage':
    'Non-education withdrawals will lead to loss of government grants.',
  getMoreInformation: 'Get more information',
  'withdrawalSelect.label': 'Plan details',
  'nonPSEWithdrawal.headline': 'How much would you like to withdraw?',
  'nonPSEWithdrawal.note':
    'You can only withdraw your contributions for non-educational purposes.',
  'nonPSEWithdrawal.amountRequiredError':
    'Please enter a valid withdrawal amount.',
  'withdrawalDetails.label': 'Verify',
  'withdrawalDetails.headline': "Let's quickly review",
  'withdrawalDetails.years': 'years',
  'withdrawalDetails.year': 'year',
  'withdrawalDetails.1': 'First',
  'withdrawalDetails.2': 'Second',
  'withdrawalDetails.3': 'Third',
  'withdrawalDetails.4': 'Fourth',
  'withdrawalDetails.5': 'Fifth',
  'withdrawalDetails.6': 'Sixth',
  'withdrawalDetails.7': 'Seventh',
  'withdrawalDetails.8': 'Eighth',
  'withdrawalDetails.9': 'Ninth',
  'withdrawalDetails.note':
    'Withdrawals can take up to 5-7 business days to reflect in your bank account. Any withdrawals made on holidays and weekends will be processed on the next business day.',
  'withdrawalSuccess.headline': 'Withdrawal completed!',
  'withdrawalSuccess.message1':
    'You have successfully requested the withdrawal of',
  'withdrawalSuccess.needToApplyEAP': 'Neet to apply for an EAP? ',
  'withdrawalSuccess.applyNow': 'Apply now',
  'withdrawalSuccess.congratulations': 'Congratulations.',
  'withdrawalSuccess.wayToSchool': 'way to school',
  'PSEWithdrawal.label': 'PSE withdrawal',
  'PSEEnrolmentVerification.label': 'Verification of enrolment',
  'PSEEnrolmentVerification.headline': "Who's going to school?",
  'PSEEnrolmentVerification.schoolLegend1': 'School details',
  'PSEEnrolmentVerification.schoolLegend2': 'be attending?',
  'PSEEnrolmentVerification.schoolLegend3': 'the beneficiary',
  'PSEEnrolmentVerification.weeksEnrolledLegend1':
    'For how many consecutive weeks, in the last 12 months, has',
  'PSEEnrolmentVerification.weeksEnrolledLegend2': 'attended school?',
  'PSEEnrolmentVerification.weeksEnrolledLegend3': 'the beneficiary',
  'PSEEnrolmentVerification.beneficiaryRequiredError':
    'Please select a student.',
  'PSEEnrolmentVerification.weeksEnrolledTitle1':
    'How many consecutive weeks in the last 12 months has',
  'PSEEnrolmentVerification.weeksEnrolledTitle2': 'attended school?',
  'PSEEnrolmentVerification.weeksEnrolledLabel': 'Weeks enrolled',
  'PSEEnrolmentVerification.schoolNameError':
    'Please enter the school name on the VoE.',
  'PSEEnrolmentVerification.schoolPostalHelper':
    'The postal code on their VoE.',
  'PSEEnrolmentVerification.schoolPostalRequiredError':
    'Please enter the valid postal code on the VoE.',
  'PSEEnrolmentVerification.programTypeLabel': 'Program type',
  'PSEEnrolmentVerification.programTypeRequiredError':
    'Please enter the program type.',
  'PSEEnrolmentVerification.schoolWeeksEnrolledRequiredError':
    'Please enter the number of weeks enrolled.',
  'PSEEnrolmentVerification.durationLabel': 'Duration (in years)',
  'PSEEnrolmentVerification.durationError': 'Please select the duration.',
  'PSEEnrolmentVerification.programYearLabel': 'Program year',
  'PSEEnrolmentVerification.programYearError':
    'Please select the program year.',
  'PSEEnrolmentVerification.startDateLabel': 'Start date',
  'PSEEnrolmentVerification.startDateError': 'Please select the start date.',
  'PSEEnrolmentVerification.alertError':
    'Please enter all details to continue.',
  'PSEEnrolmentVerification.verificationOfEnrolment':
    'Verification of enrolment (VoE)',
  'PSEEnrolmentVerification.fileUploadDescription':
    'Provide in PDF, PNG, JPG format.',
  'PSEEnrolmentVerification.fileUploadError':
    'Please upload a digital copy of your VoE.',
  'PSEEnrolmentVerification.enrolmentVerificationInfo':
    'The CRA requires verification of enrolment',
  'PSEEnrolmentVerification.enrolmentVerificationHeading': 'All about the VoE.',
  'PSEEnrolmentVerification.enrolmentVerification1':
    "The CRA requires a verification of enrolment (VoE) document for this withdrawal. This can be obtained from the Registrar's office or school's website.",
  'PSEEnrolmentVerification.enrolmentVerification2':
    "We don't accept admissions offers, acceptance letters, email confirmations or password-protected files.",
  'PSEEnrolmentVerification.viewSampleVoE': 'View sample VoE',
  enrolmentType: 'Enrolment type',
  'enrolmentInfo.title': 'Enrolment information',
  student: 'Student',
  educationalInstitution: 'Educational institution',
  programType: 'Program type',
  programYear: 'Program year',
  programLength: 'Program length',
  weeksEnrolled: 'Weeks enrolled',
  voeFile: 'VOE file',
  upcoming: 'Upcoming',
  'scheduledContributionsList.calendar.alt': 'Calendar Icon',
  'scheduledContributions.title': 'Scheduled contributions',
  'noScheduledContributions.viewAll': 'View all',
  'noScheduledContributions.description1': 'No scheduled contributions yet. ',
  'noScheduledContributions.description2':
    'Schedule your first contribution now.',
  'scheduledContributionsDetails.title': 'Contribution schedule',
  'scheduledContributionsDetailsList.dateLabel': 'Upcoming payment',
  'scheduledContributionsDetailsList.cancelDescriptionPart1':
    'Please cancel before 9 p.m. EST, on',
  'scheduledContributionsDetailsList.cancelDescriptionPart2':
    ', to ensure your payment is not processed.',
  'scheduledContributionsDetailsList.cancelButton': 'Cancel contribution',
  'scheduledContributionsDetailsList.cancelButtonLabel': 'Yes, cancel',
  'scheduledContributionsDetailsList.confirmationDialogTitle':
    'Are you sure you want to cancel?',
  'scheduledContributionsDetailsList.confirmationDialogContent1':
    'Cancelling your',
  'scheduledContributionsDetailsList.confirmationDialogContent2':
    'scheduled contribution of',
  'scheduledContributionsDetailsList.confirmationDialogContent3':
    'cannot be undone.',
  'scheduledContributionsDetailsList.confirmationDialogCancel': 'No, keep',
  'scheduledContributionsDetailsListError.title': 'An error occurred',
  'scheduledContributionsDetailsListError.message': 'Please try again later.',
  'cancelContributionSuccess.alt': 'Cancel Contribution Success',
  'cancelContributionSuccess.headline':
    'We have cancelled your scheduled contribution',
  'coSubOnboardingCannotBeCoSub.cantContinue':
    'Sorry, you can’t be a joint-account holder',
  'coSubOnboardingCannotBeCoSub.header': "Sorry, you can't be a co-subscriber",
  'coSubOnboardingCannotBeCoSub.description1':
    'Joint-account holder should be spouses or common-law partners.',
  'coSubOnboardingCannotBeCoSub.description2':
    'Explore our plans and open your own RESP account today!',
  'coSubOnboardingCannotBeCoSub.openResp': 'Open an RESP',
  'cancelContributionSuccess.message':
    'A confirmation email has been sent to you.',
  'coSubOnboardingPopup.alertDialogPopupMessage':
    'Your application will not be submitted.',
  'withdrawal.PSE.label': 'Educational withdrawal',
  'withdrawal.NONPSE.label': 'Non-educational withdrawal',
  'withdrawalAmount.label': 'Amount',
  'withdrawalAmount.headline': 'How much would you like to withdraw?',
  'withdrawalAmount.error': 'Please enter a valid withdrawal amount.',
  'withdrawalAmount.grantsNote.title': 'Grants and earnings',
  'withdrawalAmount.grantsNote.body':
    'By default, we withdraw from your grants and earnings before contributions.',
  'withdrawalAmount.grantsNote.actionLabel': 'Reallocate',
  'withdrawalAmount.grantsNote.resetLabel': 'Use Default',
  'withdrawalAmount.breakdown.grantsLabel': 'Grants and earnings',
  'withdrawalAmount.breakdown.contributionsLabel': 'Contributions',
  'reAllocationDialog.title': 'Allocate your withdrawal',
  'reAllocationDialog.totalLabel': 'Total withdrawal',
  'vouchedIDV.progressIndicatorLoading': 'Loading',
  'vouchedIDV.crossDeviceTitle': 'ID verification',
  'vouchedIDV.crossDeviceInstructions':
    'Take a photo of your ID and a picture of yourself to instantly verify your identity.',
  'vouchedIDV.qrDesktopInstructions':
    'Mobile handoff options are not supported in Sandbox Mode. Please use your webcam instead. {qrDesktopLink}',
  'vouchedIDV.qrDesktopLink': 'Start webcam',
  'vouchedIDV.upperIdInstructions':
    "Please take a clear photo of a current, non-expired government-issued ID (e.g., driver's license, passport).",
  'vouchedIDV.retryMessageInvalidIdPhoto':
    'Please upload a valid government ID.',
  'vouchedIDV.upperFaceInstructions':
    'Please take a selfie, ensuring your photo is clicked without any glasses, hats, facial obstructions, and any other people in it.',
  'vouchedIDV.lowestFaceInstructions':
    'Photos of other photos are not allowed.',
  'vouchedIDV.cameraFaceLabelShowFace': 'Take a selfie',
  'vouchedIDV.success': "Thanks, you're all done!",
  'vouchedIDV.mobileHandoffDoneMessage':
    'You can now return to your Embark profile setup.',
  'vouchedIDV.stepTitlesFrontId': 'Step 1',
  'vouchedIDV.stepTitlesFace': 'Step 2',
  'idVerificationStart.headline': "Let's verify your identity",
  'idVerificationStart.topDescription':
    "To secure your personal information, we'll verify your identity within the comforts of your home.",
  'idVerificationStart.requirementsTitle': "Here's what you'll need:",
  'idVerificationStart.requirement1': 'Device camera access',
  'idVerificationStart.requirementText1': 'for real-time identity confirmation',
  'idVerificationStart.requirement2': 'A valid government-issued photo ID',
  'idVerificationStart.requirementText2':
    '(e.g., provincial driver’s license, Canadian passport, or PR card)',
  'idVerificationStart.requirement3': 'A selfie',
  'idVerificationStart.requirementText3': 'to compare to your photo ID',
  'idVerificationStart.bottomDescription':
    'Follow the on-screen instructions to complete the process, instantly and securely.',
  'idVerificationSuccess.title': "Great! Let's continue",
  'idVerificationSuccess.message':
    "Now that we've created your personal profile, let's set up your investment profile.",
  'idVerificationFail.title': 'Verification failed',
  'idVerificationFail.message':
    'Sorry, your identity verification was unsuccessful. Please try again.',
  'idVerificationStop.title':
    'Sorry, you have reached the maximum identity verification attempts',
  'idVerificationStop.messageText1': 'Please ',
  'idVerificationStop.messageLink': 'book an appointment',
  'idVerificationStop.messageText2': ' to proceed.',
  'educationTargetInfo.description.text1':
    'This projection is based on assumptions and is for illustrative purposes only. This is the total projected value of your RESP at the time your child is expected to start their post-secondary education.',
  'educationTargetInfo.description.text2':
    'The projected value includes contributions and government grants you are expected to accumulate, and the earnings on those contributions and grants. The total market value of your plan may fluctuate daily based on the value of the plan’s investments. Investment returns and the actual future value of your RESP cannot be predicted or guaranteed.',
  'educationTargetInfo.description.text3':
    'If you have not made any contributions, we assume a $100 per month contribution. This is for example only.',
  'projectedRateReturn.description':
    'All projections are provided for informational purposes only and do not guarantee actual investment results. The rates of return demonstrate the income you could earn in your RESP and are not an indicator or guarantee of future performance.',
  'totalCosts.university': 'University',
  'totalCosts.college': 'College',
  'educationProjection.byYear': 'by',
  'educationProjection.year': 'year',
  'educationProjection.university': 'university',
  'educationProjection.college': 'college',
  'educationProjection.of.college': 'of ',
  'educationProjection.of.university': 'of ',
  'educationProject.glidePathTitle': 'Your RESP Savings',
  'educationProjection.contribute': 'Contribute',
  'educationProjection.yourEducation': 'of your education target',
  'educationProjection.contributionButton': 'Schedule contribution',
  'educationProjection.primaryRoR': '1-4% RoR',
  'educationProjection.secondaryRoR': '1-8% RoR',
  'estimatedGrowth.headline': 'Grow your RESP savings',
  'estimatedGrowth.description':
    'Find out how much more you can save by making additional contributions. Play around with different amounts and watch your potential savings grow.',
  'estimatedGrowth.cost.title': 'Average cost of education',
  'estimatedGrowth.cost.description1': 'Tuition',
  'estimatedGrowth.cost.description2': 'Tuition and residence',
  'projectionChart.dataLabel1': 'Contributions',
  'projectionChart.dataLabel2': 'Grants',
  'projectionChart.dataLabel3': 'Investment income',
  'projectionChart.totalLabel': 'Total:',
  'rateSelector.option1': '3%',
  'rateSelector.option2': '4%',
  'rateSelector.option3': '5%',
  'enrolmentSummary.title': 'Enrolment Summary',
  'enrolmentSummary.accountNumber': 'Account Number',
  'enrolmentSummary.firstName': 'First Name',
  'enrolmentSummary.middleName': 'Middle Name',
  'enrolmentSummary.lastName': 'Last Name',
  'enrolmentSummary.dateOfBirth': 'Date of Birth',
  'enrolmentSummary.SIN': 'Social Insurance Number',
  'enrolmentSummary.employmentStatus': 'Employment Status',
  'enrolmentSummary.jobTitle': 'Job Title',
  'enrolmentSummary.householdIncome': 'Gross Income',
  'enrolmentSummary.invesmentExperience': 'Investment Experience',
  'enrolmentSummary.riskProfile': 'Risk Profile',
  'enrolmentSummary.electronicSignature': 'Electronic Signature',
  'enrolmentSummary.subscriber': 'Subscriber',
  'enrolmentSummary.ipAddress': 'IP Address',
  'enrolmentSummary.timestamp': 'Timestamp',
  'enrolmentSummary.EAA': 'EAA',
  'enrolmentSummary.acknowledgements': 'Acknowledgements',
  'enrolmentSummary.beneficiary': 'Beneficiary',
  'enrolmentSummary.relationship': 'Relationship to subscriber',
  'enrolmentSummary.grants': 'Grants',
  'enrolmentSummary.CESG': 'Canadian Education Savings Grant (CESG)',
  'enrolmentSummary.CLB': 'Canada Learning Bond (CLB)',
  'enrolmentSummary.ACESG': 'Additional Canada Education Savings Grant (ACESG)',
  'enrolmentSummary.BCTESG':
    'British Columbia Training and Education Savings Grant (BCTESG)',
  'enrolmentSummary.QESI': 'Quebec Education Savings Incentive (QESI)',
  'enrolmentSummary.separator': ':',
  'studentsCard.beneficiaries': 'Your children',
  'schoolCostCard.setGoal':
    'Select a profile picture and set an education goal.',
  'beneficiarySchoolCosts.headline': 'Beneficiaries',
  'programDetails.changeProfession.btn': 'Choose another career',
  'programDetails.changeProfession.looking': 'Looking for something else?',
  'programDetails.relatedCareers.estimatedSalary': 'Estimated salary ',
  'programDetails.year': 'y',
  'programDetails.tuitionCost': 'Estimated annual tuition',
  'programDetails.tuitionDuration': 'Duration of the program',
  'programDetails.disclaimer.headline': 'Disclaimer',
  'programDetails.disclaimer.content':
    'All data displayed here is based on information available as of January 2024. Tuition fees and other costs are subject to change, and the figures provided are approximate. For the most current and accurate information, please consult the official websites of the respective universities or contact their financial services offices.',
  'programDetails.disclaimer.icon': 'Arrow icon',
  'programDetails.enrolmentRequirements.headline': 'Enrolment requirements',
  'programDetails.enrolmentRequirements.item':
    'Completion of secondary school or equivalent',
  'programDetails.relatedCareers.headline': 'Explore related careers',
  'professionInfoForm.name': 'Your career match:',
  'professionInfoForm.salary': 'Estimated annual earnings',
  'professionInfoForm.content.li-1':
    'Conceive, design, build, supervise, operate, construct, and maintain infrastructure projects, including roads, airports, dams, bridges, and water treatment systems.',
  'professionInfoForm.content.li-2':
    'Focus on protecting public and environmental health.',
  'professionInfoForm.continue': 'Looks good, continue',
  'professionInfoForm.back': 'Not a fit, go back',
  'institutionsGroup.kilometers': 'km',
  'programMatcherMap.salary': 'Potential Starting Salary',
  'programMatcherMap.duration': 'Duration:',
  'programMatcherMap.estimatedTuition': 'Estimated annual tuition:',
  'programMatcherMap.specialization': 'Specialization needed',
  'programMatcherMap.furtherEducationRequired': 'Further Education Required',
  'programMatcherMap.chosenCareer': 'Your Chosen Career: ',
  'programMatcherMap.listHeader': 'School for an Aspiring',
  'programMatchMap.schoolPin.tuitionText': 'Avg Tuition: ',
  'programMatchMap.schoolPin.tuitionYear': '/yr',
  'mapView.userCoordinatedError': 'Unable to get coordinates.',
  'mapView.title': 'Which university would they like to attend?',
  'mapView.main.title': 'Schools',
  'mapView.description-1': 'Choose from our selection of Canadian schools for ',
  'mapView.dropdownLabel': 'Province:',
  'mapView.dropdownCanadaWide': 'Canada Wide',
  'mapView.dropdownDefault': 'Enter a Postal Code',
  'mapView.duration': 'Duration:',
  'mapView.estimatedTuition': 'Estimated annual tuition:',
  'mapView.showMap': 'Show map',
  'mapView.showList': 'Show list of schools',
  'mapView.noSchools': 'No schools found near you',
  'mapView.selectDifferentProvince':
    'Please try selecting a different province.',
  'schoolFilter.near': 'Schools near you',
  'schoolFilter.canadaWide': 'Canada Wide',
  'programsPanel.programsFound': 'See Your Program Possibilities: ',
  'programMatcher.schoolList.campus': 'Campus',
  'programMatcher.schoolList.programs': 'Program(s)',
  'programMatcher.addressFields.title': 'Residential address',
  'programMatcher.addressFields.label': "You're here",
  'programMatcher.mapChip.groceries': 'Groceries',
  'programMatcher.mapChip.transit': 'Transit',
  'programMatcher.mapChip.cafe': 'Cafes',
  'programMatcher.mapChip.restaurant': 'Restaurants',
  'programMatcher.mapChip.groceriesAlt': 'shopping cart icon',
  'programMatcher.mapChip.transitAlt': 'tram icon. public transit icon',
  'programMatcher.mapChip.cafeAlt': 'coffe mug. cafes, icon',
  'programMatcher.mapChip.restaurantAlt': 'dining icon. restaurants',
  'programMatcher.map.groceryPinAlt': 'google map pin with grocery store icon',
  'programMatcher.map.transitPinAlt':
    'google map pin with public transit, tram icon',
  'programMatcher.map.cafePinAlt': 'google map pin with cafe, coffe mug icon',
  'programMatcher.map.restaurantPinAlt': 'google map pin with restaurant icon',
  'programMatcher.map.defaultPinAlt':
    'google map pin with default location icon',
  'programMatcher.map.groceryCluster': 'Grocery stores',
  'programMatcher.map.transitCluster': 'Transit stations',
  'programMatcher.map.cafeCluster': 'Cafes',
  'programMatcher.map.restaurantCluster': 'Restaruants',
  'schoolGroup.headline': 'schools found',
  'programMatcher.back': 'Back',
  'programMatcher.done': 'Continue exploring',
  'programMatcher.years': 'years',
  'programMatcher.admissionRequirements': 'Admission requirements:',
  'programMatcher.selection.requiredToContinueError':
    'Please select an option to continue.',
  'programMatcher.selection.requiredError': 'Please select an option.',
  'pickProfessions.title1': 'Navigate their future with ',
  'pickProfessions.title2': "Embark's Career & School Matcher",
  'pickProfessions.description':
    'The only tool of its kind in Canada, The Embark Career & School Matcher provides need-to-know information, like tuition costs and program requirements, in minutes.',
  'pickProfessions.searchbar.placeholder': 'Search',
  'pickProfessions.button': 'Go',
  'pickProfessions.link.careerList.text': 'Or search all careers',
  'pickProfessions.link.careerList.link': 'here.',
  'careerList.industry.title': 'Industries',
  'careerList.searchbar.placeholder': 'Explore careers (e.g., Accountant)',
  'careerList.header.searchbtn': 'Search',
  'careerList.occupationGroups.notFound': 'No careers found',
  'searchbar.popular': 'Popular careers',
  'pickProfessions.createdBy': 'Created by',
  'splash.careerProgramMatcher1': '',
  'splash.careerProgramMatcher2': 'Career ',
  'splash.careerProgramMatcher3': '& School Matcher',
  'splash.createdBy': 'Created by ',
  'splash.subheader':
    "Personalized analysis of your child's interests for tailored guidance on their educational journey and career opportunities.",
  'programMatcher.compareHeader':
    'Check out other schools that offer similar programs',
  'programMatcher.comparePopular': 'Most popular',
  'programMatcher.compareNearest': 'Nearest school',
  'programMatcher.compareTuition': 'Highest tuition',
  'programMatcher.compareEmptySubHeader':
    "Hmm, it seems like there's nothing here!",
  'programMatcher.compareEmptyBody': 'Try exploring other programs.',
  'programMatcher.ageDialog.title': 'How old is your child?',
  'programMatcher.ageDialog.content':
    'We want to better understand your needs and enhance our features for a more tailored experience.',
  'programMatcher.ageDialog.dropdownLabel': "Child's age",
  'programMatcher.feedbackSent.input.alt1': 'heart-image',
  'programMatcher.feedback.header': 'We value your feedback!',
  'programMatcher.feedbackSent.header': 'Thank you for helping us improve!',
  'programMatcher.feedback.body1': 'Did you enjoy your experience?',
  'programMatcher.feedback.body2': 'Let us know your feedback below!',
  'programMatcher.feedbackSent.body1': 'Your feedback could help us make this',
  'programMatcher.feedbackSent.body2':
    'feature even better for users like you.',
  'programMatcher.feedback.input.thumbsUp': 'Yes',
  'programMatcher.feedback.input.alt2': 'Thumbs-up-image',
  'programMatcher.feedback.input.thumbsDown': 'No',
  'programMatcher.feedback.input.alt3': 'Thumbs-down-image',
  'programMatcher.feedback.input.error': 'Maximum 250 characters',
  'programMatcher.feedback.input.textLabel': 'Additional Feedback',
  'programMatcher.feedback.cta1': 'Send',
  'programMatcher.feedback.cta2': 'Close',
  'programMatcher.feedbackSent.cta1': 'Done',
  'programMatcher.carIconAltText': 'car-icon',
  'programMatcher.pencilIconAltText': 'pencil-and-ruler-icon',
  'programMatcherPaywall.content.tagline':
    'This content is available to Embark subscribers.',
  'programMatcherPaywall.content.headline': 'Join Embark’s Community',
  'programMatcherPaywall.content.description':
    'Unlock comprehensive enrolment criteria, insider knowledge on career outcomes, and custom resources designed for proactive students.',
  'programMatcherPaywall.content.cta': 'Join Embark',
  'programMatcherPaywall.content.signIn.title': 'Already a member?',
  'programMatcherPaywall.content.signIn.text': 'To access benefits, ',
  'programMatcherPaywall.content.signIn.link': 'sign in here',
  'programMatcherPaywall.content.activate.text':
    'Did you receive an activation email?',
  'programMatcherPaywall.content.activate.link': 'Activate your account',
  'programMatcherPaywall.card.title': 'Benefits include:',
  'programMatcherPaywall.card.bulletPoint1': 'Personalized Savings Plans',
  'programMatcherPaywall.card.bulletPoint2': 'Advanced Financial Calculators',
  'programMatcherPaywall.card.bulletPoint3': 'Expert Advice',
  'programMatcherPaywall.card.bulletPoint4':
    'Comprehensive Guides and Resources',
  'programMatcherPaywall.card.bulletPoint5': 'Exclusive Webinars and Workshops',
  'programMatcherPaywall.card.bulletPoint6': 'Priority Customer Support',
  'programMatcherPaywall.blurredImage.alt':
    'Blurred background of admissions, driving distance, location, related to the specific occupation school and program of your choice',
  'programMatcherPaywall.checkmark.alt': 'checkmark inside a circle',
  'budgeting.header': 'Cost of School',
  'budgeting.cta.heading': 'Almost there!',
  'budgeting.cta.descriptionNoResp':
    "Our budgeting tool is an exclusive feature designed to help you make the most out of your RESP. By opening an account with us, you'll unlock a world of benefits and take a step closer to securing your child's future.",
  'budgeting.cta.descriptionResp':
    'Our budgeting tool is an exclusive feature available to our RESP customers. To make the most of this  tool, head over to your RESP dashboard and unlock all the benefits!',
  'budgeting.cta.buttonNoResp': 'Open an RESP',
  'budgeting.cta.buttonResp': 'Go to my dashboard',
  'budgeting.backgroundImg.alt': 'pink background with various shapes',
  'budgeting.backgroundImgPhone.alt': 'app in use on mobile phone',
  'openRESP.header': 'RESPs',
  'openRESP.cta.heading': 'Sign up for an RESP',
  'openRESP.cta.description':
    "Sign up for an Embark Student RESP and start saving for your child's future.",
  'openRESP.cta.button': 'Open an RESP',
  'openRESP.backgroundImg.alt': 'pink background with various shapes',
  'openRESP.backgroundImgPhone.alt': 'app in use on mobile phone',
  'schoolCostCard.title': 'Estimated cost',
  'schoolCostCard.viewProfile': 'View profile',
  'schoolCostCard.createProfile': 'Create profile',
  'schoolCostCard.completeProfile': 'Complete profile',
  'schoolCostCard.costTotal': 'Education savings goal: ',
  'termsConditions.title': 'Terms and conditions',
  'termsConditions.singleSubscriber.eaaBox1': 'I have read and agree to the',
  'termsConditions.singleSubscriber.eaaBox2':
    ' I understand that this is my plan contract.',
  'termsConditions.singleSubscriber.disclosureBox1':
    'I have read and agree to the',
  'termsConditions.singleSubscriber.electronicBox1':
    'Electronic delivery of tax documents:',
  'termsConditions.singleSubscriber.electronicBox2':
    'I agree to the electronic delivery of all tax documents, including any forms, slips, receipts or other documents or information Embark Student Corp. may be required to send now or in the future under applicable tax legislation',
  'termsConditions.singleSubscriber.promoBox1':
    'I agree to receive news, offers, promotional material and updates from Embark Student Corp. and Embark Student Foundation. I understand that I can unsubscribe at any time.',
  'termsConditions.disagreeError': 'Please accept to continue.',
  'termsConditions.eaa': 'Education Assistance agreement and Acknowledgements.',
  'termsConditions.eaa.link': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Family_Plan_EAA_&_Acknowledgements_&_Prospectus_EN_DIGITAL.pdf`,
  'termsConditions.relationshipDisclosure': 'Relationship disclosure',
  'termsConditions.relationshipDisclosure.link': `${__STUDENT_SERVICES_URL__}/documents/Embark_Relationship_Disclosure_en.pdf`,
  'termsConditions.conflictsDisclosure': 'Conflicts of Interest disclosure',
  'termsConditions.conflictsDisclosure.link': '/terms',
  'promotion.unsubscribeLink': '/unsubscribe',
  'enrolmentSummaryPDF.downloadBtnText': 'Enrolment Summary',
  'enrolmentSummaryPDF.downloadError':
    'Something went wrong. Please try again.',
  'fileUpload.title': 'Upload file',
  'fileUpload.upload': 'Upload',
  'fileUpload.remove': 'Remove',
  'fileUpload.maxFileSize': 'Max file size:',
  'fileUpload.maxFileSizeError1': 'Please upload a valid file size.',
  'fileUpload.fileTypeError': 'Please upload a valid file type.',
  'documents.title': 'Documents',
  'documents.financialYear': 'Year',
  'documents.account': 'Plans',
  'documents.taxSlips': 'Tax slips',
  'documents.financialStatements': 'Financial statements',
  'documents.tradeConfirmations': 'Trade confirmations',
  'documents.enrolmentSummary': 'Enrolment summary',
  'fileUpload.MB': 'MB',
  'profile.personalDetails': 'Personal details',
  'profile.emailCommunicationPreferences': 'Email communication preferences',
  'profile.taxStatements': 'Electronic delivery of tax documents',
  'profile.newsAndMarketing': 'News, offers and marketing updates',
  'profile.investmentProfile': 'Investment profile',
  'profile.addressTitle': "What's your address?",
  'profile.phoneTitle': "What's your phone number?",
  'childProfileSelect.title': "Who's going to school?",
  'childProfileSelect.addProfile': 'Add profile',
  'childProfileSelect.addIcon': 'plus icon',
  'digitalAccess.title': 'ACTIVATE YOUR DIGITAL ACCOUNT',
  'existingRESP.headline':
    'Are you the parent (subscriber) of an existing RESP with Knowledge First Financial, Heritage, or Embark?',
  'existingRESP.alert':
    'Digital activation is currently limited to parents (subscribers) only. Student digital activation is unavailable at the moment.',
  'respOpeningPeriod.headline':
    'Did you open your RESP plan(s) between 1995 and February 2023?',
  'respOpeningPeriodOption.plansBeforeAndAfterFeb2023':
    'I have plans opened before and after February 2023',
  'welcome.headline': 'Before you get started',
  'welcome.para1': `Your Knowledge First Financial plan(s) will be linked to your new Embark digital account at the end of this registration. you'll also get access to our wide range of exclusive products and services.`,
  'welcome.detailList.title': 'You must have the following details:',
  'welcome.detailList.bullet1': 'Social Insurance Number (SIN)',
  'welcome.detailList.bullet2':
    'Please ensure you have one of the following government-issued photo IDs',
  'welcome.detailList.bullet2.bullet1': 'Provincial driver’s license',
  'welcome.detailList.bullet2.bullet2': 'Passport',
  'welcome.detailList.bullet2.bullet3': 'Permanent resident card',
  'welcome.detailList.note.important': 'IMPORTANT:',
  'welcome.detailList.note': 'You cannot use an expired ID.',
  'welcome.estimatedTime': 'Estimated time 5 minutes.',
  'welcome.needMoreInfo': 'Need more information?',
  'welcome.call.part1': 'Call our team at',
  'welcome.call.part2': ' to get in touch.',
  'existingEmbarkCustomer.headline':
    'It seems like you already have a plan with us!',
  'existingEmbarkCustomer.message':
    'Sign in to your dashboard to view your plans.',
  'existingEmbarkCustomer.signInBtn': 'Sign in now',
  'programLength.lessThanOneYear': 'Less than one year',
  Today: 'Today',
  'jobTitle.maxLength': 'Job title has a size limitation of 40 characters',
  'generalError.title': "Something's not right.",
  'generalError.text': 'Please try again later.',
  'investmentProfile.maritalStatus': 'Are you married?',
  'investmentProfile.headline': "Let's do a quick review of your profile",
  'advisor.headline': 'Verify your agent ID',
  'advisor.description': 'Please enter your agent ID',
  'advisor.agentId': 'Agent ID#',
  'advisor.error': 'Please enter your ID',
  'termsConditions.singleSubscriber.ESCandD1':
    ' I hereby consent to the processing of my personal data that I have provided and I confirm that I have read and agree to the',
  'termsConditions.singleSubscriber.ESCandD2': 'and the',
  'termsConditions.ESCandD1.link': 'Embark Student Corp. Privacy Policy',
  'termsConditions.ESCandD2.link': 'Digital Terms & Conditions',
  'termsConditions.singleSubscriber.EnrolmentSummary':
    'I confirm and agree to all the details I shared with the agent during the assisted flow. ',
  'termsConditions.link.EnrolmentSummary': 'Enrolment Summary',
  'onboardingPlanSelection.title': 'Select an RESP plan',
  'onboardingPlanSelectionOption.label.family': 'Embark student family plan',
  'onboardingPlanSelectionOption.label.individual':
    'Embark student individual plan',
  'onboardingPlanSelectionOption.helperText.family':
    'Subscribers must be a parent (biological or adoptive), grandparent or sibling.',
  'onboardingPlanSelectionOption.helperText.individual':
    'Subscribers are not required to be related to the beneficiary. Adults can open this RESP for themselves too.',
  'createAccount.title': 'CREATE ACCOUNT',
  'identification.head': "Verify the subscriber's ID",
  'identification.idType': 'ID type',
  'identification.typeError': 'Please select the ID type.',
  'identification.idTypeNotes':
    "Should be a valid government-issued photo ID(e.g., provincial driver's license, passport, or PR card).",
  'identification.idNumber': 'ID number',
  'identification.idNumberError': 'Please enter the ID number.',
  'identification.expireDate': 'ID expiration date',
  'identification.issuingJurisdiction': 'Issuing jurisdiction',
  'identification.issuingError': 'Please enter the issuing jurisdiction.',
  'identification.maxCharError': 'Please enter 40 characters or less.',
  openRESP: 'Open RESP',
  'onboardingPersonalInfo.DateOfBirth': 'Date of birth',
  'onboardingPersonalInfo.MobileNumber': 'Mobile number',
  'verifyEmail.head': 'Let’s verify the subscriber’s email',
  'verifyEmail.label': "We've sent a 6-digit security code to:",
  'verifyEmail.securityCode': 'Security code',
  'verifyEmail.resendCode': 'Resend code',
  'verifyEmail.invalidCode': 'Please enter a valid security code.',
  'verifyEmail.expiredCode': 'Security code has expired. Please try again.',
  'verifyEmail.maximumAttempts':
    'Sorry, you have reached the maximum email verification attempts. Please try again later. ',
  'unauthorizedAccess.headline': 'You do not have access to this application.',
  'unauthorizedAccess.headlineFr': 'Vous n’avez pas accès à cette application.',
  'unauthorizedAccess.content':
    'Please contact your administrator to request access.',
  'unauthorizedAccess.contentFr':
    'Veuillez communiquer avec votre administrateur pour demander l’accès.',
  'unauthorizedAccess.close': 'Close / Fermer',
  'success.heading': "You're all set!",
  'success.message1': "Let's explore your dashboard and get saving for ",
  'success.message2': ' education.',
  'success.contribute': 'Contribute',
  'success.dashboard': 'Dashboard',
  'partialSuccess.heading': 'Joint account holder’s agreement pending',
  'partialSuccess.message':
    'Your RESP account is not opened yet. Your joint account holder must read and agree to the Terms and Conditions, before we complete the enrolment of your RESP account. We will notify you with an email once they have completed the process.',
  'idleLogout.title': "You've been logged out",
  'idleLogout.body1': "You've been signed out due to 15 minutes of inactivity.",
  'idleLogout.body2': 'Please log in again to continue.',
  'idleLogout.cta1': 'Sign in',
  'idleLogout.cta2': 'Close',
  'childProfile.title': 'Who’s going to school?',
  'childProfile.subTitle': 'Create a profile below to get started.',
  'childProfile.headerOne': 'Child profile',
  'childProfile.headerTwo': 'Are you sure you want to leave?',
  'childProfile.body': 'Your changes will not be saved.',
  'childProfile.interestOne': 'Interest one',
  'childProfile.interestTwo': 'Interest two',
  'childProfile.interestThree': 'Interest three',
  'childProfile.interestFour': 'Interest four',
  'childProfile.fieldsError': 'Complete profile details to continue',
  'childProfile.saveError': 'Something went wrong. Please try again.',
  'childProfile.ctaOne': 'Yes, leave',
  'childProfile.ctaTwo': 'No, stay',
  'childProfile.firstNameRequired': 'Please enter your first name',
  'childProfile.nameRequired': 'Please enter a name.',
  'externalTransfer.header': 'Transfer to Embark',
  'externalTransfer.title.part1': 'Transfer ',
  'externalTransfer.title.part2': 'your RESP to Embark and get ',
  'externalTransfer.title.part4': ' more on us!',
  'externalTransfer.title.helpText':
    'Fill out the form below and we will contact you with next steps.',
  'externalTransfer.terms.part1': 'See ',
  'externalTransfer.terms.part2': ' for more information.',
  'externalTransfer.terms.link': 'Terms & Conditions',
  'externalTransfer.termsIcon.alt': 'Redirect Icon',
  'externalTransfer.info.title': 'RESP transfer process made easy',
  'externalTransfer.info.description':
    'Effortlessly move your RESP plans to Embark. Fill in the details below, and we will call you to guide you through the process.',
  financialInstituteLabel: 'Which financial institution are your RESPs held?',
  financialInstituteLabelHelper: 'Financial Institution',
  financialInstitutionNameRequired: 'Please enter the financial institution.',
  respAmountLabel: 'What is the estimated balance of your RESPs?',
  respAmountLabelHelper: 'Amount',
  backIcon: 'Back Icon',
  'externalTransfer.icon.alt': 'Transfer Icon',
  'externalTransfer.semiAnnulus.icon.alt': 'Semi Annulus Icon',
  'externalTransfer.square.icon.alt': 'Square Icon',
  'searchbar.ariaLabel.clearField': 'Clear search field',
  'searchbar.ariaLabel.setDefaultState': 'Set search back to default field',
  'img.alt.carIcon': 'outline of a car',
  'img.alt.folderIcon': 'outline of a folder',
  'img.alt.shiftCollabIcon': 'Company icon of shiftCollab',
  'img.alt.giftCardIcon': 'Gift card icon',
  'img.alt.embarkBgText': 'Embark abbreviation: e, a',
  'img.alt.devices': 'Two mobile devices displaying Career and School Matcher',
  'img.alt.embarkLogo': 'Embark',
  'img.alt.errorIcon': 'Error',
  'headerNav.resps': 'RESP',
  'headerNav.openResp': 'Open an account',
  'headerNav.budget': 'Cost of School',
  'headerNav.matcher': 'Career & School Matcher',
  'headerNav.scholarships': 'Scholarships',
  'headerNav.refer': 'Refer a friend',
  'settings.header': 'Settings',
  'settings.plans.header': 'Plans',
  'settings.security.header': 'Security',
  'settings.messages.header': 'Messages (Coming Soon)',
  'settings.dialog.header': 'Settings',
  'settings.dialog.subHeader': "We couldn't find any plans",
  'settings.dialog.body': 'Once you open a RESP, your plan will appear here.',
  'settings.dialog.cta': 'Add a plan',
  'financialPlanDropdown.canada': 'Canada',
  'financialPlanLineChart.disclaimer':
    'This projection is based on assumptions and is for illustrative purposes only. Investment returns and actual future value of your RESP cannot be predicted or guaranteed.',
  'financialPlanEducationCost.title': 'Average cost of education',
  'financialPlanEducationCost.tuition': 'Tuition',
  'financialPlanEducationCost.total': 'Tuition and residence',
  'financialPlanLineChartHeader.projectedSavings': 'Projected savings',
  'financialPlanLineChartHeader.shortfallSurplus': 'Total shortfall/surplus ',
  'financialPlanLineChartHeader.year': 'by ',
  'financialPlanLineChartHeader.title': 'Your RESP Savings',
  'financialPlannerEntry.heading.headline': 'Education Savings Calculator',
  'financialPlannerEntry.useRespData': 'Use RESP Data',
  'financialPlannerEntry.heading.content':
    'Figure out the total estimated cost of school. Realidtically forecast your expenses, plus ideas on how to cover your costs.',
  'interestQuestionnaireEntry.headline': 'Career kickstart quiz',
  'interestQuestionnaireEntry.body':
    "Are you sure about doctor? Whether you're a parent or future scholar, our career quiz reveals paths just as exciting as medicine—and maybe even more high-paying.",
  'interestQuestionnaireEntry.step1.headline': 'Step 1',
  'interestQuestionnaireEntry.step1.title': 'Take the quiz',
  'interestQuestionnaireEntry.step1.body':
    "Let's take the guesswork out of work.",
  'interestQuestionnaireEntry.step2.headline': 'Step 2',
  'interestQuestionnaireEntry.step2.title': 'Explore the results',
  'interestQuestionnaireEntry.step2.body':
    'Discover potential strengths and careers that suit you.',
  'interestQuestionnaireEntry.step3.headline': 'Step 3',
  'interestQuestionnaireEntry.step3.title': 'See Career & School Matcher',
  'interestQuestionnaireEntry.step3.body':
    'Check out schools near you for that career.',
  'interestQuestionnaireEntry.cta': "Let's go!",
  'interestQuestionnaireQuizDialog.header': 'Are you sure you want to leave?',
  'interestQuestionnaireQuizDialog.body': 'You will lose any unsaved changes.',
  'interestQuestionnaireQuizRestartDialog.title1':
    "Uh-oh, we've run out of questions for you.",
  'interestQuestionnaireQuizRestartDialog.title2': 'Please start over.',
  'interestQuestionnaireQuizRestartDialog.cta': 'Start Over',
  'interestQuestionnaireQuizDialog.no': 'No, stay',
  'interestQuestionnaireQuizDialog.yes': 'Yes, leave',
  'interestQuestionnaireEmail.headline': "You're almost there!",
  'interestQuestionnaireEmail.body':
    'Enter your email to unlock your quiz results.',
  'interestQuestionnaireEmail.cta': 'See the results',
  'interestQuestionnaireEmail.disclaimer1':
    "By providing your email address, you consent to receive communications from both Embark Student Corp. and Embark Student Foundation. You acknowledge and agree to Embark Student Corp's. ",
  'interestQuestionnaireEmail.disclaimer2':
    '. You may withdraw consent at any time by opting out. All your data is secure using SHA-256 encryption.',
  'interestQuestionnaireCareers.headline': "The future's looking bright!",
  'interestQuestionnaireCareers.body':
    'Sunglasses may be needed. Here are a few brag-worthy traits and the awesome potential career paths that go with them.',
  'interestQuestionnaireCareers.cta': 'See top schools for ',
  'interestQuestionnaireCareers.feedbackHeadline': 'Was this quiz helpful?',
  'interestQuestionnaireCareers.feedbackBody': 'Thanks for your feedback.',
  'childProfileCard.year': 'yr',
  'childProfileCard.careerLabel': 'Aspiring career',
  'childProfileCard.careerDefault': 'No career chosen',
  'childProfileCard.careerIconAlt': 'School cap',
  'childProfileCard.schoolLabel': 'School of choice',
  'childProfileCard.schoolDefault': 'No school selected',
  'childProfileCard.link.careers': 'Explore careers',
  'childProfileCard.link.details': 'View details',
  'childProfileCard.schoolIconAlt': 'School cap',
  'valuePropTour.loading.text': 'Your child’s tomorrow starts now.',
  'dashboard.coSubInviteCard.title':
    ' has invited you to be a joint-account holder',
  'dashboard.coSubInviteCard.new.description':
    'Start the joint-account holder flow.',
  'dashboard.coSubInviteCard.interrupted.description':
    'Pick up from where you left off.',
  'dashboard.coSubInviteCard.new.button': 'Get started',
  'dashboard.coSubInviteCard.interrupted.button': 'Continue',
  childName: 'Child name',
  childNameRequiredError: "Please enter the child's name",
  schoolTypeRequiredError: 'Please enter select a school type',
  yearsOfPseStudy: 'Years of PSE study',
  respSavings: 'RESP savings',
  monthlycontribution: 'Monthly contribution',
  annualTuition: 'Annual tuition',
  annualCompulsoryFees: 'Annual compulsory fees',
  annualResidenceMeals: 'Annual residence/meals',
  annualTextbooksSupplies: 'Annual textbook/supplies',
  annualPersonalExpenses: 'Annual personal expenses',
  rateOfReturn: 'Rate of returns',
  totalEducationCost: 'Total education cost',
  'valueProp.iconAlt.moneyPlant': 'Money Plant',
  'valueProp.iconAlt.capBook': 'Cap Book',
  'valueProp.iconAlt.bagCoints': 'Bag Coins',
  'valueProp.iconAlt.goldBar': 'Gold Bar',
  'valueProp.iconAlt.coinCap': 'Coin Cap',
  'valueProp.embarkStudentPlanTitle': 'Embark Student Plan',
  'whyEmbark.title': 'Why Embark?',
  'whyEmbark.years': '60 years',
  'whyEmbark.yearsText':
    'of specialized experience in education saving and planning',
  'whyEmbark.students': '60,000+ students',
  'whyEmbark.studentsText': 'supported every year',
  'whyEmbark.aum': '$6.4 billion',
  'whyEmbark.aumText': 'Assets Under Management (AUM)',
  'whyEmbark.ourFocusTitle': 'Our focus',
  'whyEmbark.ourFocusText':
    'At Embark, we specialize in education savings, planning, and support, backed by the <strong>Embark Student Foundation</strong>, a not-for-profit organization, and distributed by <strong>Embark Student Corporation</strong>. Our mission is to make education accessible and empower students to reach their full potential.',
  'whyEmbark.keyBenefitsTitle': 'Key benefits for you',
  'whyEmbark.toolTitle': 'Tools for education',
  'whyEmbark.toolText':
    'The only tool of its kind in Canada—Embark Career & School Matcher.',
  'whyEmbark.taxTitle': 'Tax and grant advantages',
  'whyEmbark.taxText':
    'Maximize grants while your savings grow tax-free. Withdrawals for education are taxed at a lower rate in the student’s hands.',
  'whyEmbark.flexibleTitle': 'Flexible access',
  'whyEmbark.flexibleText':
    'Manage your RESP online, track its growth, and easily withdraw funds for your child’s education.',
  'whyEmbark.eligibilityTitle': 'Broad Eligibility',
  'whyEmbark.eligibilityText':
    'Use your RESP funds for university, college, trades, or apprenticeships—full-time or part-time, in Canada or abroad.',
  'tailoredSavings.planTitle': 'Tailored saving plans',
  'tailoredSavings.planSubtitle': 'that fit your child’s age',
  'tailoredSavings.investmentTitle': 'Investment strategy',
  'tailoredSavings.investmentSubtitle': 'on the Embark Student Plan',
  'tailoredSavings.feeStructure': 'Simple and competitive fee structure',
  'tailoredSavings.managementFee':
    'Management Fee (MER): 1.65% + applicable taxes, calculated based on net asset value of all plan savings. Deducted monthly from plan earnings.',
  'tailoredSavings.contributions': 'Contributions',
  'tailoredSavings.portfolioTitle': 'Portfolio:',
  'tailoredSavings.portfolioDescription':
    'Low to medium risk, focusing on preserving savings for post-secondary education.',
  'tailoredSavings.maxContributionTitle': 'Max contribution:',
  'tailoredSavings.maxContribution': 'Up to $50,000 per child',
  'tailoredSavings.addedValueTitle': 'Added value:',
  'tailoredSavings.addedValue': 'Create a gifting page for your child',
  'tailoredSavings.fullDetailsTitle': 'Full details:',
  'tailoredSavings.fullDetails':
    'Refer to the Prospectus for fees and plan details',
  'governmentGrant.title': 'Government grants',
  'governmentGrant.subtitle': 'Government-boosted savings',
  'governmentGrant.cesg.title': 'Canada Education Savings Grant (CESG)',
  'governmentGrant.cesg.lifetimeMaximum': 'Lifetime maximum',
  'governmentGrant.cesg.lifetimeMaximumValue': '$7,200',
  'governmentGrant.cesg.annualGrant': 'Annual grant',
  'governmentGrant.cesg.annualGrantValue':
    '20% on the first $2,500 contributed',
  'governmentGrant.cesg.additional': 'Additional CESG',
  'governmentGrant.cesg.additionalValue':
    'Up to 10% or 20% on the first $500 contributed, based on income',
  'governmentGrant.cesg.availability': 'Availability',
  'governmentGrant.cesg.availabilityValue':
    'Until the end of the year your child turns 17',
  'governmentGrant.clb.title': 'Canada Learning Bond (CLB)',
  'governmentGrant.clb.provides': 'Provides',
  'governmentGrant.clb.providesValue':
    'Up to $2,000 for eligible children born in 2004 or later',
  'governmentGrant.clb.eligibility': 'Eligibility',
  'governmentGrant.clb.eligibilityValue': 'Families meeting income limits',
  'governmentGrant.clb.applicationDeadline': 'Application deadline',
  'governmentGrant.clb.applicationDeadlineValue':
    'The beneficiary must be under the age of 21 at the time of application',
  'governmentGrant.bc.title':
    'British Columbia Training and Education Savings Grant',
  'governmentGrant.bc.grant': 'Grant',
  'governmentGrant.bc.grantValue': '$1,200 for residents of British Columbia',
  'governmentGrant.bc.childEligibility': "Child's eligibility",
  'governmentGrant.bc.childEligibilityValue':
    'Born on or after January 1, 2006',
  'governmentGrant.bc.applicationPeriod': 'Application period',
  'governmentGrant.bc.applicationPeriodValue':
    "Between the child's 6th and 9th birthdays",
  'governmentGrant.qc.title': 'Quebec Education Savings Incentive (QESI)',
  'governmentGrant.qc.lifetimeMaximum': 'Lifetime maximum',
  'governmentGrant.qc.lifetimeMaximumValue': '$3,600 per child',
  'governmentGrant.qc.potentialEarnings': 'Potential earnings',
  'governmentGrant.qc.potentialEarningsValue': 'Up to $3,600 per child',
  'governmentGrant.qc.annualGrant': 'Annual grant',
  'governmentGrant.qc.annualGrantValue':
    '10% of RESP contributions, up to $250 per year',
  'governmentGrant.eligibilityNotice':
    'Eligibility requirements apply. Please visit our current Embark Student Plan Prospectus for full details.',
  'governmentGrant.respUsage.title': 'What can your RESP pay for?',
  'governmentGrant.respUsage.tuitionFees': 'Tuition fees',
  'governmentGrant.respUsage.residenceAndMeals': 'Residence and meals',
  'governmentGrant.respUsage.residenceAndMealsValue':
    'Housing, rentals, utilities',
  'governmentGrant.respUsage.booksAndSupplies': 'Books and supplies',
  'governmentGrant.respUsage.booksAndSuppliesValue':
    'Laptops, notebooks, tablets',
  'governmentGrant.respUsage.transportation': 'Transportation',
  'governmentGrant.respUsage.transportationValue': 'Car, public transportation',
  'governmentGrant.respUsage.personalExpenses': 'Personal expenses',
  'governmentGrant.respUsage.personalExpensesValue':
    'Entertainment, cellphone, clothing',
  'governmentGrant.ifNotPostSecondary.title':
    'What if your child chooses not to pursue post-secondary education?',
  'governmentGrant.ifNotPostSecondary.option1':
    'Continue earning income on plan assets for up to 35 years',
  'governmentGrant.ifNotPostSecondary.option2':
    'Share or transfer the RESP plan with another child',
  'governmentGrant.ifNotPostSecondary.option3':
    'Transfer unused income to RRSP or as an Accumulated Income Payment (AIP)*',
  'governmentGrant.ifNotPostSecondary.note':
    '*Withdrawn accumulated income is taxable, subject to a 20% federal tax (12% for Quebec residents), or can be transferred to an RRSP, up to $50,000 per subscriber (based on RRSP contribution room and tax regulations).',
  'headerNavLinks.home': 'Home',
  'headerNavLinks.money': 'Money',
  'headerNavLinks.rewards': 'Rewards',
  'headerNavLinks.offers': 'Offers',
  'headerNavLinks.refer': 'Refer a friend',
  'headerNavMenuItems.addAChild': 'Add a child',
  'headerNavMenuItems.linkABankAccount': 'Link a bank account',
  'headerNavMenuItems.addAPlan': 'Add a plan',
  'headerNavMenuItems.giftingLink': 'Share gift link',
  'headerNavMenuItems.transferIn': 'Transfer an RESP',
  'headerNavMenuItems.addCosubscriber': 'Add a joint account holder',
  'headerNavMenuItems.settings': 'Settings',
  'headerNavMenuItems.openResp': 'Open an RESP',
  'headerNavMenuItems.documents': 'Documents',
  'headerNavMenuItems.logout': 'Log out',
  'settings.profile.info': 'Personal information',
  'settings.profile.name': 'Name:',
  'settings.profile.email': 'Email:',
  'settings.profile.phone': 'Mobile number:',
  details: 'Details',
  contact: 'Contact',
  changeLanguage: 'Change language',
  emailCommunication: 'Email communication',
  newsOffersMarketingUpdates: 'News, offers and marketing updates',
  'settings.security.changePassword': 'Change your password',
  'settings.security.stepOne':
    'When updating your password, start by sharing your email and phone number, then verify your password by text or email.',
  'settings.security.stepTwo':
    'Next, create a new password that meets the specified requirements, such as length and special characters. Once you’ve completed these steps, simply look for the " Continue " button.',
  'settings.security.continue': 'Change password',
  'surveyFeedbackDialogSuccess.description':
    'Your feedback really matters. By sharing your thoughts, you’re helping us make Embark even better.',
  'surveyFeedbackDialogSuccess.thanks':
    'Thanks for joining! We’d love your feedback to improve your experience.',
  'survey.language': 'What’s your preferred language?',
  'survey.gender': 'What’s your gender?',
  'survey.discovery': 'How did you discover us?',
  'survey.additionalSavings':
    'Do you have additional education savings from other accounts?',
  'survey.educationFunds':
    'Where else are you setting aside funds for education?',
  'survey.headsUp': 'Just a heads up: your responses won’t be saved.',
  quickSurvey: 'Quick survey',
  'language.english': 'English',
  'language.french': 'French',
  'language.mandarin': 'Mandarin',
  'language.cantonese': 'Cantonese',
  'language.hindi': 'Hindi',
  'language.urdu': 'Urdu',
  'language.arabic': 'Arabic',
  'language.tagalog': 'Tagalog',
  'language.others': 'Others',
  'source.google': 'Google',
  'source.socialMedia': 'Social media',
  'source.friendsFamily': 'Friends & Family',
  'source.newspaperMagazine': 'Newspaper & Magazine',
  'source.tvStreaming': 'TV/Streaming',
  'source.billboards': 'Billboards',
  'source.radioPodcast': 'Radio/Podcast',
  'amount.lessThan5000': 'Less than $5,000',
  'amount.moreThan5000': 'More than $5,000',
  'amount.preferNotToSay': 'Prefer not to say',
  'account.anotherRESP': 'Another RESP',
  'account.tfsa': 'Tax Free Savings Account (TFSA)',
  'account.chequingSavings': 'Chequing / Savings',
  'account.preferNotToSay': 'Prefer not to say',
  additionalFeedback: 'Additional feedback',
  accountType: 'Account type',
  'done.survey': 'Done',
  'money.header': 'Manage your savings',
  'money.add.header': 'Add money',
  'money.add.dialogBody':
    "We're here to help! Right now, you may be unable to add money for a couple of reasons:",
  'money.withdraw.header': 'Withdraw money',
  'money.withdraw.dialogBody':
    "We're here to help! Right now, you may be unable to withdraw money for a couple of reasons:",
  'money.link.header': 'Link a bank account',
  'money.link.dialogBody':
    "You don't have any bank accounts linked yet. Open a plan to link your bank accounts and manage your contributions and withdrawals.",
  'money.reason1': 'You don’t have an',
  'money.reason1.urlText': 'RESP plan.',
  'money.reason2': 'You might not have a',
  'money.reason2.urlText': 'linked bank account.',
  termsAndConditionsApply: '*Terms and conditions apply',
  'termsAndConditionsLink.open':
    'https://www.embark.ca/landing/resp-offer#terms',
  'termsAndConditionsLink.transfer':
    'https://www.embark.ca/balance-offer-terms-and-conditions',
  transferYourRESP: 'Transfer your RESP',
  continueApplication: 'Continue application',
  startApplication: 'Start application',
  actionRequired: 'Action required',
  'home.nonRESP.header': "Start your child's RESP today",
  'home.nonRESP.description':
    'Open an RESP or transfer an existing RESP from somewhere else.',
  'home.nonRESP.openCard.subheader': 'Open an RESP',
  'home.nonRESP.openCard.body1': '8 minutes is all you need to open an RESP.',
  'home.nonRESP.openCard.body2': ' Use Code EASY for a $250 bonus',
  'home.nonRESP.openCard.body3': ' and start earning grants.',
  'home.nonRESP.transferCard.subheader': 'Transfer your existing RESP',
  'home.nonRESP.transferCard.body':
    'Move an existing RESP to Embark and receive 2% bonus.',
  'home.nonRESP.pendingPrimaryCard.subheader': 'Your application is pending',
  'home.nonRESP.pendingPrimaryCard.body':
    "This may take a few business days. You'll get an email once it's approved",
  'home.nonRESP.pendingJointCard.subheader':
    'Your joint account application is pending',
  'home.nonRESP.pendingJointCard.body':
    "This may take a few business days. You'll get an email once it's approved",
  'home.nonRESP.continuePrimaryCard.subheader': 'Continue your application',
  'home.nonRESP.continuePrimaryCard.body': 'Finish where you left off.',
  'home.nonRESP.continueJointCard.subheader':
    'has invited you to be a joint account holder',
  'home.nonRESP.continueJointCard.body': 'Finish where you left off.',
  'home.nonRESP.inviteCard.subheader':
    'has invited you to be a joint account holder',
  'home.nonRESP.inviteCard.body':
    "You have been invited to join an RESP account. Let's start your application and get you set up.",
  'home.nonRESP.staticCards.header': 'The easy way to RESP',
  'home.nonRESP.staticCards.subheader1': 'Open an RESP in minutes',
  'home.nonRESP.staticCards.body1':
    "We get it, you're a busy parent. That's why you can open an RESP in minutes. From home.",
  'home.nonRESP.staticCards.subheader2': '$0 upfront costs',
  'home.nonRESP.staticCards.body2':
    'Save what you want, when you want. Stress-free savings that fit your budget.',
  'home.nonRESP.staticCards.subheader3': '$7,200+ in grants',
  'home.nonRESP.staticCards.body3':
    'Add to your RESP and get a 20% match, up to $500 a year and $7,200 total.',
  'home.nonRESP.pendingPrimaryDialog.header': 'Open an RESP',
  'home.nonRESP.pendingPrimaryDialog.subHeader':
    'You’ve already got an RESP on the go. Here’s why you might not be able to open a new one:',
  'home.nonRESP.pendingPrimaryDialog.listItem1':
    'An application is currently under review.',
  'home.nonRESP.pendingPrimaryDialog.listItem2': 'You’ve already ',
  'home.nonRESP.pendingPrimaryDialog.listItem2Link': 'started an application.',
  'home.nonRESP.pendingPrimaryDialog.listItem3Link': 'You’ve been invited',
  'home.nonRESP.pendingPrimaryDialog.listItem3':
    ' to join someone else’s RESP.',
  'childSavingsCalculator.v2.header': 'Savings calculator',
  'childSavingsCalculator.v2.description':
    "See how your RESP can grow, so you're ready when they are.",
  'childSavingsCalculator.v2.savingsLabel': 'Your estimated RESP savings is',
  aboutThisCalculator: 'About this calculator',
  'aboutThisCalculator.body1':
    'This tool is for illustrative and general information purposes only. Based on the information and inputs you provide, the tool illustrates a projected value at the time your child is expected to start their post-secondary education.',
  'aboutThisCalculator.body2':
    'The value includes contributions (to a maximum of $50,000), excepted Canada Education Savings Grant (CESG) expected to accumulate at 20% (up to $7200) and the estimated earnings of those contributions and grants at  x% net return.',
  'aboutThisCalculator.body3':
    'This is not an indicator or guarantee of future performance.  The illustration should not be relied upon for specific financial advice, and your contribution amounts will depend on personal affordability.',
  mostPopularChoice: 'Most popular choice',
  maximizeYourGovernmentGrants: 'Maximize your government grants',
  'rewards.header': 'Embrace smart savings',
  'rewards.description':
    'You’re an essential part of our journey. Enjoy exclusive rewards designed to help you save smarter and reach your financial goals faster.',
  'rewards.savingOption1.subheader': 'Switch to smarter savings',
  'rewards.savingOption1.description':
    'Transfer your RESP to Embark, and we’ll add an extra 2%, a little boost to get you started.',
  'rewards.savingOption2.subheader': 'Make friends with $250*',
  'rewards.savingOption2.description':
    'Refer a friend and you could both score $250. It’s a great way to grow your RESP, while we take care of the rest.',
  'rewards.subheader1': 'Partner offers',
  'rewards.partnerOffers.policyMe.header': 'Life insurance, simplified',
  'rewards.partnerOffers.policyMe.body1':
    'Get the first 2 months free with Embark.',
  'rewards.partnerOffers.policyMe.body2':
    'Get a quote in less than 30 seconds.',
  'rewards.partnerOffers.policyMe.learnMoreLink':
    'https://policyme.pxf.io/c/5711270/2138593/15713',
  'rewards.partnerOffers.willful.header':
    'Create a will in minutes with Willful',
  'rewards.partnerOffers.willful.body': 'Get 20% off your legal will.',
  'rewards.partnerOffers.willful.learnMoreLink':
    'https://try.willful.co/embark',
  'rewards.partnerOffers.apollo.header': 'Tenant insurance in 5 minutes',
  'rewards.partnerOffers.apollo.body':
    'Guaranteed acceptance by property managers and landlords across Canada.',
  'rewards.partnerOffers.apollo.learnMoreLink':
    'https://info.apollocover.com/embark',
  'rewards.partnerOffers.csl.header': 'Student accommodations across Canada',
  'rewards.partnerOffers.csl.body':
    'Canadian Student Living offers professionally managed, modern student housing with premium amenities and dedicated support — designed for student success across Canada.',
  'rewards.partnerOffers.csl.logoAlt': 'Canadian Student Living',
  'cslOfferDialog.url': 'https://www.canadianstudentliving.com/embark',
  'cslOfferDialog.title':
    'Student housing made easy with Canadian Student Living',
  'cslOfferDialog.body1a':
    'Through Embark, you can now connect with CSL’s trusted network of student residences — ideal for students who want modern amenities, safety, and less stress in their school year.',
  'cslOfferDialog.body1b':
    'CSL properties are move-in ready and include everything from furniture, internet, and laundry to gyms and game rooms.',
  'cslOfferDialog.listTitle': 'Here’s what you get:',
  'cslOfferDialog.listItem1': 'All-inclusive rent',
  'cslOfferDialog.listItem2': 'Move-in ready suites',
  'cslOfferDialog.listItem3': 'Steps from class, groceries, and transit',
  'cslOfferDialog.listItem4': 'Built-in community and support',
  'cslOfferDialog.listItem5':
    'Student living, simplified — with leases that work for you',
  'cslOfferDialog.body2':
    'Give your child more than a dorm. Give them a home base for success.',
  'cslOfferDialog.cta': 'See what’s available',
  'cslOfferDialog.body3a': 'By clicking on this offer, you agree to the ',
  'cslOfferDialog.body3b': 'Referral Disclosure Agreement',
  'cslOfferDialog.rdaUrl': `${__BASEURL__}/documents/Referral_Disclosure_Canadian_Student_Living_EN.pdf`,
  goToDashboard: 'Go to dashboard',
  lifetime: ' lifetime',
  grantsRecieved: 'Grants received',
  'bonus&Referrals': 'Bonus & Referrals',
  'bonus&Referrals.description':
    'This is the total you’ve earned through special signup offers and by referring friends who opened an RESP with Embark. It includes all bonuses and referral rewards you’ve received since joining.',
  'cosubInvitation.header': 'has added you as a joint account holder',
  'cosubInvitation.body1': 'You’ve been invited as a joint account holder in',
  'cosubInvitation.body2': '’s RESP. It only takes a few minutes to accept.',
  joinResp: 'Join RESP',
  applicationInReview: 'Application in review',
  'applicationInReview.description':
    'We’re reviewing your info — this can take a few business days. You’ll get an email as soon as it’s approved.',
  'genesys.Chat.CTA': 'Chat',
  'genesys.Chat.CTA.alt': 'Talk to a human Icon',
  'respHome.plans.header': 'Plans',
  'respHome.plans.body.bold': 'Plan transfer in progress.',
  'respHome.plans.body':
    ' We’ll close your old plan once the transfer’s done (about 45–60 business days). Your pre-authorized contributions are now going to your new plan — you can start adding more anytime.',
  'respHome.plans.cta': 'Add a plan',
  'respHome.plans.alert.transfer': 'Transfer in progress',
  'respHome.plans.alert.review': 'Application in review',
  'respHome.plans.alert.actionRequired': 'Action required',
  'respHome.plans.alert.inProgress': 'In progress',
  'respHome.plans.type.familyConservative': 'Family conservative',
  'respHome.plans.type.familyGlidepath': 'Family glidepath',
  'respHome.plans.type.individualConservative': 'Individual conservative',
  'respHome.plans.type.individualGlidepath': 'Individual glidepath',
  'addChildOfferCard.title': 'Add a child, get $100',
  'addChildOfferCard.body':
    'When you grow your RESP plan, we grow it with you. Add a child and we’ll contribute $100.',
  'addChildOfferDialog.body.p1':
    'For every new child you add to your RESP plan before ',
  'addChildOfferDialog.body.date': 'August 25,',
  'addChildOfferDialog.body.p2':
    ' we’ll grow it with you. We’ll contribute $100 for their future, whether they’re brand new or just new to your plan.',
  'addChildOfferDialog.t&c.p1': '*Offer ends August 25. ',
  'addChildOfferDialog.t&c.p2': 'Terms & conditions',
  'addChildOfferDialog.t&c.p3': ' apply.',
  'addChildOfferDialog.t&c.link':
    'https://www.embark.ca/new-beneficiary-bonus-offer-terms-and-conditions',
  logout: 'Log out',
  selectedPlan: 'Selected plan',
  review: 'Review',
  saveAndContinue: 'Save and continue',
  saveAndExit: 'Save and exit',
  skipForNow: 'Skip for now',
  delete: 'Delete',
  brockUniversity: 'Brock University',
  carletonUniversity: 'Carleton University',
  dalhousieUniversity: 'Dalhousie University',
  macewanUniversity: 'Macewan University',
  memorialUniversityOfNewfoundland: 'Memorial University of Newfoundland',
  simonFraserUniversity: 'Simon Fraser University',
  torontoMetropolitanUniversity: 'Toronto Metropolitan University',
  universityCollegeOfTheFraserValley: 'University College of the Fraser Valley',
  universityOfAlberta: 'University of Alberta',
  universityOfBritishColumbiaSaunders:
    'University of British Columbia Saunders',
  universityOfBritishColumbia: 'University of British Columbia',
  universityOfCalgaryCummingSchoolOfMedicine:
    'University of Calgary Cumming School of Medicine',
  universityOfCalgary: 'University of Calgary',
  universityOfGuelphHumber: 'University of Guelph Humber',
  universityOfGuelph: 'University of Guelph',
  universityOfOttawa: 'University of Ottawa',
  universityOfTorontoMississauga: 'University of Toronto Mississauga',
  universityOfTorontoScarborough: 'University of Toronto Scarborough',
  universityOfTorontoWoodsworth: 'University of Toronto Woodsworth',
  universityOfVictoria: 'University of Victoria',
  universityOfWaterloo: 'University of Waterloo',
  universityOfWesternOntario: 'University of Western Ontario',
  wilfridLaurierUniversity: 'Wilfrid Laurier University',
  'brockUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Brock University.pdf`,
  'carletonUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Carleton University.pdf`,
  'dalhousieUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Dalhousie University.pdf`,
  'macewanUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Macewan University.pdf`,
  'memorialUniversityOfNewfoundland.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Memorial University of Newfoundland.pdf`,
  'simonFraserUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Memorial University of Newfoundland.pdf`,
  'torontoMetropolitanUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Toronto Metropolitan University.pdf`,
  'universityCollegeOfTheFraserValley.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University College of the Fraser Valley.pdf`,
  'universityOfAlberta.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Alberta.pdf`,
  'universityOfBritishColumbiaSaunders.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of British Columbia Saunders.pdf`,
  'universityOfBritishColumbia.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of British Columbia.pdf`,
  'universityOfCalgaryCummingSchoolOfMedicine.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Calgary Cumming School of Medicine.pdf`,
  'universityOfCalgary.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Calgary.pdf`,
  'universityOfGuelphHumber.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Guelph Humber.pdf`,
  'universityOfGuelph.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Guelph.pdf`,
  'universityOfOttawa.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Ottawa.pdf`,
  'universityOfTorontoMississauga.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Toronto Mississauga.pdf`,
  'universityOfTorontoScarborough.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Toronto Scarborough.pdf`,
  'universityOfTorontoWoodsworth.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Toronto Woodsworth.pdf`,
  'universityOfVictoria.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Victoria.pdf`,
  'universityOfWaterloo.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/UUniversity of Waterloo.pdf`,
  'universityOfWesternOntario.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Western Ontario.pdf`,
  'wilfridLaurierUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Wilfrid Laurier University.pdf`,
  'other.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Other_EN.pdf`,
  'onboardingPlanTypeOption.CTA.family': 'Get Family plan',
  'onboardingPlanTypeOption.CTA.individual': 'Get Individual plan',
  popular: 'Popular',
  icon: 'icon',
  'icon.alt.scotia': 'Scotiabank Icon',
  'icon.alt.rbc': 'RBC Icon',
  'icon.alt.bmo': 'BMO Icon',
  'icon.alt.cibc': 'CIBC Icon',
  'icon.alt.nationalbank': 'National bank Icon',
  'icon.alt.desjardins': 'desjardins Icon',
  'icon.alt.simplii': 'simplii Icon',
  'icon.alt.tangerine': 'tangerine Icon',
  governmentGrants: 'Government grants',
  accumulatedIncome: 'Accumulated income',
  'onboardingGateway.title': 'RESP ACCOUNT OPENING',
  'onboardingGoal.title': 'What do you want to achieve?',
  'onboardingGoal.description':
    'Select a goal from the options below or set your own plan',
  'onboardingPlanType.stepperHeader': 'Open an RESP',
  'onboardingBeneInfo.stepperHeader': 'Child profile',
  'onboardingCustomerProfile.stepperHeader': 'Customer profile',
  'onboardingInvestmentProfile.stepperHeader': 'Investment profile',
  'onboardingGrants.stepperHeader': 'Government grants',
  'onboardingSubscriberInfo.stepperHeader': 'Verify your identity',
  'onboardingSubscriberSIN.stepperHeader': 'Social Insurance Number',
  'onboardingReview.stepperHeader': 'Application review',
  'onboardingTermsAndCondition.stepperHeader': 'Terms and conditions',
  'coSubOnboardingRelationship.stepperHeader': 'Confirm your relationship',
  'coSubOnboardingReview.stepperHeader': 'Review your details',
  'coSubOnboardingReview.header': "Let's do a quick review",
  'onboarding.grants.headline.part1': 'You can receive up to ',
  'onboarding.grants.headline.part2': '$7,200*',
  'onboarding.grants.headline.part3': ' for each child over their lifetime.',
  'onboardingTermsAndCondition.headline':
    'Please review the terms and conditions',
  'onboardingTermsAndCondition.description':
    'A copy of all agreements will be available for your reference under account settings.',
  'onboardingTermsAndCondition.eaa.description1':
    'I have read and agree to the',
  'onboardingTermsAndCondition.eaa.description2':
    'I understand that this document serves as my plan contract and includes the Prospectus, which outlines all product details, costs, risks and benefits',
  'onboardingTermsAndCondition.eaa.link':
    'Education Savings Plan Agreement, Acknowledgements and Prospectus',
  'onboardingPlanType.headline': 'Which plan fits you best?',
  'onboardingPlanType.label': 'RESP plan type',
  'onboardingPlanType.headline.addAPlan': 'Select an RESP plan type',
  'onboardingPlanTypeOption.individual.label': 'Individual Plan',
  'onboardingPlanTypeOption.individual.helperList.item1':
    'Anyone can be a subscriber',
  'onboardingPlanTypeOption.individual.helperList.item2':
    'Savings for a single beneficiary',
  'onboardingPlanTypeOption.individual.helperList.item3':
    'Grants and income are not shareable',
  'onboardingPlanType.helper.title': 'All plans include:',
  'onboardingPlanType.helper.text1': 'No upfront fees or hidden costs',
  'onboardingPlanType.helper.text2': 'Management free (MER)*: 1.65% plus tax',
  'onboardingPlanType.helper.text3':
    'Asset mix personalized to age of each child',
  'onboardingPlanType.helper.text4':
    'Low to medium-risk portfolio with trusted partners administering the plan',
  'onboardingPlanType.helper.text4.subtext1.part1': 'ScotiaBank',
  'onboardingPlanType.helper.text4.subtext1.part2': 'Trustee & Depository',
  'onboardingPlanType.helper.text4.subtext2.part1': 'RBC',
  'onboardingPlanType.helper.text4.subtext2.part2': 'Custodian',
  'onboardingPlanType.helper.text4.subtext3.part1': 'BMO',
  'onboardingPlanType.helper.text4.subtext3.part2': 'Investment manager',
  'onboardingPlanType.helper.text5':
    'Access to all applicable grants (CESG, ACESG, CLB, BCTESG, QESI)',
  'onboardingPlanTypeOption.family.label': 'Family Plan',
  'onboardingPlanTypeOption.family.subheading':
    'Recommended for parents, grandparents, or siblings of the child(ren) you are saving for, or to combine individual RESPs',
  'onboardingPlanTypeOption.family.helperList.item1':
    'Can be opened for one or more children who are siblings by blood or adoption, with the option to add siblings later',
  'onboardingPlanTypeOption.family.helperList.item2':
    'Children can share grants and investment income',
  'onboardingPlanTypeOption.V2.family.label': 'Family plan',
  'onboardingPlanTypeOption.V2.family.subheading': 'RESP savings in one place.',
  'onboardingPlanTypeOption.V2.family.note':
    '*Up to a maximum of $7,200 of CESG',
  'onboardingPlanTypeOption.V2.family.helperList.item1.title': 'Shared savings',
  'onboardingPlanTypeOption.V2.family.helperList.item1.description':
    'Your children can share contributions, grants* and income.',
  'onboardingPlanTypeOption.V2.family.helperList.item2.title': 'Family-focused',
  'onboardingPlanTypeOption.V2.family.helperList.item2.description':
    'Ideal for parents or grandparents saving for their children or grandchildren.',
  'onboardingPlanTypeOption.V2.family.helperList.item3.title': 'Add siblings',
  'onboardingPlanTypeOption.V2.family.helperList.item3.description':
    'Add or change siblings (related by blood or adoption) as your family grows.',
  'onboardingPlanTypeOption.V2.individual.label': 'Individual plan',
  'onboardingPlanTypeOption.V2.individual.subheading':
    'For one child at a time.',
  'onboardingPlanTypeOption.V2.individual.helperList.item1.title':
    'Child does not have to be related',
  'onboardingPlanTypeOption.V2.individual.helperList.item1.description':
    'Ideal for aunts, uncles, or other unrelated individuals.',
  'onboardingPlanTypeOption.V3.family.label': 'Family plan',
  'onboardingPlanTypeOption.V3.family.subheading': 'Top features:',
  'onboardingPlanTypeOption.V3.family.helperList.item1.title': 'Shared savings',
  'onboardingPlanTypeOption.V3.family.helperList.item1.description':
    'Your children can share contributions, grants and income. Up to a maximum of $7,200 of Canada Education Savings Grant (CESG).',
  'onboardingPlanTypeOption.V3.family.helperList.item2.title':
    'For parents or grandparents',
  'onboardingPlanTypeOption.V3.family.helperList.item2.description':
    'Ideal for parents or grandparents saving for their children or grandchildren (children in the plan must related by blood or adoption).',
  'onboardingPlanTypeOption.V3.family.helperList.item3.title':
    'Easily add siblings',
  'onboardingPlanTypeOption.V3.family.helperList.item3.description':
    'Add or change siblings (related by blood or adoption) as your family grows.',
  'onboardingPlanTypeOption.V3.individual.label': 'Individual plan',
  'onboardingPlanTypeOption.V3.individual.subheading': 'Top feature:',
  'onboardingPlanTypeOption.V3.individual.helperList.item1.title':
    'You do not need to be directly related to the child.',
  'onboardingPlanTypeOption.V3.individual.helperList.item1.description':
    'Ideal for aunts, uncles, or other non-relatives.',
  'onboardingPlanType.V3.helper.title': 'All plans include:',
  'onboardingPlanType.V3.helper.text1': 'No upfront fees or hidden costs',
  'onboardingPlanType.V3.helper.text2': 'Highly competitive management fees',
  'onboardingPlanType.V3.helper.text3':
    'Customized asset allocation based on the age of each child',
  'onboardingPlanType.V3.helper.text4':
    'Access to all applicable governement grants up to $12,800*',
  'onboardingPlanType.V3.helper.text5':
    'Trusted partners that hold and manage all your funds',
  'onboardingPlanType.V3.helper.text5.subtext1.part1': 'ScotiaBank',
  'onboardingPlanType.V3.helper.text5.subtext1.part2': 'Trustee & Depository',
  'onboardingPlanType.V3.helper.text5.subtext2.part1': 'RBC',
  'onboardingPlanType.V3.helper.text5.subtext2.part2': 'Custodian',
  'onboardingPlanType.V3.helper.text5.subtext3.part1': 'BMO',
  'onboardingPlanType.V3.helper.text5.subtext3.part2': 'Investment manager',
  'onboardingPlanType.V3.footer':
    '*The lifetime limit of $12,800 per child is subject to variations based on eligibility criteria and the province of residence. Actual grant amounts may differ.',
  'onboardingPlanType.howRESPWork.link': 'How your RESP works',
  'onboardingPlanType.howRESPWork.title': 'How your RESP works',
  'onboardingPlanType.howRESPWork.sectionOne.header':
    'Here’s what makes it one of the smartest ways to save for education:',
  'onboardingPlanType.howRESPWork.sectionOne.listItem1.header':
    'Free government money',
  'onboardingPlanType.howRESPWork.sectionOne.listItem1.description':
    'Get up to $500 a year in grants just for contributing. Plus, your savings grow tax-free.',
  'onboardingPlanType.howRESPWork.sectionOne.listItem2.header':
    'School flexibility',
  'onboardingPlanType.howRESPWork.sectionOne.listItem2.description':
    'Use your RESP for full-time or part-time studies—college, university, trades, or apprenticeships in Canada or abroad.',
  'onboardingPlanType.howRESPWork.sectionOne.listItem3.header':
    'Low, transparent fees',
  'onboardingPlanType.howRESPWork.sectionOne.listItem3.description':
    '1.65% management fee (MER), plus tax. That’s it.',
  'onboardingPlanType.howRESPWork.sectionOne.listItem4.header':
    'Investment strategy built for students',
  'onboardingPlanType.howRESPWork.sectionOne.listItem4.description':
    'A portfolio designed to help protect your savings as school approaches.',
  'onboardingPlanType.howRESPWork.sectionTwo.header': 'Contribution limit:',
  'onboardingPlanType.howRESPWork.sectionTwo.listItem1.description':
    'Save up to $50,000 per child (check your plan details for specifics)',
  'onboardingPlanType.howRESPWork.sectionThree.header': 'What it covers:',
  'onboardingPlanType.howRESPWork.sectionThree.description':
    'Tuition, books, rent, groceries, supplies—even transportation and personal costs.',
  'onboardingPlanType.howRESPWork.sectionFour.headerOne':
    'Not using it right away?',
  'onboardingPlanType.howRESPWork.sectionFour.headerTwo':
    'No problem—you’ve got options:',
  'onboardingPlanType.howRESPWork.sectionFour.listItem1':
    'Keep it growing for up to 35 years',
  'onboardingPlanType.howRESPWork.sectionFour.listItem2':
    'Transfer to another child',
  'onboardingPlanType.howRESPWork.sectionFour.listItem3':
    'Move up to $50,000 into your RRSP (if you have room)',
  'onboardingPlanType.howRESPWork.sectionFour.listItem4':
    'Withdraw it as income later (called an AIP)',
  'onboardingPlanType.howRESPWork.footer':
    '*Withdrawn accumulated income is taxable, subject to a 20% federal tax (12% for Quebec residents), or can be transferred to an RRSP, up to $50,000 per subscriber (based on RRSP contribution room and tax regulations).',
  'onboardingGrants.grantSelection.headline': 'What province are you in?',
  'onboardingGrants.grantSelection.description':
    "We'll apply for these grants on your behalf.",
  'onboardingGrants.grants.headline': 'Government grants available to you:',
  'onboardingGrants.footer':
    '*The lifetime limit of $7,200 per child is subject to variations based on eligibility criteria and the province of residence. Actual grant amounts may differ.',
  'onboardingGrants.howRespWorks.link': 'Learn more about grants',
  'onboardingGrants.howRespWorks.title': 'Learn more about grants',
  'onboardingGrants.howRESPWork.sectionOne.header':
    'Canada Education Savings Grant (CESG)',
  'onboardingGrants.howRESPWork.sectionOne.listItem1.span': 'Lifetime maximum:',
  'onboardingGrants.howRESPWork.sectionOne.listItem1': '$7,200',
  'onboardingGrants.howRESPWork.sectionOne.listItem2.span': 'Annual grant:',
  'onboardingGrants.howRESPWork.sectionOne.listItem2':
    '20% on the first $2,500 contributed',
  'onboardingGrants.howRESPWork.sectionOne.listItem3.span': 'Additional CESG:',
  'onboardingGrants.howRESPWork.sectionOne.listItem3':
    'Up to 10% or 20% on the first $500 contributed, based on income',
  'onboardingGrants.howRESPWork.sectionOne.listItem4.span': 'Availability:',
  'onboardingGrants.howRESPWork.sectionOne.listItem4':
    'Until the end of the year your child turns 17',
  'onboardingGrants.howRESPWork.sectionTwo.header':
    'Canada Learning Bond (CLB)',
  'onboardingGrants.howRESPWork.sectionTwo.listItem1.span': 'Provides:',
  'onboardingGrants.howRESPWork.sectionTwo.listItem1':
    'Up to $2,000 for eligible children born in 2004 or later',
  'onboardingGrants.howRESPWork.sectionTwo.listItem2.span': 'Eligibility:',
  'onboardingGrants.howRESPWork.sectionTwo.listItem2':
    'Families meeting income limits',
  'onboardingGrants.howRESPWork.sectionTwo.listItem3.span':
    'Application deadline:',
  'onboardingGrants.howRESPWork.sectionTwo.listItem3':
    'The beneficiary must be under the age of 21 at the time of application',
  'onboardingGrants.howRESPWork.sectionThree.header':
    'British Columbia Training and Education Savings Grant',
  'onboardingGrants.howRESPWork.sectionThree.listItem1.span': 'Grant:',
  'onboardingGrants.howRESPWork.sectionThree.listItem1':
    '$1,200 for residents of British Columbia',
  'onboardingGrants.howRESPWork.sectionThree.listItem2.span':
    "Child's eligibility:",
  'onboardingGrants.howRESPWork.sectionThree.listItem2':
    'Born on or after January 1, 2006',
  'onboardingGrants.howRESPWork.sectionThree.listItem3.span':
    'Application period:',
  'onboardingGrants.howRESPWork.sectionThree.listItem3':
    "Between the child's 6th and 9th birthdays",
  'onboardingGrants.howRESPWork.sectionFour.header':
    'Quebec Education Savings Incentive (QESI)',
  'onboardingGrants.howRESPWork.sectionFour.listItem1.span':
    'Lifetime maximum:',
  'onboardingGrants.howRESPWork.sectionFour.listItem1': '$3,600 per child',
  'onboardingGrants.howRESPWork.sectionFour.listItem2.span':
    'Potential earnings:',
  'onboardingGrants.howRESPWork.sectionFour.listItem2':
    'Up to $3,600 per child',
  'onboardingGrants.howRESPWork.sectionFour.listItem3.span': 'Annual grant:',
  'onboardingGrants.howRESPWork.sectionFour.listItem3':
    '10% of RESP contributions, up to $250 per year',
  'onboardingGrants.howRESPWork.footer':
    'Eligibility requirements apply. Please visit our current Embark Student Plan Prospectus for full details.',
  'onboardingGateway.requirementsTitle3': "You'll need the following:",
  'onboardingGateway.requirementItem6': 'A Canadian resident',
  'onboardingGateway.requirementItem7':
    'Social insurance number (SIN) for you and your child, as per CRA requirements',
  'onboardingGateway.requirementItem8':
    'Personal information for you and your child',
  'onboardingGateway.cosub.requirementItem7':
    'Your social insurance number (SIN)',
  'onboardingGateway.cosub.requirementItem8': 'Your personal information',
  'onboardingGateway.requirementItem9':
    'If applicable, co-subscriber’s email and legal name',
  'onboardingGateway.promoTitle': 'Have an advisor code or promo code?',
  'onboarding.popup.whyDoWeAsk.label': 'Why do we ask this?',
  'onboarding.popup.whyDoWeAsk.content':
    'Canadian regulators require us to collect this information as part of our Know Your Client (KYC) obligations. Your data is safe and never leaves Embark.',
  'onboardingMoneyQuestion.header': "Let's dive into some questions",
  'onboardingMoneyQuestion.info':
    'We are required by government regulations to ask some personal questions to determine the best fit for you. This is standard practice for all investment providers in Canada.',
  'onboardingBalancingBenefit.title.line.firstWord': "Embark Student Plan's",
  'onboardingBalancingBenefit.title.line': ' automatic rebalancing',
  'onboardingBalancingBenefit.description':
    'We invest strategically for maximum growth in the early years, helping your savings grow faster.',
  'onboardingBalancingBenefit.slider.label': "Child's age",
  'onboardingBalancingBenefit.chart.label.equity': 'Equity',
  'onboardingBalancingBenefit.chart.label.fixedIncome': 'Fixed Income',
  'onboardingBalancingBenefit.chart.label.yearsOld': 'years old',
  'onboardingBalancingBenefit.chart.label.yearOld': 'year old',
  'onboardingBeneficiaries.stopAndResume.sinHeadline.child':
    "For tax and grant purposes, we need your SIN and your child's SIN to be included in the RESP plan.",
  'onboardingBeneficiaries.stopAndResume.sinHeadline.children':
    "For tax and grant purposes, we need your SIN and your children's SIN to be included in the RESP plan.",
  'addPlan.sinHeadline.child':
    "For tax and grant purposes, we need your child's SIN to be included in the RESP plan.",
  'addPlan.sinHeadline.children':
    "For tax and grant purposes, we need your children's SIN to be included in the RESP plan.",
  'onboardingBeneficiaries.stopAndResume.headline.addAPlan':
    'For tax and grant purposes, we need your child’s SIN to be included in the RESP plan.',
  'onboardingBeneficiarySIN.old.headlinePart1': "What's ",
  'onboardingBeneficiarySIN.old.headlinePart2':
    ' social insurance number (SIN)?',
  'onboardingBeneficiarySIN.infoGuide1.primary':
    'Don’t have a Social Insurance Number (SIN)?',
  'onboardingBeneficiarySIN.infoGuide1.primary.note':
    "Your progress will be saved, and you can come back whenever you're ready. ",
  'onboardingBeneficiarySIN.infoGuide2.primary': 'Here’s how to get a SIN.',
  'onboardingBeneficiarySIN.V2.headline.1': '',
  'onboardingBeneficiarySIN.V2.headline.2':
    "'s Social Insurance Number (SIN) is required by Employment and Social Development Canada (ESDC) to apply for government grants.",
  'onboardingBeneficiarySIN.V2.footer.title':
    'Don’t have a Social Insurance Number (SIN)?',
  'onboardingBeneficiarySIN.V2.footer.description.1':
    "Your progress will be saved, and you can come back whenever you're ready. ",
  'onboardingBeneficiarySIN.V2.footer.description.1.link':
    'https://www.canada.ca/en/employment-social-development/services/sin/apply.html',
  'onboardingBeneficiarySIN.V2.footer.description.2':
    'Here’s how to get a SIN.',
  'onboardingPersonalSIN.headline':
    "What's your social insurance number (SIN)?",
  'digitalAccessPersonalInfo.headline': 'Let’s confirm your details',
  'onboardingSubscriberInfo.headline': 'Tell us about yourself',
  'onboardingSubscriberInfo.governmentName':
    'The name on your government-issued ID.',
  'onboardingSubscriberInfo.MobileNumberHeader': 'Mobile number',
  'onboardingSubscriberInfo.MobileNumber': 'Mobile number',
  'onboardingNewGrants.headline.one': 'You can receive up to ',
  'onboardingNewGrants.headline.two': ' for each child over their lifetime.*',
  'onboardingNewGrants.description':
    "Maximize your RESP savings with tax-deferred government grants. We'll apply for these grants on your behalf.",
  'onboardingNewGrants.grants.heading': 'Government grants you may qualify for',
  'onboardingNewGrants.grants.note':
    '*The lifetime limit of $12,800 per child is subject to variations based on eligibility criteria and the province of residence. Actual grant amounts may differ.',
  'onboardingNewGrants.grants.upTo': 'Up to',
  'onboardingNewGrants.grants.perLifetimePerChild': 'per lifetime per child',
  'onboardingNewGrants.grants.perYearPerChild': 'per year per child',
  'onboardingNewGrants.grants.perChild': 'per child',
  'onboardingNewGrants.grants.perYearPerRESP': 'per year per RESP',
  'onboardingNewGrants.grants.CESG': 'Canadian Education Savings Grant (CESG)',
  'onboardingNewGrants.grants.CESG.link':
    'https://www.canada.ca/en/services/benefits/education/education-savings/savings-grant.html',
  'onboardingNewGrants.grants.CLB': 'Canada Learning Bond (CLB)',
  'onboardingNewGrants.grants.CLB.link':
    'https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/registered-education-savings-plans-resps/canada-education-savings-programs-cesp/canada-learning-bond.html',
  'onboardingNewGrants.grants.ACESG':
    'Additional Canadian Education Savings Grant (ACESG)',
  'onboardingNewGrants.grants.ACESG.link':
    'https://www.canada.ca/en/services/benefits/education/education-savings/savings-grant/amount.html',
  'onboardingNewGrants.grants.BCTESG':
    'British Columbia Training and Education Savings Grant (BCTESG)',
  'onboardingNewGrants.grants.BCTESG.link':
    'https://www2.gov.bc.ca/gov/content/education-training/k-12/support/scholarships/bc-training-and-education-savings-grant',
  'onboardingNewGrants.grants.QESI':
    ' Quebec Education Savings Incentive (QESI)',
  'onboardingNewGrants.grants.QESI.link':
    'https://www.revenuquebec.ca/en/citizens/tax-credits/quebec-education-savings-incentive/',
  'onboardingSINSection.title': 'SIN',
  'onboardingSINSection.title-plural': 'SINs',
  'onboardingSIN.primary.headline':
    'Your Social Insurance Number is required to open an RESP with the CRA and apply for grants',
  'digitalAccessSIN.alt': 'Notification Icon',
  'digitalAccessSIN.headline': 'Confirm your Social Insurance Number (SIN)',
  'digitalAccessSIN.description':
    'Your SIN is required to confirm your ID for tax purposes.',
  'digitalAccessSIN.note':
    'Your SIN (Social Insurance Number) is protected and securely encrypted.',
  'onboardingSIN.SINLabel': 'What’s your social insurance number (SIN)?',
  'Onboarding.onboardingSubscriberSIN.V2.headline':
    'Your Social Insurance Number (SIN) is required by Canada Revenue Agency (CRA) to open an RESP and get government grants',
  'CosubOnboarding.onboardingSubscriberSIN.V2.headline':
    'We need your Social Insurance Number (SIN) to add you as a joint account holder on this RESP and to meet the requirements set by the Canada Revenue Agency (CRA).',
  'onboardingSubscriberSIN.V2.input.label': 'Your Social Insurance Number',
  'onboardingChildDetails.addAnotherChild': 'Add another child',
  'onboardingChildsDetails.infoTitle':
    "You've already completed the following child profiles:",
  'onboardingChildsDetails.sameAddress':
    'All children in this plan live with me.',
  'onboardingChildsDetails.sameAddress.singleBene':
    'The child in this plan lives with me.',
  'onboardingChildsDetails.V2.headlineFirst': 'First child',
  'onboardingChildsDetails.V2.headlineSecond': 'Second child',
  'onboardingChildsDetails.V2.headlineThird': 'Third child',
  'onboardingChildsDetails.V2.headlineFourth': 'Fourth child',
  'onboardingChildsDetails.V2.genderInfo':
    "Please ensure that the selected gender matches the child's official government ID.",
  'onboardingChildsDetails.relationship.headline': 'How are you related?',
  'onboardingChildsDetails.relationship.headline.singleBene':
    "What's your relationship?",
  'onboardingChildsDetails.relationship.description':
    'If you are adding multiple children, your relationship to them must be the same. If your relationship to one or more of the children is different, you will need to open a separate plan for those children.',
  'onboardingChildRelationshipDropdown.label': 'Relationship',
  'onboardingChildsDetails.selectRelationshipError':
    'Please select the relationship.',
  'deleteChildDialog.title':
    "Are you sure you want to delete this child's profile?",
  'deleteChildDialog.description':
    'This profile will be deleted immediately. You can’t undo this action.',
  'newOnboardingMoneyQuestion.Header': 'A plan that’s right for you',
  'newOnboardingMoneyQuestion.info':
    "We've got a few RESPs to offer and need to ask some money-related questions to determine the best fit for you. This is standard practice for all investment providers in Canada.",
  'onboardingThirdParty.label': 'Third party contributor',
  'onboardingThirdParty.headline': 'Will you have a third party contributor?',
  'onboardingThirdParty.description':
    "If there's someone else you would like to contribute to this account, we'll need to book an appointment with you to get their details.",
  'onboardingThirdParty.bookAppointmentTitle': 'Please book an appointment',
  'onboardingThirdParty.bookAppointmentDescription1':
    'Reasons why with a third party contributor would have to book an appointment, please',
  'onboardingThirdParty.bookAppointmentDescription2': 'contact us',
  'onboardingThirdParty.bookAppointmentDescription3': 'directly for support.',
  'onbaordingInvestingExperience.standalonekyc.riskProfileHeader':
    'Risk profile',
  'onbaordingInvestingExperience.standalonekyc.infoPopupHeader':
    'What is a risk profile?',
  'onbaordingInvestingExperience.standalonekyc.infoPopupContent':
    'Risk Tolerance (a customer’s willingness to accept risk) and Risk Capacity (a customer’s ability to endure potential financial loss) are separate considerations that together make up the overall Risk Profile. The Risk Profile of a customer reflects the lower of the two.',
  'onboardingRiskProfile.standalonekyc.familyPlan': 'Family Plan',
  'onboardingRiskProfile.standalonekyc.individualPlan': 'Individual Plan',
  'onbaordingRiskProfile.standalonekyc.separator': 'for',
  'onbaordingRiskProfile.standalonekyc.confirmButton': 'Confirm details',
  'onboarding.sin.whyWeAsk.popUp.header': 'Why do we need this?',
  'onboarding.sin.whyWeAsk.popUp.title': 'Social Insurance Number',
  'onboarding.sin.whyWeAsk.popUp.content':
    'Employment and Social Development Canada (ESDC) requires your Social Insurance Number (SIN) to effectively support your grant applications. This is crucial for accurately processing government grants on your behalf.',
  'onboardingHouseholdNetWorth.old.headline1':
    'Tell us about your assets and liabilities',
  'estimatedAmount.error': 'Enter an amount.',
  'onboardingHouseholdNetWorth.old.header1': 'What are your total assets?',
  'onboardingHouseholdNetWorth.old.header2': 'What are your total liabilities?',
  'onboardingAlmostThere.headline': "You're almost there!",
  'onboardingAlmostThere.text':
    'Just a few more questions to help us determine your risk score.',
  middleNameOptional: 'Middle name (optional)',
  beneFirstNameRequiredError:
    'The name on their birth certificate or social insurance number.',
  beneLastNameRequiredError:
    'The name on their birth certificate or social insurance number.',
  SINPersonalDuplicatedError: 'Duplicate SIN records found.',
  'Onboarding.primary.SIN': 'Your Social insurance number',
  'mobileNumber.V2.message.1': 'Is this the right mobile number?',
  'mobileNumber.V2.message.2':
    'We’ll send a text message with a code to this number for security and login verification.',
  ensureBeneSameRelationship:
    'The selected relationship for each child must be the same. If the relationship with the child is different, you will need to open a separate plan for them.',
  askMeLater: 'Ask me later',
  invalidStreetNameLength: 'Please enter 40 characters or less.',
  invalidCityLength: 'Please enter 30 characters or less.',
  stateProvinceLabel: 'State/Province',
  countryLabel: 'Country',
  'signOut.alt': 'Sign out Icon',
  'editInPlaceRadioCardsSelect.submitBtnLabel': 'Update',
  'editInPlaceRadioCardsSelect.editBtnLabel': 'Edit',
  'bookAppointmentReason.noMatchingRecord':
    'Conversion customer tried to get digital access but no matching record found.',
  'bookAppointmentReason.nonCanadianResident':
    'PSE withdrawal; student is a non-resident.',
  'bookAppointmentReason.idLastname': 'Last name on ID does not match.',
  'bookAppointmentReason.idDob': 'Date of birth on ID does not match.',
  'addACosub.alreadyExistError':
    'A co-subscriber is already on file. You can add only one co-subscriber to your plan.',
  'navigation.transferRESP': 'Transfer an RESP',
  'navigation.sendAGift': 'Embark Gifting',
  'makeContribution.missingProduct.noProductDescription':
    "You'll need to add an RESP account to contribute funds easily.",
  makeAContribution: 'Make a contribution',
  'amount.colon': 'Amount:',
  estimatedAmount: 'Estimated amount',
  'missingProduct.noProductHeader': "You don't have an RESP product.",
  'missingProduct.noProduct': 'No RESP product',
  addMoney: 'Add money',
  'planTransferAlert.header': 'Plan Transfer in Progress',
  'planTransferAlert.info':
    "Your plan transfer is in progress. During this time, you won't be able to contribute to your old plan. Once the transfer is complete, your old plan will be closed.",
  'planTransferAlert.ErrorIcon.alt': 'Error Icon',
  'contributionSuccess.exclusiveOffers': 'Exclusive offers',
  'contributionSuccess.continueOffers': 'Continue with offer',
  promoCode: 'Promo code',
  promoCodeOrReferralCode: 'Promo or referral code',
  'promoInput.placeholder': 'Optional',
  'promoInput.characterLimits': 'Please enter 20 characters or less.',
  'promoInputWfg.success': 'WFG advisor code applied!',
  'addABeneficiary.selectPlan.info.alt': 'Info Icon',
  'addABeneficiary.selectPlan.info.descriptionOne':
    'Individual plans can only have one child. To add a beneficiary to a family plan with four or more children, please call us at ',
  'addABeneficiary.selectPlan.info.descriptionTwo': '.',
  'addABeneficiary.selectPlan.info.descriptionPhone': '1-800-363-7377',
  'addABeneficiary.redirectError.header':
    'Sorry, we’re unable to add another child to this plan',
  'addABeneficiary.redirectError.fifthBene.description.first':
    'To add a child, please get in touch with us at ',
  'addABeneficiary.redirectError.fifthBene.description.phone': '1-800-363-7377',
  'addABeneficiary.redirectError.fifthBene.description.second':
    ', or open an additional family or individual plan.',
  'addABeneficiary.redirectError.indDescription1.first':
    'Under the Canada Revenue Agency (CRA) and the Employment and Social Development Canada (ESDC) guidelines, you can have only one beneficiary for your individual RESP.',
  'addABeneficiary.redirectError.indDescription1.second':
    'To start saving for your new beneficiary, open a new plan.',
  'addABeneficiary.redirectError.CTA': 'Open a new plan',
  'cannotContinue.indFifthBene.header':
    'Sorry, you cannot add a beneficiary to this plan',
  'cannotContinue.indFifthBene.items.header':
    'Additional beneficiaries cannot be added due to one of the following reasons:',
  'cannotContinue.indFifthBene.item.one':
    'Your individual RESP can only have one beneficiary',
  'cannotContinue.indFifthBene.item.two':
    'Your family RESP already has four beneficiaries, and more cannot be added digitally. Please contact us if you would like to add more',
  'cannotContinue.indFifthBene.description1':
    'If you want to add more than one beneficiary, you may consider opening a new family plan or another individual one.',
  'cannotContinue.indFifthBene.description2':
    'To start saving for your new beneficiary, you’ll need answer a few quick questions. Get started below.',
  'cannotContinue.indFifthBene.description3': 'Estimated time 5-10 minutes',
  'cannotContinue.indFifthBene.CTA': 'Open a new plan',
  'cannotContinue.existingCoSub.header':
    'Sorry, your current plan already has a co-subscriber',
  'cannotContinue.existingCoSub.description':
    'Please note that you can only add one co-subscriber to each plan.',
  'cannotContinueNoVerification.additionalInfoDescription1':
    'We need additional information.',
  'cannotContinue.pendingApplicationHeader':
    'You currently have an application pending',
  'cannotContinue.pendingApplicationDescription':
    'This process may take a few business days. You’ll receive an email once your request is approved. After that, you’ll be able to add another RESP.',
  'cannotContinue.goToDashboard': 'Go to dashboard',
  'onboardingBookAppointment.bookAppointment': 'Book an appointment',
  'onboardingBookAppointment.moreInfo': 'Need more information?',
  'onboardingBookAppointment.getInTouch': 'Get in touch ',
  'onboardingBookAppointment.customerServiceTeam':
    'with our customer service team',
  'cannotContinue.previousResponse.header':
    "Sorry, based on your previous response, you can't continue digitally",
  'cannotContinue.previousResponse.description':
    'Please call us at 1-800-363-7377 or chat with us online to continue.',
  'cannotContinue.withdrawalHeader':
    "We're unable to submit your withdrawal request",
  'cannotContinue.withdrawalAdditionalInfoDescription1':
    'You can update your banking information by accessing your Embark account at any time.',
  'cannotContinue.withdrawalSubHeader': 'Our team is here to help! To proceed,',
  'cannotContinue.withdrawalDescription1': 'Fill out this ',
  'cannotContinue.withdrawalDescription1.Link': 'withdrawal form',
  'cannotContinue.withdrawalDescription1.Link.Document': `${__STUDENT_SERVICES_URL__}/documents/Educational-Withdrawal-Form-Embark (1).pdf`,
  'cannotContinue.withdrawalDescription2':
    'Email your form and your Verification of Enrollment to ',
  'cannotContinue.withdrawalDescription2.Email': 'withdrawals@embark.ca',
  'cannotContinue.withdrawalAdditionalInfoDescription2':
    'Mon - Thu: 9:00am - 8:00pm EST',
  'cannotContinue.withdrawalAdditionalInfoDescription3':
    'Fri: 9:00am to 6:00pm EST',
  'cannotContinue.termsNotSigned':
    'Sorry, this service request cannot be submitted',
  'cannotContinue.descriptionTermsNotSigned':
    'The service request cannot be submitted as the customer has not signed their plan terms and conditions.',
  'cannotContinue.nonCanadian.header': 'Sorry, you can’t continue digitally',
  'cannotContinue.nonCanadian.additionalInfoDescription1': 'As ',
  'cannotContinue.nonCanadian.additionalInfoDescription2':
    ' is a non-resident, we need additional information for this withdrawal.',
  'cannotContinue.nonCanadian.additionalInfoDescription3':
    'Don’t worry, our agents will assist you. Please call us at 1-800-363-7377 or chat with us online to continue. ',
  'onboardingRiskProfile.descriptionHeaderAllCode':
    ' for this Embark Student Plan',
  'onboardingRiskProfile.descriptionHeaderPlanChange':
    ' and aligns with the Embark Student Plan',
  'onboardingRiskProfile.descriptionHeaderLowCode':
    ' for this Embark Select Conservative Plan',
  'onboardingRiskProfile.descriptionHeaderEnd':
    ' and aligns with the Embark Select Conservative Plan',
  'onboardingRiskProfile.lowProfileSettings':
    'The Embark Select Conservative Plan has the same digital benefits and fees as the Embark Student Plan but has a more conservative investment approach which aligns with your Low risk profile.',
  'onboardingRiskProfile.NotlowProfileSettings1':
    'The Embark Student Plan has the same digital benefits and Fees as the Embark Select Conservative Plan but has the glidepath investment approach where investments are tailored to each child’s age and time to graduation. This plan has some more risk but higher potential returns, which aligns with your ',
  'onboardingRiskProfile.NotlowProfileSettings2': ' risk profile.',
  'onboardingRiskProfile.lowProfileNote1': 'Click ',
  'onboardingRiskProfile.lowProfileNote2': '“Continue”',
  'onboardingRiskProfile.lowProfileNote3': ' to learn more',
  'onboardingRiskProfile.redo.btn': 'Redo questionnaire',
  'onboardingRiskProfile.noticeHeader':
    'Notice for Embark Select Conservative Plan',
  'onboardingRiskProfile.noticeItem1':
    'The Embark Select Conservative Plan has a more conservative investment approach',
  'onboardingRiskProfile.noticeItem2':
    'Savings will be invested with a fixed asset mix (25% equity, 75% fixed income) until around the year the child turns 18',
  'onboardingRiskProfile.noticeItem3':
    'Around 18, your investments will move into a Graduation fund focused on preserving your savings',
  'onboardingRiskProfile.noticeItem4.part1':
    'For more information, review the ',
  'onboardingRiskProfile.noticeItem4.part2':
    'Embark Select Conservative Plan prospectus',
  'onboardingRiskProfile.noticeItem4.part3':
    ' or book an appointment to speak with an Education Savings Specialist',
  'onboardingRiskProfile.noticeItem5.part1':
    'To continue with the Embark Select Conservative Plan, click ',
  'onboardingRiskProfile.noticeItem5.part2': '“I accept”',
  'onboardingRiskProfile.noticeItem5.part3':
    ' or decline and redo your questionnaire',
  'onboardingRiskProfile.noticeAcceptButton': 'I accept',
  'educationSavings.remindCoSubDialog.title':
    'Invite your joint account holder to activate their digital account',
  'educationSavings.remindCoSubDialog.whyThisMatters': 'Why this matters:',
  'educationSavings.remindCoSubDialog.whyThisMattersBody':
    "For your joint account holder to get full access to Embark, they need to sign up. We'll send them an email to guide them on how to register with us.",
  'educationSavings.remindCoSubDialog.whyThisMattersNote1': 'Note: ',
  'educationSavings.remindCoSubDialog.whyThisMattersNote2':
    'The joint account holder must be a spouse, or common-law partner.',
  'educationSavings.remindCoSubDialog.whatYouNeedToDo': 'What you need to do:',
  'educationSavings.remindCoSubDialog.whatYouNeedToDoStep1':
    'Enter their email to send a reminder.',
  'educationSavings.remindCoSubDialog.whatYouNeedToDoStep2':
    'They will receive an email with instructions to finish setting up their account.',
  invite: 'Invite',
  'addPlanIDVGateway.intro':
    'Before you open a new plan, we just need to verify your identity. This is required by our regulators, the Financial Transactions and Reports Analysis. Centre of Canada (FINTRAC) since you didn’t complete this step when signing up.',
  'addPlanIDVGateway.time':
    'It only takes about 2 minutes, and you’ll only need to do it once.',
  'addPlanIDVGateway.documents': 'Have one of these ready:',
  'addPlanIDV.verficiation.fail.title': 'Verification failed',
  'addPlanIDV.verficiation.fail.body':
    'Your identity verification was unsuccessful. Please try again or contact us at ',
  'addPlanIDV.verficiation.fail.body.phone': '1-800-363-7877.',
  'onboardingIDVGateway.title': 'Prepare your documents',
  'onboardingIDVGateway.missingId.addBene':
    "Before you can add a child to this plan, we just need to verify your identity. This is required by our regulators, the Financial Transactions and Reports Analysis Centre of Canada (FINTRAC) since you didn't complete this step when signing up.",
  'onboardingIDVGateway.missingId.minutes':
    'It only takes about 2 minutes, and you’ll only need to do it once.',
  'onboardingIDVGateway.missingId.listTitle': 'Have one of these ready:',
  'onboardingIDVGateway.note':
    'Don’t have everything on hand? We’ll make sure to save your progress.',
  'onboardingIDVGateway.list.title':
    'Have one of the following documents ready for ID verification:',
  'onboardingIDVGateway.list.1.text': 'Driver’s license',
  'onboardingIDVGateway.list.2.text': 'Passport',
  'onboardingIDVGateway.list.3.text': 'Permanent resident card',
  'onboardingIDVGateway.list.contactUs':
    "Having trouble? Chat with our sales representative for assistance. No need to worry about having everything on hand-we'll save your progress for you.",
  'exclusiveOffers.apollo.title': 'Protect your space with Apollo',
  'exclusiveOffers.apollo.message':
    'Receive $25 on a Neo approved credit card.',
  'exclusiveOffers.apollo.url': 'https://info.apollocover.com/embark',
  'exclusiveOffers.apollo.alt': 'apollo',
  'exclusiveOffers.csl.title': 'Smart homes for student life',
  'exclusiveOffers.csl.message':
    'Clean, secure student spaces — move-in ready.',
  'exclusiveOffers.csl.url': 'https://www.canadianstudentliving.com/embark',
  'exclusiveOffers.csl.alt': 'Canadian Student Living',
  'exclusiveOffers.neoFinancial.title': 'Neo Financial',
  'exclusiveOffers.neoFinancial.message':
    'Receive $25 on a Neo approved credit card.',
  'exclusiveOffers.neoFinancial.url': 'https://www.neofinancial.com/',
  'exclusiveOffers.neoFinancial.alt': 'neofinancial',
  'exclusiveOffers.willful.title': 'Willful',
  'exclusiveOffers.willful.message': 'Get 20% off your legal will.',
  'exclusiveOffers.willful.url': 'https://try.willful.co/embark',
  'exclusiveOffers.willful.alt': 'willful',
  'exclusiveOffers.willful2.title': 'Create a will in minutes with Willful.',
  'exclusiveOffers.willful2.message': 'Get 20% off your legal will.',
  'exclusiveOffers.willful2.url': 'https://try.willful.co/embark/',
  'exclusiveOffers.willful2.alt': 'willful',
  'exclusiveOffers.policyMe.title': 'PolicyMe',
  'exclusiveOffers.policyMe.message':
    'Get your first two months of life or critical illness insurance free.',
  'exclusiveOffers.policyMe.url':
    'https://policyme.pxf.io/c/5711270/2138593/15713',
  'exclusiveOffers.policyMe.alt': 'policyMe',
  'exclusiveOffers.policyMe2.title': 'Life insurance, simplified.',
  'exclusiveOffers.policyMe2.message':
    'Get first 2 months free with Embark. Apply online in 20 minutes.',
  'exclusiveOffers.policyMe2.url':
    'https://policyme.pxf.io/c/5711270/2138593/15713',
  'exclusiveOffers.policyMe2.alt': 'policyMe',
  'exclusiveOffers.youthfully.title': 'Youthfully',
  'exclusiveOffers.youthfully.message': 'Receive 10% off student 1:1 coaching.',
  'exclusiveOffers.youthfully.url':
    'https://www.youthfully.com/embark/?via=embark',
  'exclusiveOffers.youthfully.alt': 'Youthfully',
  'exclusiveOffers.apollo2.title': 'Protect your space with Apollo',
  'exclusiveOffers.apollo2.message': 'Exclusive offer for tenant insurance',
  'exclusiveOffers.apollo2.url': 'https://info.apollocover.com/embark',
  'exclusiveOffers.apollo2.alt': 'apollo',
  'accountSummary.backHome': 'Back to home',
  'accountSummary.arrowBack': 'arrow back',
  'accountSummary.coSubReminderBanner.title': 'Digital access invitation',
  'accountSummary.coSubReminderBanner.body1': 'Extend an invitation to ',
  'accountSummary.coSubReminderBanner.body2':
    ' to get digital access. This allows them to view plans and enjoy exclusive offers.',
  'giftBanner.content.one': 'New! Embark gifting. ',
  'giftBanner.content.two':
    "Share your unique gifting link with your family and friends so that they can contribute to your child's RESP.",
  'giftBanner.linkLabel': 'Create gift link',
  'accuntSummary.respTitle': 'RESP',
  'refer.moneyBag.alt': 'Refer Money Bag',
  'refer.content.four': 'Referral code: ',
  'refer.content.copyCode': 'Copy code',
  'refer.linkCopied': 'Link copied!',
  'refer.step1.mobile':
    'Invite your friends and family to open an Embark RESP by sharing your unique link or code.',
  'refer.step3.one': 'You and your friend will each earn ',
  'refer.step3.three': ' when they enrol in a plan!*',
  'refer.referAFriend': 'Embark Refer a friend',
  'sendAGift.entry.headline': 'Create a gift link',
  'sendAGift.entry.body':
    'Family and friends can now gift money into your child’s RESP.',
  'sendAGift.entry.steps.title': '3 simple steps',
  'sendAGift.entry.steps.stepOneHeader': 'Step 1: Create a gift link',
  'sendAGift.entry.steps.stepOneBody':
    "Create a unique gift link for each child. Don't forget to personalize it by adding a photo!",
  'sendAGift.entry.steps.stepTwoHeader':
    'Step 2: Share your child’s gift link with family and friends',
  'sendAGift.entry.steps.stepTwoBody':
    'Get ready to spread the joy! Share your gift link with your loved ones and friends.  You can send the link to as many people as you like.',
  'sendAGift.entry.steps.stepThreeHeader':
    'Step 3: Get notified when you get an Embark RESP gift',
  'sendAGift.entry.steps.stepThreeBody':
    'You will get a notification when an Embark RESP gift is sent. Gifts are automatically deposited into your RESP.',
  'sendAGift.entry.tip':
    'It will take up to 7 business days for the gift to appear in the RESP.',
  'sendAGift.entry.button': 'Create gift link',
  'sendAGift.headline': 'Embark gifting',
  'sendAGift.description':
    'Pick someone special to receive the gift, then click “Share.”  You’ll get a one-of-a-kind link to send to your family and friends.',
  'sendAGift.beneficiaries.label': 'Select a child',
  'sendAGift.beneficiaries.listHeader': 'Children',
  'sendAGift.beneficiaries.header': 'Who’s getting the gift?',
  'sendAGift.beneficiaries.body':
    'Select a child to receive the gift. The gift they receive may also be eligible for up to 20% in government grants!',
  'beneficiaries.addPhoto': 'Add a photo',
  'sendAGift.plans.label': 'Select a plan',
  'sendAGift.plans.listHeader': 'Current plans',
  'sendAGift.plans.header': 'Where do you want the money to go?',
  'sendAGift.plans.body':
    'If your plan has multiple children, you can choose who receives the money.',
  'sendAGift.beneficiaryProfilePermission': 'Allow child’s image to be shared.',
  'sendAGift.terms.body': 'By choosing to continue you agree to the following ',
  'sendAGift.terms.link': 'Terms and Conditions.',
  'sendAGift.terms.icon.alt': 'redirect icon',
  'sendAGift.footer.lineOne': 'Embark. All rights reserved.',
  'sendAGift.footer.lineTwo': 'Embark is a trademark of Embark Student Corp.',
  'sendAGift.skip': 'Skip this step',
  'sendAGift.beneEmail.label': 'Gift notification',
  'sendAGift.beneEmail.header':
    'Would you like your child to receive a notification?',
  'sendAGift.beneEmail.body':
    'If your child has an email address, we can notify them when they receive a gift. You will also be notified when your child gets a gift.',
  'sendAGift.beneEmail.emailHeader': 'Child’s email',
  'sendAGift.share.header': 'Embark RESP gift link is ready!',
  'sendAGift.share.mobile.bodyOne': 'Share',
  'sendAGift.share.mobile.bodyTwo':
    'gift link with family and friends as many times as you like.',
  'sendAGift.share.copy': 'Copy link',
  'sendAGift.share.share': 'Share',
  'sendAGift.share.copied': 'Link copied!',
  'sendAGift.share.button': 'Done',
  'sendAGift.input.label': 'Link to share',
  'sendAGift.loader.alt1': 'background shape 1',
  'sendAGift.loader.alt2': 'background shape 2',
  'sendAGift.loader.alt3': 'background shape 3',
  'sendAGift.loader.giftAlt': 'gift',
  'sendAGift.loader.logoAlt': 'Embark gifting logo',
  'sendAGift.error.selectBeneOption': 'Please select an option to continue.',
  'sendAGift.error.selectPlanOption': 'Please select an option to continue.',
  'accountSummary.billPaymentCard.headline.text1': 'Contribute directly with ',
  'accountSummary.billPaymentCard.headline.text2': 'online banking',
  'accountSummary.billPaymentCard.button': 'Learn more',
  'accountSummary.billPaymentDialog.text1': 'Add Embark as a payee under ',
  'accountSummary.billPaymentDialog.text2': 'Bill Payment ',
  'accountSummary.billPaymentDialog.text3':
    'to make direct contributions to your RESP.',
  'accountSummary.billPaymentDialog.item1.text1':
    'In your online banking, select "',
  'accountSummary.billPaymentDialog.item1.text2': 'Add a payee',
  'accountSummary.billPaymentDialog.item1.text3': '" under Bill Payment.',
  'accountSummary.billPaymentDialog.item2.text1': 'Search for "',
  'accountSummary.billPaymentDialog.item2.text2': 'Embark Student Corp.',
  'accountSummary.billPaymentDialog.item2.text3': '" payee.',
  'accountSummary.billPaymentDialog.item3.text1': 'Enter your plan number ',
  'accountSummary.billPaymentDialog.item3.text2':
    ' under account number and save.',
  'accountSummary.billPaymentDialog.text4': 'Currently available at:',
  'accountSummary.billPaymentDialog.text5': 'and more…',
  'accountSummary.billPaymentDialog.text6':
    '*This feature is not available for TD and CIBC users.',
  'accountSummary.billPaymentDialog.tooltip': 'Copy to clipboard',
  'planTransfer.title.part1':
    'Transfer your current RESP to Embark and receive a ',
  'planTransfer.title.part2': ' bonus',
  'planTransfer.terms.part1': 'See ',
  'planTransfer.terms.part2': ' for more information.',
  'planTransfer.terms.link': 'Terms & Conditions',
  'planTransfer.termsIcon.alt': 'Redirect Icon',
  'planTransfer.button': 'Transfer',
  'planTransfer.icon.alt': 'Plan Transfer Icon',
  'accountSummary.totalSavings.oldPlanText':
    'Not available for contributions. Please contribute to your new plan.',
  'accountSummary.totalSavings.viewNewPlanBtn': 'View new plan',
  'accountSummary.newPlanLabel': 'New plan',
  'accountSummary.embarkConservativePlan.header':
    'What’s the Embark Select Conservative Plan investment advantage?',
  'accountSummary.embarkConservativePlan.description.paraOne':
    'Your RESP includes contributions you make over the years, grants from the government and earnings you gain through compound growth on investment of your contributions and grants.',
  'accountSummary.embarkConservativePlan.description.paraTwo':
    'Under the Embark Select Conservative Plan, your contributions, grants, and earnings have a fixed target asset mix (25% equity, 75% fixed income) until around the year your child turns 18 where your plan will merge into a Graduation Fund with more allocation towards fixed-income securities to preserve your savings.',
  'accountPendingRequests.title': 'Pending Transactions',
  'accountPendingRequest.type.withdrawal': 'Withdrawal',
  'accountPendingRequest.alertIcon': 'Alert Icon',
  'accountPendingRequest.attentionRequired': 'Attention required',
  'accountPendingRequest.requestCancelled': 'Request cancelled',
  'accountPendingRequest.cancelIcon': 'Cancel Icon',
  'educationGoalCustomize.headline.text': 'Set an education goal for ',
  'educationGoalCustomize.projectedCostYear': 'Projected cost of school in ',
  'savedProgramMatch.years': 'yr',
  'savedProgramMatch.careerLabel': 'Aspiring career',
  'savedProgramMatch.careerDefault': 'No career chosen',
  'savedProgramMatch.careerIconAlt': 'School cap',
  'savedProgramMatch.schoolLabel': 'School',
  'savedProgramMatch.schoolDefault': 'No school selected',
  'savedProgramMatch.programLabel': 'Program',
  'savedProgramMatch.programDefault': 'No program selected',
  'savedProgramMatch.link.details': 'View details',
  'savedProgramMatch.link.findSchool': 'Find school',
  'bankAccountSelect.verification.message': 'Verification required',
  'bankAccountSelect.transferRrsp':
    'Transfer to an RRSP at another institution',
  'onboardingReview.review.reminderCard.text':
    "You've set a reminder to come back on",
  'onboardingReview.review.IconAlt': 'Bell Icon',
  'onboardingReview.grants': 'Government grants you’ve applied for:',
  'onboardingReviewRESPSection.title.lowProfile':
    'Embark Select Conservative Plan',
  'onboardingReviewSubscriberSection.V2.title': 'Personal details',
  'onboardingReviewPersonalInformation.title': 'Identity verification',
  'onboardingReviewBeneficiarySection.icon.alt': 'Beneficiary Card Info',
  'onboardingReviewBeneficiarySection.beneInfoCard.part1':
    'This plan is just for ',
  'onboardingReviewBeneficiarySection.beneInfoCard.part2':
    ' for now since we don’t have the SIN for your other child(ren) yet. You can easily add them later by tapping "Save for another child" from your dashboard.',
  'onboardingReview.addPromoReferralCode': 'Add a promo or referral code',
  'onboardingSuccess.description': 'Let’s get your new RESP ready for saving.',
  'onboardingSuccess.description.new':
    "Let's start by saving, exploring your dashboard, linking a bank account or making a contribution.",
  'onboardingSuccess.startSaving.CTA': 'Start saving',
  'onboardingSuccess.continueWithOffer': 'Continue with offer',
  'onboardingSuccess.transfer': 'Transfer an existing RESP',
  'onboardingSuccess.transfer.description1':
    'Transfer your current RESP to Embark and receive a ',
  'onboardingSuccess.transfer.description2': ' bonus',
  'onboardingSuccess.transfer.conditions': '*Terms and conditions apply',
  'onboardingSuccess.transfer.conditions.url':
    'https://www.embark.ca/balance-offer-terms-and-conditions',
  'onboardingSuccess.footer.part1':
    'By the way, you can add a Trusted Contact Person to this plan. Just call us at ',
  'onboardingSuccess.footer.part2': ' to learn more.',
  'onboardingSuccess.footer.phoneNumber': '1-800-363-7377',
  'onboardingUnderReview.heading': "We've received your application!",
  'onboardingUnderReview.description':
    "We're currently reviewing your application, and this may take a few business days. You will receive an email once it's approved.",
  'onboardingUnderReview.offers.header': 'Exclusive offers',
  'onboardingUnderReview.footer.part1':
    'By the way, you can add a Trusted Contact Person to this plan. Just call us at ',
  'onboardingUnderReview.footer.part2': ' to learn more.',
  'onboardingUnderReview.footer.phoneNumber': '1-800-363-7377',
  'onboardingPendingApplication.description.one':
    "We've saved all your information, but the RESP hasn't been opened yet.",
  'onboardingPendingApplication.description.two':
    'Come back when you have the details ready to complete the process.',
  'digitalAccessSuccess.img.alt': 'Digital Access Success Icon',
  'digitalAccessSuccess.heading':
    'Your plan(s) have been migrated to your Embark account',
  'digitalAccessSuccess.message':
    'Please visit your homepage to review plan details and make any necessary updates to your risk profile.',
  'digitalAccessBookAppointment.heading': 'Ran into a problem?',
  'digitalAccessBookAppointment.message':
    'Please review your information and restart the Digital Activation process.',
  'digitalAccessBookAppointment.existingCustomer':
    'Already an existing Embark customer?',
  'digitalAccessCannotContinue.heading':
    "Something went wrong and you're unable to continue",
  'digitalAccessCannotContinue.issueTitle':
    'You might be encountering this issue if:',
  'digitalAccessCannotContinue.issue1':
    'The information provided is incorrect or cannot be found in our system',
  'digitalAccessCannotContinue.issue2': 'You aren’t a subscriber on a plan',
  'digitalAccessCannotContinue.issue3':
    'Our system is experiencing technical difficulties',
  'digitalAccessCannotContinue.homepage': 'Go to homepage',
  'onboardingSuccess.dashboard.message':
    'Your Embark RESP is all set up! Check out your dashboard, get personalized career suggestions, and enjoy special offers made just for you.',
  'onboardingSuccess.V2.offers.header': 'Exclusive offers',
  'onbaordingSuccess.offers.header': 'Exclusive offers for you',
  'onbaordingSuccess.offers.neoFinancial.title': 'Neo Financial',
  'onbaordingSuccess.offers.neoFinancial.message':
    'Receive $25 on a Neo approved credit card.',
  'onbaordingSuccess.offers.neoFinancial.url': 'https://www.neofinancial.com/',
  'onbaordingSuccess.offers.neoFinancial.alt': 'neofinancial',
  'onbaordingSuccess.offers.willful.title': 'Willful',
  'onbaordingSuccess.offers.willful.message': 'Get 20% off your legal will.',
  'onbaordingSuccess.offers.willful.url': 'https://try.willful.co/embark',
  'onbaordingSuccess.offers.willful.alt': 'willful',
  'onbaordingSuccess.offers.policyMe.title': 'PolicyMe',
  'onbaordingSuccess.offers.policyMe.message':
    'Get your first two months of life or critical illness insurance free.',
  'onbaordingSuccess.offers.policyMe.url': 'https://www.policyme.com/',
  'onbaordingSuccess.offers.policyMe.alt': 'policyMe',
  'onbaordingSuccess.card.message':
    'By the way, you can add a Trusted Contact Person to this plan. Just call us at 1-800-363-7377 to learn more.',
  'onbaordingSuccess.card.alt': 'Bookmark Icon',
  'digitalAccessSuccess.homepage': 'Go to homepage',
  'beneficiary.messageContent':
    'Please note any children added to a family plan must be siblings by blood or adoption of the existing plan.',
  'email.optional': 'Email (optional)',
  'manageAccount.transferIn': 'Transfer an RESP',
  'manageAccount.transferIn.alt': 'Transfer an RESP Icon',
  'addPlanMembers.child.addChild': 'Add a child',
  'addBeneficiary.success.description': 'Let’s get saving for their education.',
  'digitalAccessPersonalInfo.addressFields.title': 'Residential address',
  'AIPWithdrawal.whichAccount': 'To which account?',
  'AIPWithdrawal.planSelection.stepperHeader': 'Select a plan',
  'AIPWithdrawal.unavailable': 'AIP withdrawal unavailable',
  'AIPWithdrawal.body':
    'It looks like you can’t make an AIP withdrawal right now. This might be because certain requirements have not been met. Here are some possible reasons:',
  'AIPWithdrawal.description1': 'You still have contributions in the plan.',
  'AIPWithdrawal.description2': 'AIP withdrawal already submitted.',
  'AIPWithdrawal.description3': 'The child(ren) is/are not yet 21 years old.',
  'AIPWithdrawal.makeWithdrawal': 'Make an AIP withdrawal',
  'AIPWithdrawal.makeWithdrawalTitle':
    'Before you start your AIP withdrawal, here are a few important things to know:',
  'AIPWithdrawal.makeWithdrawalDescription1.part1':
    'Before you can complete an AIP withdrawal, you must ',
  'AIPWithdrawal.makeWithdrawalDescription1.part2':
    'first speak with an Embark representative to make a non-PSE withdrawal. ',
  'AIPWithdrawal.makeWithdrawalDescription1.part3':
    'Contact us at contact@embark.ca. ',
  'AIPWithdrawal.makeWithdrawalDescription1.part4':
    'If this step is skipped, your AIP withdrawal will be rejected.',
  'AIPWithdrawal.makeWithdrawalDescription2.part1':
    'All AIP withdrawals are considered ',
  'AIPWithdrawal.makeWithdrawalDescription2.part2': 'taxable income.',
  'AIPWithdrawal.makeWithdrawalDescription3.part1':
    'You can choose to transfer the funds to ',
  'AIPWithdrawal.makeWithdrawalDescription3.part2':
    'your personal bank account or to an RRSP (Registered Retirement Savings Plan). ',
  'AIPWithdrawal.makeWithdrawalDescription3.part3':
    'Transferring to an RRSP may help ',
  'AIPWithdrawal.makeWithdrawalDescription3.part4': 'reduce the taxes ',
  'AIPWithdrawal.makeWithdrawalDescription3.part5': 'you owe.',
  'AIPWithdrawal.makeWithdrawalDescription4.part1':
    'Only you can submit your AIP withdrawal request. If you have a joint account holder, they must ',
  'AIPWithdrawal.makeWithdrawalDescription4.part2':
    'log in and complete their own request ',
  'AIPWithdrawal.makeWithdrawalDescription4.part3': 'separately.',
  'AIPWithdrawal.makeWithdrawalDescription5.part1':
    'Once your AIP withdrawal is complete, ',
  'AIPWithdrawal.makeWithdrawalDescription5.part2':
    'your RESP will be closed in February of the following year. ',
  'AIPWithdrawal.makeWithdrawalDescription5.part3':
    'All remaining grants will be returned to the government, and any unused funds will be forfeited.',
  'AIPWithdrawal.makeWithdrawalDescription6.part1':
    'If your child isn’t attending school, consider ',
  'AIPWithdrawal.makeWithdrawalDescription6.part2': 'replacing the child(ren) ',
  'AIPWithdrawal.makeWithdrawalDescription6.part2.link':
    'https://www.embark.ca/making-withdrawals',
  'AIPWithdrawal.makeWithdrawalDescription6.part3':
    'on this plan with another child.',
  'AIPWithdrawal.amountError': 'Please enter amount.',
  'AIPWithdrawal.RRSPDeductionLimit.title': 'RRSP deduction limit',
  'AIPWithdrawal.RRSPDeductionLimit.desc':
    'To transfer the income portion of your RESP to your RRSP, we need to confirm you have enough RRSP contribution room. Please check your notice of assessment and enter your RRSP deduction limit below.',
  'AIPWithdrawal.RRSPDeductionLimit.linkText':
    'Where can I find my deduction limit?',
  'AIPWithdrawal.RRSPDeductionLimit.link':
    'https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/rrsps-related-plans/contributing-a-rrsp-prpp/where-you-find-your-rrsp-prpp-deduction-limit.html',
  'AIPWithdrawal.RRSPWithdrawalUnavailable': 'RRSP withdrawal unavailable',
  'AIPWithdrawal.RRSPWithdrawalUnavailable.desc':
    "There's not enough contribution room in your RRSP to complete this transfer. You can go back and submit a full AIP withdrawal to your bank account.",
  'AIPWithdrawal.aip': 'Accumulated income balance',
  'AIPWithdrawalBalance.paragraph1.1':
    'To complete this AIP withdrawal, you’ll need to withdraw the full accumulated income balance of',
  'AIPWithdrawalBalance.paragraph1.2':
    ' from your plan. If there are joint subscribers on the plan, the total amount can be withdrawn by either one or both subscribers.',
  'AIPWithdrawalBalance.paragraph2.1': 'After the withdrawal, the',
  'AIPWithdrawalBalance.paragraph2.2':
    " you've accumulated in grants will be returned to the government. You can see a detailed breakdown below.",
  'AIPWithdrawal.success.message1':
    'You have successfully requested the AIP withdrawal of ',
  'AIPWithdrawal.success.message2':
    ' Withdrawals can take up to 5-7 business days to process.',
  'AIPWithdrawal.jointAccount.question': 'How much would you like to take out?',
  'AIPWithdrawal.jointAccount.info':
    'Your joint account holder needs to submit their own AIP withdrawal request by logging into their account.',
  'AIPWithdrawalTransferDetails.stepperHeader': 'RRSP details',
  'AIPWithdrawalTransferDetails.enterAddressLabel': 'Enter address manually',
  'AIPWithdrawal.review.text1':
    'Regular income tax and provincial tax will be deducted when your AIP withdrawal is processed.',
  'AIPWithdrawal.review.text2':
    'Your final amount will be different due to market fluctuations.',
  'AIPWithdrawal.review.text3':
    'Once an AIP withdrawal is processed, a tax slip will be issued. The RESP account will be closed by the end of February in the following year.',
  'PSEEnrolmentVerification.EAPLimit.note.first':
    'In compliance with government regulations, a student can withdraw ',
  'PSEEnrolmentVerification.EAPLimit.note.amount': '$4,000',
  'PSEEnrolmentVerification.EAPLimit.note.last':
    ' per 13-week period from grants and earnings for part-time enrolments. If you are requesting an amount that exceeds the limit, you authorize us to deduct the balance from your contributions, if any remaining.',
  'PSEEnrolmentVerification.EAPLimit.alt': 'Withdrawal Info Icon',
  'PSEEnrolmentVerification.areTheyCanadianResident':
    'Are they a Canadian resident for tax purposes?',
  'PSEEnrolmentVerification.areTheyCanadianResident.helperText1':
    'Determine their ',
  'PSEEnrolmentVerification.areTheyCanadianResident.helperText2':
    'residency status',
  'PSEEnrolmentVerification.areTheyCanadianResident.link':
    'https://www.canada.ca/en/revenue-agency/services/tax/international-non-residents/information-been-moved/determining-your-residency-status.html',
  selectAnotherAccount: 'Select another account',
  pleaseEnterPercentage: 'Please enter percentage.',
  pleaseEnterCorrectPercentage: 'Please enter a number between 1-100.',
  'vouchedIDV.digitalAccess.crossDeviceTitle': "Let's verify your ID",
  'vouchedIDV.alertBanner':
    'All your data is secure and encrypted. We use this information only to verify your identity.',
  'idVerificationExpired.message':
    'Sorry, we could not verify your identity because your ID has expired. Please try again with a valid ID.',
  'idVerificationStop.message': 'Please try again later.',
  'educationProjection.years': 'years',
  'planTransferSummary.title': 'Transfer Summary',
  'enrolmentSummary.gender': 'Gender',
  'enrolmentSummary.sourceOfIncome': 'Source of Income',
  'enrolmentSummary.managementRebateSelection':
    'Is this customer transferring Flex First or FSSP plan(s)?',
  'enrolmentSummary.managementRebateSelection.Yes': 'Yes',
  'enrolmentSummary.managementRebateSelection.No': 'No',
  'enrolmentSummary.managementRebatePlan':
    'What plan(s) are they transferring?',
  'enrolmentSummary.managementRebatePlan.FFP': 'Flex First Plan',
  'enrolmentSummary.managementRebatePlan.FSSP': 'FSSP Plan',
  'enrolmentSummary.managementRebatePlan.Both': 'Both FSSP and Flex First Plan',
  'enrolmentSummary.sessionID': 'Session ID',
  'enrolmentSummary.grantsGovernmentApplied':
    'Government grants you’ve applied for',
  'faceRating.stronglyDisagree': 'Strongly Disagree',
  'faceRating.disagree': 'Disagree',
  'faceRating.neutral': 'Neutral',
  'faceRating.agree': 'Agree',
  'faceRating.stronglyAgree': 'Strongly Agree',
  'schoolCostCard.costOfSchool': 'Cost of school',
  'schoolCostCard.noCalculatedCost': 'No calculated cost',
  'termsConditions.eaa.link.family': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Family_Plan_EAA_&_Acknowledgements_&_Prospectus_EN_DIGITAL.pdf`,
  'termsConditions.eaa.link.individual': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Individual_Plan_EAA_&_Acknowledgements_&_Prospectus_EN_DIGITAL.pdf`,
  'termsConditions.eaa.link.conservativeIndividual': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Conservative_Individual_Plan_EAA_&_Acknowledgements_&_Prospectus_EN_DIGITAL.pdf`,
  'termsConditions.eaa.link.conservativeFamily': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Conservative_Family_Plan_EAA_&_Acknowledgements_&_Prospectus_EN_DIGITAL.pdf`,
  'termsConditions.eaa.link.glidePathIndividual': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_GlidePath_Individual_Plan_EAA_&_Acknowledgements_&_Prospectus_EN_DIGITAL.pdf`,
  'termsConditions.eaa.link.glidePathFamily': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_GlidePath_Family_Plan_EAA_&_Acknowledgements_&_Prospectus_EN_DIGITAL.pdf`,
  'termsConditions.customerReferralDisclosure': 'Customer referral disclosure',
  'termsConditions.customerReferralDisclosure.link.lighthouse': `${__STUDENT_SERVICES_URL__}/documents/Embark_Customer_Referral_Disclosure_Lighthouse_en.pdf`,
  'termsConditions.customerReferralDisclosure.link.fintel': `${__STUDENT_SERVICES_URL__}/documents/Embark_Customer_Referral_Disclosure_Fintel_en.pdf`,
  'fileUpload.maxFileSizeError1.button':
    'Please upload a valid file size. Max file size: 5MB',
  'fileUpload.fileTypeError.button':
    'The selected file format is not supported. Please upload a PDF, PNG, or JPG file',
  'documents.filterDescription':
    'Quickly find what you need by filtering your documents.',
  'documents.noDocumentsTitle': "It looks like you don't have any documents",
  'documents.noDocumentsDescription':
    'Your documents will be available here after adding a plan, making a withdrawal, or receiving your next quarterly statement.',
  'documents.noActivityDescription': 'No activity this month.',
  filter: 'Filters',
  noMatchesFound: 'No matches found',
  tryAdjustingYourFilters: 'Try adjusting your filters.',
  clearFilter: 'Clear filter',
  loadMore: 'Load more',
  download: 'Download',
  'profile.riskProfile': 'Risk profile',
  'digitalAccessPersonalInfo.DateOfBirth': 'Date of birth',
  'investmentProfile.standaloneKYC.employmentStatus':
    'What’s your employment status?',
  'standalonekyc.riskprofile.confirmButton': 'Confirm details',
  'standalonekyc.riskprofile.timeHorizonDialogTitle':
    'Would you like to update your response?',
  'standalonekyc.riskprofile.timeHorizonDialogMessage':
    "It looks like you’ve changed your mind from your previous selection. If you update it now, you won't be able to continue digitally. Please call us at 1-800-363-7377 or chat with us online to continue.",
  'standalonekyc.riskprofile.postSecondaryDialogTitle':
    'Would you like to update your response?',
  'standalonekyc.riskprofile.postSecondaryDialogMessage':
    "It looks like you’ve changed your mind from your previous selection. If you update it now, you won't be able to continue digitally. Please call us at 1-800-363-7377 or chat with us online to continue. ",
  'standalonekyc.RiskProfile.toConservative.noticeHeader':
    'Notice for transfer to Embark Select Conservative Plan',
  'standalonekyc.RiskProfile.toConservative.noticeItem1':
    'The Embark Select Conservative Plan has a more conservative investment approach',
  'standalonekyc.RiskProfile.toConservative.noticeItem2':
    'Savings will be invested with a fixed asset mix (25% equity, 75% fixed income) until around the year the child turns 18',
  'standalonekyc.RiskProfile.toConservative.noticeItem3':
    'Around 18, your investments will move into a Graduation fund focused on preserving your savings',
  'standalonekyc.RiskProfile.toConservative.noticeItem4.part1':
    'For more information, review the ',
  'standalonekyc.RiskProfile.toConservative.noticeItem4.part2':
    'Embark Select Conservative Plan prospectus',
  'standalonekyc.RiskProfile.toConservative.noticeItem5':
    'By continuing, you consent to the transfer of your assets from the Embark Student Plan to the Embark Select Conservative Plan',
  'standalonekyc.RiskProfile.toConservative.noticeItem6.part1':
    'To continue with the Embark Select Conservative Plan, click ',
  'standalonekyc.RiskProfile.toConservative.noticeItem6.part2': '“I accept”',
  'standalonekyc.RiskProfile.toConservative.noticeItem6.part3':
    ' or decline and redo their questionnaire',
  'standalonekyc.RiskProfile.toGlidepath.noticeHeader':
    'Notice for transfer to Embark Student Plan',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem1':
    'The Embark Student Plan tailors each child’s investment to their age, focusing on growth when they are young and automatically adjusting to become more conservative as they get closer to graduation to preserve savings',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem2.part1':
    'For more information, review the ',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem2.part2':
    'Embark Student Plan Prospectus',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem3':
    'By continuing, you consent to the transfer of your assets from the Embark Select Conservative Plan to the Embark Student Plan',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem4.part1':
    'To continue with the Embark Student Plan, click ',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem4.part2': '“I accept”',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem4.part3':
    ' or decline and redo their questionnaire',
  'standalonekyc.RiskProfile.NoticeInfo':
    'Please note that the plan transfer may take 45-60 business days to complete.',
  'standalonekyc.RiskProfile.confirmationDialogContinue': 'Yes, Continue',
  'mandatoryKYC.header':
    'Have circumstances stayed the same personally and financially?',
  'mandatoryKYC.header.quickReview': 'Let’s do a quick review',
  'mandatoryKYC.body':
    'Before you continue, we need to confirm personal and financial information.  Changes to investment or risk profiles may require a plan reassessment.',
  'mandatoryKYC.phone.headline': 'What’s your mobile number?',
  'mandatoryKYC.confirm.CTA': 'Confirm details',
  'mandatoryKYC.skipNow.CTA': 'Skip for now',
  'mandatoryKYC.riskProfile.updateRisk':
    'Update your risk profile. This will only take 5-10 minutes.',
  'update.now': 'Update now',
  goback: 'Go back',
  'termsConditions.callus':
    'By the way, you can add a Trusted Contact Person to this plan. Just call us at 1-800-363-7377 to learn more.',
  'withdrawal.pendingOrders.header':
    'You already have a withdrawal request in progress for this plan',
  'withdrawal.pendingOrders.body':
    'You can only have one withdrawal request at a time. Please wait until your previous withdrawal request is completed before submitting another one.',
  'dashboard.button': 'Go to dashboard',
  invalidDateFormat: 'Please enter a valid date.',
  'withdrawal.transactions.title': 'Withdrawal',
  'withdrawal.transactions.stepperIcon.alt': 'Stepper Icon',
  'withdrawal.transactions.stepper.underReview': 'Under review',
  'withdrawal.transactions.stepper.approved': 'Approved',
  'withdrawal.transactions.stepper.cancelled': 'Cancelled',
  'withdrawal.transactions.stepper.attentionRequired': 'Attention required',
  'withdrawal.transactions.stepper.moneySent': 'Money sent',
  'withdrawal.transactions.stepper.inProgress': 'In progress',
  'withdrawal.transactions.withdrawalAmount.header': 'Withdrawal amount',
  'withdrawal.transactions.withdrawalAmount.description1':
    'Students eligible for Canada Education Savings Grant (CESG) and enrolled in a Registered Education Savings Plan can collect a maximum of $7,200 in CESG. Students are limited to this amount and any excess must be repaid to the Government.',
  'withdrawal.transactions.withdrawalAmount.description2':
    'Any other grants received are also subject to being returned to the Government based on the student’s eligibility at the time of withdrawal.',
  'withdrawal.transactions.withdrawalDetails.header': 'More details',
  'withdrawal.transactions.card.inProgress':
    'Your funds are expected to be deposited into your bank account by: ',
  'withdrawal.transactions.card.underReview':
    'If additional information is required, we will contact you via email.  Please allow 5-7 business days for processing.',
  'withdrawal.transactions.card.approved':
    'Your withdrawal request has been approved.  Please allow 2-3 business days for your funds to be deposited.',
  'withdrawal.transactions.card.moneySentOverThreshold':
    'Your request has been processed successfully.  Please allow 2-3 business days for the funds to be deposited into your account.',
  'withdrawal.transactions.card.moneySentUnderThreshold':
    'Your funds are expected to be deposited into your bank account by: ',
  'withdrawal.transactions.card.cancelledOverThreshold':
    "We had to cancel your withdrawal request because either you requested it or we couldn't reach you for the extra information we needed. If you still wish to withdraw funds from your RESP, please submit a new request.",
  'withdrawal.transactions.card.cancelledUnderThreshold':
    'We had to cancel your withdrawal request because either your requested it or we couldn’t reach you for the extra information we needed.  If you still wish to withdraw funds from your RESP, please submit a new request.',
  'withdrawal.transactions.card.attentionRequire':
    'Please check your inbox for the next steps in processing your withdrawal. Once you provide a new Verification of Enrolment (VOE), it will take an additional 5 business days for your funds to be processed. Withdrawal requests will be cancelled if no action is taken within 30 business days.',
  'withdrawalApplication.selectAPlan.header': 'Select a plan',
  'withdrawalEnrolmentVerification.header': 'Who’s going to school?',
  'withdrawalEnrolmentVerification.beneficiary.label': 'Child name',
  'withdrawalEnrolmentVerification.beneficiary.error':
    'Please select a student.',
  'withdrawalEnrolmentVerification.beneficiaryEmail.label':
    'Child’s email address',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.checkbox.label':
    'Yes, the child still lives at the same address.',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.yes.card.label':
    "Keep your child's address up to date",
  'withdrawalEnrolmentVerification.areTheyCanadianResident.yes.card.description':
    'Canadian address so we can keep our records accurate and ensure continued grant eligibility.',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.no.card.label':
    'Limited access to grant funds',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.no.card.description':
    'RESP withdrawals are made up of three parts: contributions, income, and grants. If your child lives outside Canada, grants like the CESG or CLB may not be accessible, and income may be taxed differently depending on the country. ',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.no.card.learnMore':
    'Learn more',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.address.label':
    'Address',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.address.placeholder':
    'Start typing your address',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.header':
    'Are they a Canadian resident?',
  'withdrawalEnrolmentVerification.voe.header':
    'Verification of Enrolment (VOE)',
  'withdrawalEnrolmentVerification.voe.link.popup': "What's a VOE?",
  'withdrawalEnrolmentVerification.voe.link.sampleVoe': 'View sample VOE',
  'withdrawalEnrolmentVerification.voe.schoolName.label': 'School name',
  'withdrawalEnrolmentVerification.voe.schoolName.error.required':
    'Please enter the school name on the VoE.',
  'withdrawalEnrolmentVerification.voe.schoolName.other.error.required':
    'Please enter a school name to continue.',
  'withdrawalEnrolmentVerification.voe.schoolName.other.error.maxLength':
    'Please enter a financial institution name under 200 characters',
  'withdrawalEnrolmentVerification.voe.postalCode.helperText':
    'The postal code on their VoE.',
  'withdrawalEnrolmentVerification.voe.addVerificationSchoolEnrolment':
    'Add verification of school enrolment',
  'withdrawalEnrolmentVerification.voe.fileUpload.error.required':
    'Please upload a digital copy of your VoE.',
  'withdrawalEnrolmentVerification.enrolmentType.header': 'Enrolment type',
  'withdrawalEnrolmentVerification.enrolmentType.info.partTime.one':
    'You can withdraw up to ',
  'withdrawalEnrolmentVerification.enrolmentType.info.partTime.two': '$4,000',
  'withdrawalEnrolmentVerification.enrolmentType.info.partTime.three':
    " every 13 weeks from grants and earnings for part-time studies. If you request more than this limit, we'll deduct the extra from your contributions.",
  'withdrawalEnrolmentVerification.enrolmentType.programType.label':
    'Program type',
  'withdrawalEnrolmentVerification.enrolmentType.programType.error.required':
    'Please enter the program type.',
  'withdrawalEnrolmentVerification.enrolmentType.programDuration.label':
    'Duration (in years)',
  'withdrawalEnrolmentVerification.enrolmentType.programYear.label':
    'Program year',
  'withdrawalEnrolmentVerification.startDate.header': 'Start Date',
  'withdrawalEnrolmentVerification.consecutiveWeeks.header':
    'Have they completed 13 consecutive weeks of post-secondary education in the last 12 months?',
  'withdrawalApplication.amount.header': 'Withdrawal amount',
  'withdrawalApplication.amount.withdrawalBreakdown': 'Withdrawal breakdown',
  'withdrawalApplication.amount.howMuchWithdrawal':
    'How much should I withdraw?',
  'withdrawalApplication.amount.reallocate': 'Reallocate',
  'withdrawalApplication.amount.grants': 'Grant and earnings:',
  'withdrawalApplication.amount.availableForWithdrawal':
    ' available for withdrawal.',
  'withdrawalApplication.amount.contributions': 'Contributions:',
  'withdrawalApplication.amount.grantsNote.body':
    'By default, we withdraw funds from your grants and earnings before contributions. You may edit to reallocate the funds below.',
  'withdrawalApplication.bank.header':
    'Which account would you like to deposit it into?',
  'withdrawalApplication.bank.selectionRequired':
    'Please select an account to continue',
  'withdrawalApplication.review.header': 'Review',
  'withdrawalApplication.reviewDetailsSection.title': 'Withdrawal details',
  'withdrawalApplication.reviewDetailsSection.amount': 'Amount:',
  'withdrawalApplication.reviewDetailsSection.grants': 'Grant and earnings:',
  'withdrawalApplication.reviewDetailsSection.contributions': 'Contributions:',
  'withdrawalApplication.reviewDetailsSection.to': 'To:',
  'withdrawalApplication.reviewDetailsSection.note':
    'Withdrawals can take up to 5-7 business days to reflect in your bank account. Any withdrawals made on holidays and weekends will be processed on the next business day.',
  'withdrawalApplication.success.headline': 'Withdrawal in progress!',
  'withdrawalApplication.success.message':
    'You have successfully requested the withdrawal of ',
  'withdrawalApplication.success.offers.title': 'Continue with offer',
  'withdrawalApplication.howMuchWithdrawaldialog.content.title':
    'Post-secondary costs add up — tuition, rent, books, and more. Here’s what to know before you withdraw:',
  'withdrawalApplication.howMuchWithdrawaldialog.body.types':
    'Two types of RESP funds:',
  'withdrawalApplication.howMuchWithdrawaldialog.body.list.eap': 'EAPs: ',
  'withdrawalApplication.howMuchWithdrawaldialog.body.list.pse': 'PSE: ',
  'withdrawalApplication.howMuchWithdrawaldialog.body.list.one':
    'Government grants and investment growth',
  'withdrawalApplication.howMuchWithdrawaldialog.body.list.two':
    ' Your own contributions',
  'withdrawalApplication.howMuchWithdrawaldialog.body.recommend':
    'We recommend withdrawing EAPs first so you don’t lose unused grants. (You can take out contributions anytime).',
  'withdrawalApplication.howMuchWithdrawaldialog.body.default':
    'We’ll default to EAPs, but you can change this.',
  'withdrawalApplication.howMuchWithdrawaldialog.body.cesg': 'CESG limit: ',
  'withdrawalApplication.howMuchWithdrawaldialog.body.cesg.content':
    'There’s a $7,200 lifetime max per child for government grants. If you go over, you’ll need to pay back the extra.',
  'withdrawalApplication.howMuchWithdrawaldialog.body.matters':
    'This matters if you have: ',
  'withdrawalApplication.howMuchWithdrawaldialog.body.matters.one':
    'Multiple RESPs',
  'withdrawalApplication.howMuchWithdrawaldialog.body.matters.two':
    'A family plan with more than one child',
  'withdrawalApplication.howMuchWithdrawaldialog.done': 'Done',
  'VOEInfoDialog.title': 'What’s a VOE?',
  'VOEInfoDialog.content.one.body':
    'A VOE (that’s short for Verification of Enrolment) is a document from the school that confirms your child is currently enrolled. You’ll need one to move forward.',
  'VOEInfoDialog.content.two.header': 'Where to find it:',
  'VOEInfoDialog.content.two.body':
    'Most schools include your VOE in the student profile. If not, you can usually request one from the registrar’s office or student services.',
  'VOEInfoDialog.content.three.header': 'To be accepted, your VOE must:',
  'VOEInfoDialog.content.three.item.one':
    'Be issued by your school on its official letterhead.',
  'VOEInfoDialog.content.three.item.two': 'Be issued in the last 6 months.',
  'VOEInfoDialog.content.four.header': 'What a VOE is not:',
  'VOEInfoDialog.content.four.item.one': 'A letter of acceptance.',
  'VOEInfoDialog.content.four.item.two':
    'A transcript, tuition invoice, or class schedule.',
  'VOEInfoDialog.content.five.header': 'View a sample:',
  'VOEInfoDialog.content.five.body':
    'Select your school from the dropdown and we’ll show you an example of what a valid VOE looks like.',
  'VOEInfoDialog.done': 'Done',
  'withdrawalReviewTotalSection.total': 'Total:',
  'withdrawalReviewPlanSection.title': 'Embark Student Plan',
  'withdrawalReviewPlanSection.iconAlt': '',
  'withdrawalReviewPlanSection.from': 'From:',
  'withdrawalReviewPlanSection.familyPlan': 'Family Plan',
  'withdrawalReviewPlanSection.individualPlan': 'Individual plan',
  'withdrawalReviewProfileSection.title': ' profile',
  'withdrawalReviewProfileSection.childName': 'Child’s name:',
  'withdrawalReviewProfileSection.canadianResident':
    'Are they a Canadian resident?',
  'withdrawalReviewProfileSection.schoolName': 'School name:',
  'withdrawalReviewProfileSection.schoolPostalCode': 'School postal code:',
  'withdrawalReviewProfileSection.voe': 'VOE (Verification of Enrolment)',
  'withdrawalReviewProfileSection.enrolmentType': 'Enrolment type:',
  'withdrawalReviewProfileSection.programType': 'Program type:',
  'withdrawalReviewProfileSection.schoolDuration': 'Duration (in years):',
  'withdrawalReviewProfileSection.programYear': 'Program year:',
  'withdrawalReviewProfileSection.startDate': 'Start date:',
  'withdrawalReviewProfileSection.completedWeeks':
    'Have they completed 13 consecutive weeks of post-secondary education in the last 12 months?',
  'withdrawalReviewTransferSection.title': 'Transfer details',
  'withdrawalReviewTransferSection.amount': 'Amount:',
  'withdrawalReviewTransferSection.grants': 'Grant and earnings:',
  'withdrawalReviewTransferSection.contributions': 'Contributions:',
  'withdrawalReviewTransferSection.to': 'To:',
  'withdrawalReviewTransferSection.note':
    'Withdrawals can take up to 5-7 business days to reflect in your bank account. Any withdrawals made on holidays and weekends will be processed on the next business day.',
  'withdrawalEapBreakdown.heading':
    'Withdrawal: Educational Assistance Payment',
  'withdrawalEapBreakdown.subheading': 'Breakdown of grants and earnings',
  'withdrawalEapBreakdown.label.CESG': 'Canada Education Savings Grant (CESG):',
  'withdrawalEapBreakdown.label.CLB': 'Canada Learning Bond (CLB):',
  'withdrawalEapBreakdown.label.BCTESG':
    'British Columbia Training and Education Savings Grant (BCTESG):',
  'withdrawalEapBreakdown.label.QESI':
    'Quebec Education Savings Incentive (QESI):',
  'withdrawalEapBreakdown.label.income': 'Income:',
  'withdrawalEapBreakdown.label.total': 'Total:',
  'withdrawalEapBreakdown.description.1':
    'Students eligible for Canada Education Savings Grant (CESG) and enrolled in a Registered Education Savings Plan can collect a maximum of $7,200 in CESG. Students are limited to this amount and any excess must be repaid to the Government.',
  'withdrawalEapBreakdown.description.2':
    'Any other grants received are also subject to being returned to the Government based on the student’s eligibility at the time of withdrawal.',
  'img.alt.grantsImage': 'Three shining dollar bills stacked in offset',
  'img.alt.checklist': 'Check List',
  'img.alt.grantsGif':
    'Animation of three shining dollar bills stacked in offset',
  'img.alt.questionList': 'List of questions',
  'img.alt.onboardingSuccess': 'Swirls and confetti',
  'img.alt.promoIcon': 'gift bag',
  'img.alt.icon.educationGraphic': 'Graduation cap',
  'withdrawal.transactions.schoolName': 'School name',
  'withdrawal.transactions.postalCode': 'School postal code',
  'withdrawal.transactions.duration': 'Duration (in years)',
  'withdrawal.transactions.to': 'To',
  'withdrawal.transactions.weeksAttended':
    'Have they completed 13 consecutive weeks of post-secondary education in the last 12 months?',
  'kycCard.info':
    'Canadian regulators require us to collect this information as part of our Know Your Client (KYC) obligations. Your data is safe and never leaves Embark.',
  'kycCard.info.alt': 'Notification Icon',
  'withdrawalOutage.title': 'Planned system upgrade',
  'withdrawalOutage.message':
    'We’re upgrading our withdrawal system, so the service will be unavailable during this time. Please return on September 26 to make your withdrawal.',
  'withdrawalOutage.alt': 'Withdrawal Outage Icon',
  'withdrawalOutage.footer.descriptionOne':
    'If your request is urgent, please call us at ',
  'withdrawalOutage.footer.descriptionPhone': '1-800-363-7377',
  'withdrawalOutage.footer.descriptionTwo':
    '. Please note we are experiencing longer wait times than usual, so there may be delays in reaching a representative.',
  'costOfSchoolEntry.largeCircle.alt': 'large circle icon',
  'costOfSchoolEntry.smallCircle.alt': 'small circle icon',
  'costOfSchoolEntry.diamond.alt': 'diamond icon',
  'costOfSchoolEntry.mainImg.alt': 'calculation icon',
  'costOfSchoolEntry.headline.text1':
    'Let’s find out how much school will cost for ',
  'costOfSchoolEntry.headline.text2': 'your child',
  'costOfSchoolEntry.content':
    'Learn more about tuition costs and other educational expenses that come along with it.',
  'costOfSchool.start': 'Start',
  'costOfSchool.createdBy': 'Created by ',
  'onboardingRiskProfile.description.conservative':
    'You are risk averse and prefer to focus on protecting your savings than investment growth.',
  'onboardingRiskProfile.description.moderate':
    'You would like to balance the growth of your investments and the protection of your savings. You’re willing to take on more risk than conservative plans to achieve more returns.',
  'onboardingRiskProfile.description.balanced':
    'You are willing to accept a medium level of risk. You want to see growth in your investments over the long term, but you understand you may experience some losses during a market downturn.',
  'onboardingRiskProfile.description.grow':
    'You’d like to aim for the high returns over the long term, and as a result you’re willing to accept a larger potential for losses in the short term during a market downturn.',
  'onboardingRiskProfile.description.aggressive':
    'You’d like to aim for the highest returns over the long term, and as a result, you’re willing to accept a significant potential for losses in the short term during a market downturn.',
  'termsConditions.investmentDecision':
    'I acknowledge that I (or my joint-account holder) am responsible for the investment decision on this account, and a third party is not instructing my account actions.',
  'portfolioDetails.goToButton': 'Portfolio details',
  'portfolioBalancesDetails.cesg': 'Canada Education Savings Grant (CESG)',
  'portfolioBalancesDetails.clb': 'Canada Learning Bond (CLB)',
  'portfolioBalancesDetails.bctesg':
    'British Columbia Training & Education Savings Grant (BCTESG)',
  'portfolioBalancesDetails.qesi': 'Quebec Education Savings Incentive (QESI)',
  'portfolioBalancesDetails.grants': 'Government grants',
  'portfolioBalancesDetails.contributions': 'Contributions',
  'portfolioBalancesDetails.income': 'Income',
  'portfolioDetails.headline': 'Portfolio details',
  'portfolioDetails.titleContent': 'Total savings',
  'portfolioDetails.incomeInfoPopupTitle': 'Income',
  'portfolioDetails.incomeInfoPopup':
    'Income is the money earned through the investment of your Contributions and Government grants, including dividends and interest that is reinvested. This value will fluctuate with the market value of your Plan (the dollar value of what the plan would fetch on a financial market at a specific point in time).',
  'portfolioDetails.chartContributions': 'Contributions',
  'portfolioDetails.chartGrants': 'Grants',
  'portfolioDetails.chartIncome': 'Income',
  whyDoWeAskThis: 'Why do we ask this?',
  'onboarding.IDVGateway.label': 'Identity verification',
  'onboarding.IDVGateway.headline': 'Prepare your ID and SIN',
  'onboarding.IDVGateway.documents.head':
    'Have one of the following documents ready for ID verification:',
  'onboarding.IDVGateway.documents.DriverLicense': 'Driver’s license',
  'onboarding.IDVGateway.documents.Passport': 'Passport',
  'onboarding.IDVGateway.documents.PRCard': 'Permanent resident card',
  'onboarding.IDVGateway.SIN.head': 'You’ll need the following documents:',
  'onboarding.IDVGateway.SIN.yourSIN': 'Your Social Insurance Number (SIN)',
  'onboarding.IDVGateway.SIN.yourChildSIN':
    'Your child’s SIN as per CRA requirements',
  'onboarding.IDVGateway.Note':
    'Don’t have everything on hand? We’ll make sure to save your progress.',
  'onboarding.investmentProfile': 'Investment profile',
  'setReminder.title': 'Set a reminder',
  'setReminder.body':
    "If you don't have all the details at the moment, no problem. You can set a reminder and complete the application later.",
  'setReminder.imgAlt': 'Reminder',
  'setReminder.CTA': 'Set a reminder',
  'cosubscriberRelationship.cantContinue.header':
    'Sorry, you can’t be a joint-account holder',
  'cosubscriberRelationship.cantContinue.description1':
    'Joint-account holder should be spouses or common-law partners.',
  'cosubscriberRelationship.cantContinue.description2':
    'Explore our plans and open your own RESP account today!',
  'cosubscriberRelationship.cantContinue.goToDashboard': 'Go to dashboard',
  'reviewSection.reviewAlert':
    'Please review and complete your investment profile to ensure all details are filled out.',
  'profile.KYC.header.quickReview': 'Let’s do a quick review',
  'profile.KYC.body':
    'Before you continue, we need to confirm personal and financial information. Changes to investment or risk profiles may require a plan reassessment.',
  'setAReminder.header': 'Set a reminder',
  'setAReminder.setReminderBody':
    "We'll send you an email to come back when you have all your child's details.",
  'setAReminder.editReminderBody':
    "You've set a reminder. You can edit or cancel the reminder at any time.",
  'setAReminder.CTA': 'Set reminder',
  'setAReminder.apply': 'Apply',
  'setAReminder.cancelReminder': 'Cancel reminder',
  'setAReminder.cancelConfirmDialog.title':
    'Are you sure you want to cancel your reminder?',
  'setAReminder.cancelConfirmDialog.confirmLabel': 'No, stay',
  'setAReminder.cancelConfirmDialog.cancelLabel': 'Yes, cancel',
  oneWeekReminder: '1 week',
  twoWeeksReminder: '2 weeks',
  customReminder: 'Custom',
  'setAReminder.popup.header': 'A reminder has been set',
  'setAReminder.popup.body': 'Would you like to edit it?',
  'setAReminder.popup.yesEdit': 'Yes, edit',
  'setAReminder.popup.noCancel': 'No, cancel',
  'withdrawalGateway.stepperHeader': 'Withdraw money',
  'withdrawalGateway.headline': 'It’s time for school!',
  'withdrawalGateway.description':
    'Congratulations on your child’s post-secondary enrolment. Let’s withdraw your savings for tuition, boarding, books, supplies, transportation, and other essentials.',
  'withdrawalGateway.footerText.firstPart':
    'Withdrawing for non-educational or personal expenses? Make an',
  'withdrawalGateway.footerText.link': 'Accumulated Income Payments (AIP)',
  'withdrawalGateway.footerText.secondPart': 'withdrawal.',
  'withdrawalGateway.img.alt': 'Info Icon',
  'withdrawalGateway.popup.header':
    'What’s an Accumulated Income Payment (AIP)?',
  'withdrawalGateway.popup.description.sectionOne':
    'An AIP lets you take out the income earned in your RESP if your child isn’t, and doesn’t plan to be enrolled in a post-secondary program before the RESP expires. It’s an option if they’re not attending a designated school and you’d like to access the income portion of your RESP.',
  'withdrawalGateway.popup.description.sectionTwo.one':
    'Before you request an AIP, you might want to consider ',
  'withdrawalGateway.popup.description.sectionTwo.two':
    ' if someone else in your family plans to continue their education.',
  'withdrawalGateway.popup.description.sectionTwo.link':
    'replacing your child(ren)',
  'withdrawalGateway.popup.description.sectionTwo.linkURL':
    'https://www.embark.ca/making-withdrawals',
  'withdrawalGateway.popup.description.sectionThree':
    'AIP withdrawals are taxed at your regular rate, plus an extra 20% federal tax. If you transfer the AIP to an RRSP, you’ll get a tax slip from both Embark and your RRSP provider. The tax slip from your RRSP provider will override the one from Embark. For personalized advice, it’s best to speak with a tax professional.',
  'transferIn.tAndC.stepperHeader': 'Transfer an RESP to Embark',
  'transferIn.details.stepperHeader': 'Transfer details',
  'transferIn.estimatedAmount.stepperHeader': 'Estimated amount',
  'transferIn.planSelect.stepperHeader': 'Embark plan',
  'transferIn.planSelect.stepperHeader.addPlan': 'Create a plan',
  'transferIn.review.stepperHeader': 'Review',
  'transferIn.tAndC.headline':
    'Here are some important things to know before initiating the transfer:',
  'transferIn.details.headline': 'Where are you transferring from?',
  'transferIn.details.description':
    'Please ensure that the children selected for your chosen plan match the children listed under your current RESP holder. Check your account statement to confirm the details.',
  'transferIn.planSelect.description.addPlan.partOne':
    'It looks like you don’t have an RESP plan.',
  'transferIn.planSelect.description.addPlan.partTwo':
    'To transfer your existin’g RESP from another provider, you’ll need to open an Embark RESP first. It only takes a few minutes, and we’ll guide you through every step.',
  'transferIn.details.institute.label': 'Financial institution',
  'transferIn.details.instituteRequiredError':
    'Select a financial institution.',
  'transferIn.details.financialInstitution.label': 'Financial institution name',
  'transferIn.details.institutionNameRequiredError':
    'Enter a financial institution.',
  'transferIn.details.planNumber.label': 'Plan number',
  'transferIn.details.planNumbarRequiredError': 'Enter a plan number.',
  'transferIn.details.institutionNameCharError':
    'Forms do not accept accented characters in the input fields.',
  'transferIn.details.planNumberLengthError': '40 characters or less',
  'transferIn.details.planNumberCharError': 'Invalid plan number.',
  'transferIn.details.addressField.header': 'Financial institution address',
  'transferIn.details.addressField.placeholder': 'Start typing your address',
  'transferIn.details.representative.title': 'Representative ',
  'transferIn.details.representative.title.optional': '(optional)',
  'transferIn.details.representative.description':
    'Provide the contact information for your plan representative or advisor if you have one at your current institution.',
  'transferIn.details.representative.name': 'Contact name',
  'transferIn.details.representative.contactNumber': 'Contact number',
  'transferIn.details.representative.email': 'Email',
  'transferIn.details.representative.emailError':
    'Enter a registered email address.',
  'transferIn.tAndC.helper.text1':
    'We will cover your transfer-in fees up to $150 for each plan you bring over. This offer is subject to the',
  'transferIn.tAndC.helper.text1.linkText': 'Terms & Conditions',
  'transferIn.tAndC.helper.text1.link':
    'https://www.embark.ca/balance-offer-terms-and-conditions',
  'transferIn.tAndC.helper.text2':
    'The children on your plan at your current financial institution must match those on your Embark RESP. If your plan has a co-subscriber, they must also be present to sign.',
  'transferIn.tAndC.helper.text3':
    'As per Canada Revenue Agency (CRA) requirements, RESPs can stay open for up to 35 years from when they were first opened. If you’re transferring from another provider, the original start date of your first plan will now apply to all money in your new plan.',
  'transferIn.tAndC.helper.text4':
    'Depending on your current financial institution, it can take 60–90 days, or more, to transfer your assets here.',
  'transferIn.estimatedAmount.headline': 'How much are you transferring?',
  'transferIn.estimatedAmount.text':
    'This helps us confirm the amount when it arrives and follow up if something doesn’t look right.',
  'transferIn.estimatedAmount.infoText':
    'We’ll cover your bank’s transfer-out fee when you bring over $5,000 or more.',
  'transferIn.estimatedAmount.tAndCLink': 'Terms and conditions',
  'transferIn.estimatedAmount.tAndCLink.URL':
    'https://www.embark.ca/balance-offer-terms-and-conditions',
  'transferIn.instructions.headline': 'Follow the steps below:',
  'transferIn.instructions.list.header':
    'Follow the steps below to complete your transfer:',
  'transferIn.instructions.list.item1': 'Download the transfer form.',
  'transferIn.instructions.list.item2':
    'Review your details and print the form.',
  'transferIn.instructions.list.item3':
    'Sign it by hand — your current institution requires a physical signature.',
  'transferIn.instructions.list.item4': 'Scan the signed form and email it to ',
  'transferIn.instructions.list.item4.email': 'contact@embark.ca.',
  'transferIn.instructions.list.hasSignature.item2':
    'Review your details and sign the document.',
  'transferIn.instructions.list.hasSignature.item3':
    'Save the signed form and email it to ',
  'transferIn.instructions.content':
    'You can always find the form in the Documents section of your account profile.',
  'transferIn.instructions.icon.alt': 'Trandfer in info Icon',
  'transferIn.instructions.infoText.note': 'Note: ',
  'transferIn.instructions.infoText':
    "Transfers typically take 60–90 days to finalize. We'll keep you updated throughout the process",
  'transferIn.downlaodForm.img.alt': 'Download form Icon',
  'transferIn.downlaodForm.headline':
    'Download the form and continue to next steps',
  'transferIn.downlaodForm.description':
    'Once you’ve completed and returned the form, transfers typically take 60–90 days to process.',
  'transferIn.downlaodForm.cta.text': 'Download and continue',
  'transferIn.planSelect.headline':
    'Which Embark plan are you transferring to?',
  'transferIn.planSelect.description':
    'The children listed on your current RESP must match those on the new RESP. If not, please open a new plan.',
  'transferIn.planSelect.addPlan.linkText': 'Add a plan',
  'transferIn.review.headline': 'Transfer details',
  'transferIn.review.headline.img.alt': 'Transfer details Icon',
  'transferIn.review.planselection.lable':
    'Which Embark plan are you transferring to?',
  'transferIn.review.details.lable': 'Where are you transferring from?',
  'transferIn.review.address.lable': 'Financial institution address',
  'transferIn.review.representative.lable': 'Representative information',
  'transferIn.review.estimatedAmount.lable': 'Estimated amount',
  'transferIn.transferInStatus.title': 'RESP Transfer',
  'transferIn.transferInStatus.stepperIcon.alt': 'Stepper Icon',
  'transferIn.transferInStatus.stepper.underReview': 'Under review',
  'transferIn.transferInStatus.stepper.cancelled': 'Cancelled',
  'transferIn.transferInStatus.stepper.attentionRequired': 'Attention required',
  'transferIn.transferInStatus.stepper.actionRequired': 'Action required',
  'transferIn.transferInStatus.stepper.complete': 'Complete',
  'transferIn.transferInStatus.stepper.inProgress': 'In progress',
  'transferIn.transferInStatus.stepper.requestCancelled': 'Request cancelled',
  'transferIn.transferInStatus.transferInDetails.header': 'Details',
  'transferIn.transferInStatus.transferInDetails.amount': 'Estimated amount',
  'transferIn.transferInStatus.transferInDetails.planTo':
    'Which Embark plan are you transferring to?',
  'transferIn.transferInStatus.transferInDetails.institution':
    'Financial institution',
  'transferIn.transferInStatus.transferInDetails.planFrom': 'Plan number',
  'transferIn.transferInStatus.transferInDetails.address': 'Address',
  'transferIn.transferInStatus.transferInDetails.download': 'Download',
  'transferIn.transferInStatus.transferInDetails.representative':
    'Representative information',
  'transferIn.transferInStatus.transferInDetails.eSign.header':
    'Signature required',
  'transferIn.transferInStatus.transferInDetails.physicalSign.header':
    'Physical signature required',
  'transferIn.transferInStatus.transferInDetails.eSign.details':
    'We have not received your signed transfer form. Please review, sign and return the attached form to ',
  'transferIn.transferInStatus.transferInDetails.physicalSign.details':
    'Your current institution requires you to sign this document by hand. Please review, print, sign, and return the attached form to ',
  'transferIn.transferInStatus.transferInDetails.inProgress.details':
    "Transfers typically take 60–90 days to finalize. We'll keep you updated throughout the process.",
  'newDashboard.selectPlan.header': 'Which RESP plan fits you best?',
  'newDashboard.selectPlan.subheader':
    "At Embark, we make it easy to save for your child's education, whether for one child or several.",
  'newDashboard.selectPlan.family.header': 'Family plan',
  'newDashboard.selectPlan.family.subheader1': 'Shared savings',
  'newDashboard.selectPlan.family.body1':
    'Your children can share contributions, grants and income. Up to a maximum of $7,200 of Canada Education Savings Grant (CESG).',
  'newDashboard.selectPlan.family.subheader2': 'For parents or grandparents',
  'newDashboard.selectPlan.family.body2':
    'Ideal for parents or grandparents saving for their children or grandchildren (children in the plan must be siblings related by blood or adoption).',
  'newDashboard.selectPlan.family.subheader3': 'Easily add siblings',
  'newDashboard.selectPlan.family.body3':
    'Add or change siblings as your family grows.',
  'newDashboard.selectPlan.cta': 'Get started',
  'newDashboard.selectPlan.individual.header': 'Individual plan',
  'newDashboard.selectPlan.individual.subheader1': 'Top feature:',
  'newDashboard.selectPlan.individual.body1':
    'You do not need to be directly related to the child.',
  'newDashboard.selectPlan.individual.body2':
    'Ideal for aunts, uncles, or other non-relatives.',
  'newDashboard.selectPlan.list.header': 'All plans include:',
  'newDashboard.selectPlan.list.item1': 'No upfront fees or hidden costs',
  'newDashboard.selectPlan.list.item2': 'Highly competitive management fees',
  'newDashboard.selectPlan.list.item3':
    'Customized asset allocation based on the age of each child',
  'newDashboard.selectPlan.list.item4':
    'Access to all applicable government grants up to $7,200*',
  'newDashboard.selectPlan.list.item5':
    'Trusted partners that hold and manage all your funds',
  'aipFormsLabels.ipAddress': 'IP Address',
  'expectingDueDate.title': 'Set a due date',
  'expectingDueDate.body.p1':
    'Your RESP is in progress! When your little one arrives (hi, future scholar), just bring their SIN, and we’ll kickstart their savings with a ',
  'expectingDueDate.body.p2': ' bonus.',
  'expectingDueDate.body.p3':
    ' Add your due date, and we’ll give you a friendly reminder at the right time.',
  'expectingDueDate.fieldsLabel': 'Due date',
  'expectingDueDate.primaryCta': 'Set due date',
  'expectingDueDate.secondaryCta': 'Explore your dashboard',
  'expectingDueDate.alert.p1': 'Due date saved: ',
  'expectingDueDate.alert.p2': ' You can update this anytime.',
  'expectingDueDate.monthError': 'Enter a month',
  'expectingDueDate.yearError': 'Enter a year',
  whatsYourSourceOfIncome: "What's your source of income?",
  sourceOfIncome: 'Source of income',
  canadaChildBenefit: 'Canada Child Benefit (CCB)',
  savings: 'Savings',
  socialAssistanceAllowance: 'Social assistance/allowance',
  maternityPaternityLeave: 'Maternity/paternity leave',
  familySupport: 'Family support',
  otherPleaseDescribe: 'Other (please describe)',
  pleaseEnterYourSourceOfIncome: 'Please enter your source of Income.',
  sourceOfIncomeMaxLength:
    'Source of income has a size limitation of 30 characters',
  onlyAlphanumericIsAllowed: 'Only alphanumeric is allowed',
  'settings.profile.address': 'Address:',
  electronicDeliveryTaxDocuments: 'Electronic delivery of tax documents',
  investmentProfile: 'Investment profile'
};
